!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react"), require("draft-js"), require("immutable")) : "function" == typeof define && define.amd ? define(["react", "draft-js", "immutable"], t) : "object" == typeof exports ? exports.reactDraftWysiwyg = t(require("react"), require("draft-js"), require("immutable")) : e.reactDraftWysiwyg = t(e.react, e["draft-js"], e.immutable);
}("undefined" != typeof self ? self : this, function (e, t, n) {
  return function (e) {
    function t(o) {
      if (n[o]) return n[o].exports;
      var r = n[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return e[o].call(r.exports, r, r.exports, t), r.l = !0, r.exports;
    }

    var n = {};
    return t.m = e, t.c = n, t.d = function (e, n, o) {
      t.o(e, n) || Object.defineProperty(e, n, {
        configurable: !1,
        enumerable: !0,
        get: o
      });
    }, t.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(n, "a", n), n;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = "", t(t.s = 13);
  }([function (t, n) {
    t.exports = e;
  }, function (e, t, n) {
    "use strict";

    "function" == typeof Symbol && Symbol.iterator;
    e.exports = n(16)();
  }, function (e, t, n) {
    "use strict";

    var o,
        r,
        i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    };
    /*!
    Copyright (c) 2016 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
    */

    !function () {
      function a() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          var n = arguments[t];

          if (n) {
            var o = void 0 === n ? "undefined" : i(n);
            if ("string" === o || "number" === o) e.push(n);else if (Array.isArray(n)) e.push(a.apply(null, n));else if ("object" === o) for (var r in n) {
              l.call(n, r) && n[r] && e.push(r);
            }
          }
        }

        return e.join(" ");
      }

      var l = {}.hasOwnProperty;
      void 0 !== e && e.exports ? e.exports = a : "object" === i(n(10)) && n(10) ? (o = [], void 0 !== (r = function () {
        return a;
      }.apply(t, o)) && (e.exports = r)) : window.classNames = a;
    }();
  }, function (e, n) {
    e.exports = t;
  }, function (e, t, n) {
    !function (t, o) {
      e.exports = o(n(3), n(9));
    }("undefined" != typeof self && self, function (e, t) {
      return function (e) {
        function t(o) {
          if (n[o]) return n[o].exports;
          var r = n[o] = {
            i: o,
            l: !1,
            exports: {}
          };
          return e[o].call(r.exports, r, r.exports, t), r.l = !0, r.exports;
        }

        var n = {};
        return t.m = e, t.c = n, t.d = function (e, n, o) {
          t.o(e, n) || Object.defineProperty(e, n, {
            configurable: !1,
            enumerable: !0,
            get: o
          });
        }, t.n = function (e) {
          var n = e && e.__esModule ? function () {
            return e.default;
          } : function () {
            return e;
          };
          return t.d(n, "a", n), n;
        }, t.o = function (e, t) {
          return Object.prototype.hasOwnProperty.call(e, t);
        }, t.p = "", t(t.s = 3);
      }([function (t, n) {
        t.exports = e;
      }, function (e, t, n) {
        "use strict";

        function o(e) {
          var t = e.getSelection(),
              n = e.getCurrentContent(),
              o = t.getStartKey(),
              r = t.getEndKey(),
              i = n.getBlockMap();
          return i.toSeq().skipUntil(function (e, t) {
            return t === o;
          }).takeUntil(function (e, t) {
            return t === r;
          }).concat([[r, i.get(r)]]);
        }

        function r(e) {
          return o(e).toList();
        }

        function i(e) {
          if (e) return r(e).get(0);
        }

        function a(e) {
          if (e) {
            var t = i(e),
                n = e.getCurrentContent(),
                o = n.getBlockMap().toSeq().toList(),
                r = 0;
            if (o.forEach(function (e, n) {
              e.get("key") === t.get("key") && (r = n - 1);
            }), r > -1) return o.get(r);
          }
        }

        function l(e) {
          return e ? e.getCurrentContent().getBlockMap().toList() : new h.List();
        }

        function c(e) {
          var t = r(e);
          if (!t.some(function (e) {
            return e.type !== t.get(0).type;
          })) return t.get(0).type;
        }

        function s(e) {
          var t = y.RichUtils.tryToRemoveBlockStyle(e);
          return t ? y.EditorState.push(e, t, "change-block-type") : e;
        }

        function u(e) {
          var t = "",
              n = e.getSelection(),
              o = n.getAnchorOffset(),
              i = n.getFocusOffset(),
              a = r(e);

          if (a.size > 0) {
            if (n.getIsBackward()) {
              var l = o;
              o = i, i = l;
            }

            for (var c = 0; c < a.size; c += 1) {
              var s = 0 === c ? o : 0,
                  u = c === a.size - 1 ? i : a.get(c).getText().length;
              t += a.get(c).getText().slice(s, u);
            }
          }

          return t;
        }

        function d(e) {
          var t = e.getCurrentContent(),
              n = e.getSelection(),
              o = y.Modifier.removeRange(t, n, "forward"),
              r = o.getSelectionAfter(),
              i = o.getBlockForKey(r.getStartKey());
          return o = y.Modifier.insertText(o, r, "\n", i.getInlineStyleAt(r.getStartOffset()), null), y.EditorState.push(e, o, "insert-fragment");
        }

        function p(e) {
          var t = y.Modifier.splitBlock(e.getCurrentContent(), e.getSelection());
          return s(y.EditorState.push(e, t, "split-block"));
        }

        function f(e) {
          var t = e.getCurrentContent().getBlockMap().toList(),
              n = e.getSelection().merge({
            anchorKey: t.first().get("key"),
            anchorOffset: 0,
            focusKey: t.last().get("key"),
            focusOffset: t.last().getLength()
          }),
              o = y.Modifier.removeRange(e.getCurrentContent(), n, "forward");
          return y.EditorState.push(e, o, "remove-range");
        }

        function m(e, t) {
          var n = y.Modifier.setBlockData(e.getCurrentContent(), e.getSelection(), t);
          return y.EditorState.push(e, n, "change-block-data");
        }

        function g(e) {
          var t = new h.Map({}),
              n = r(e);
          if (n && n.size > 0) for (var o = 0; o < n.size; o += 1) {
            var i = function (e) {
              var o = n.get(e).getData();
              if (!o || 0 === o.size) return t = t.clear(), "break";
              if (0 === e) t = o;else if (t.forEach(function (e, n) {
                o.get(n) && o.get(n) === e || (t = t.delete(n));
              }), 0 === t.size) return t = t.clear(), "break";
            }(o);

            if ("break" === i) break;
          }
          return t;
        }

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.blockRenderMap = void 0, t.getSelectedBlocksMap = o, t.getSelectedBlocksList = r, t.getSelectedBlock = i, t.getBlockBeforeSelectedBlock = a, t.getAllBlocks = l, t.getSelectedBlocksType = c, t.removeSelectedBlocksStyle = s, t.getSelectionText = u, t.addLineBreakRemovingSelection = d, t.insertNewUnstyledBlock = p, t.clearEditorContent = f, t.setBlockData = m, t.getSelectedBlocksMetadata = g;
        var y = n(0),
            h = n(6),
            M = (0, h.Map)({
          code: {
            element: "pre"
          }
        });
        t.blockRenderMap = y.DefaultDraftBlockRenderMap.merge(M);
      }, function (e, t, n) {
        "use strict";

        function o(e) {
          if (e) {
            var t = e.getType();
            return "unordered-list-item" === t || "ordered-list-item" === t;
          }

          return !1;
        }

        function r(e, t, n) {
          var o = e.getSelection(),
              r = e.getCurrentContent(),
              i = r.getBlockMap(),
              a = (0, l.getSelectedBlocksMap)(e).map(function (e) {
            var o = e.getDepth() + t;
            return o = Math.max(0, Math.min(o, n)), e.set("depth", o);
          });
          return i = i.merge(a), r.merge({
            blockMap: i,
            selectionBefore: o,
            selectionAfter: o
          });
        }

        function i(e, t, n) {
          var o = e.getSelection(),
              i = void 0;
          i = o.getIsBackward() ? o.getFocusKey() : o.getAnchorKey();
          var l = e.getCurrentContent(),
              c = l.getBlockForKey(i),
              s = c.getType();
          if ("unordered-list-item" !== s && "ordered-list-item" !== s) return e;
          var u = l.getBlockBefore(i);
          if (!u) return e;
          if (u.getType() !== s) return e;
          var d = c.getDepth();
          if (1 === t && d === n) return e;
          var p = Math.min(u.getDepth() + 1, n),
              f = r(e, t, p);
          return a.EditorState.push(e, f, "adjust-depth");
        }

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.isListBlock = o, t.changeDepth = i;
        var a = n(0),
            l = n(1);
      }, function (e, t, n) {
        e.exports = n(4);
      }, function (e, t, n) {
        "use strict";

        var o = n(5),
            r = n(1),
            i = n(7),
            a = function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }(i),
            l = n(2);

        e.exports = {
          getSelectedBlocksMap: r.getSelectedBlocksMap,
          getSelectedBlocksList: r.getSelectedBlocksList,
          getSelectedBlock: r.getSelectedBlock,
          getBlockBeforeSelectedBlock: r.getBlockBeforeSelectedBlock,
          getAllBlocks: r.getAllBlocks,
          getSelectedBlocksType: r.getSelectedBlocksType,
          removeSelectedBlocksStyle: r.removeSelectedBlocksStyle,
          getSelectionText: r.getSelectionText,
          addLineBreakRemovingSelection: r.addLineBreakRemovingSelection,
          insertNewUnstyledBlock: r.insertNewUnstyledBlock,
          clearEditorContent: r.clearEditorContent,
          setBlockData: r.setBlockData,
          getSelectedBlocksMetadata: r.getSelectedBlocksMetadata,
          blockRenderMap: r.blockRenderMap,
          getEntityRange: o.getEntityRange,
          getCustomStyleMap: o.getCustomStyleMap,
          toggleCustomInlineStyle: o.toggleCustomInlineStyle,
          getSelectionEntity: o.getSelectionEntity,
          extractInlineStyle: o.extractInlineStyle,
          removeAllInlineStyles: o.removeAllInlineStyles,
          getSelectionInlineStyle: o.getSelectionInlineStyle,
          getSelectionCustomInlineStyle: o.getSelectionCustomInlineStyle,
          handleNewLine: a.default,
          isListBlock: l.isListBlock,
          changeDepth: l.changeDepth
        };
      }, function (e, t, n) {
        "use strict";

        function o(e, t, n) {
          return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = n, e;
        }

        function r(e) {
          var t = e.getSelection();

          if (t.isCollapsed()) {
            var n = {},
                o = e.getCurrentInlineStyle().toList().toJS();
            if (o) return ["BOLD", "ITALIC", "UNDERLINE", "STRIKETHROUGH", "CODE", "SUPERSCRIPT", "SUBSCRIPT"].forEach(function (e) {
              n[e] = o.indexOf(e) >= 0;
            }), n;
          }

          var r = t.getStartOffset(),
              i = t.getEndOffset(),
              a = (0, y.getSelectedBlocksList)(e);

          if (a.size > 0) {
            var l = function () {
              for (var e = {
                BOLD: !0,
                ITALIC: !0,
                UNDERLINE: !0,
                STRIKETHROUGH: !0,
                CODE: !0,
                SUPERSCRIPT: !0,
                SUBSCRIPT: !0
              }, t = 0; t < a.size; t += 1) {
                var n = 0 === t ? r : 0,
                    o = t === a.size - 1 ? i : a.get(t).getText().length;
                n === o && 0 === n ? (n = 1, o = 2) : n === o && (n -= 1);

                for (var l = n; l < o; l += 1) {
                  !function (n) {
                    var o = a.get(t).getInlineStyleAt(n);
                    ["BOLD", "ITALIC", "UNDERLINE", "STRIKETHROUGH", "CODE", "SUPERSCRIPT", "SUBSCRIPT"].forEach(function (t) {
                      e[t] = e[t] && o.get(t) === t;
                    });
                  }(l);
                }
              }

              return {
                v: e
              };
            }();

            if ("object" === (void 0 === l ? "undefined" : m(l))) return l.v;
          }

          return {};
        }

        function i(e) {
          var t = void 0,
              n = e.getSelection(),
              o = n.getStartOffset(),
              r = n.getEndOffset();
          o === r && 0 === o ? r = 1 : o === r && (o -= 1);

          for (var i = (0, y.getSelectedBlock)(e), a = o; a < r; a += 1) {
            var l = i.getEntityAt(a);

            if (!l) {
              t = void 0;
              break;
            }

            if (a === o) t = l;else if (t !== l) {
              t = void 0;
              break;
            }
          }

          return t;
        }

        function a(e, t) {
          var n = (0, y.getSelectedBlock)(e),
              o = void 0;
          return n.findEntityRanges(function (e) {
            return e.get("entity") === t;
          }, function (e, t) {
            o = {
              start: e,
              end: t,
              text: n.get("text").slice(e, t)
            };
          }), o;
        }

        function l(e, t, n) {
          var o = e.getSelection(),
              r = Object.keys(h[t]).reduce(function (e, t) {
            return g.Modifier.removeInlineStyle(e, o, t);
          }, e.getCurrentContent()),
              i = g.EditorState.push(e, r, "changeinline-style"),
              a = e.getCurrentInlineStyle();
          if (o.isCollapsed() && (i = a.reduce(function (e, t) {
            return g.RichUtils.toggleInlineStyle(e, t);
          }, i)), "SUPERSCRIPT" === t || "SUBSCRIPT" == t) a.has(n) || (i = g.RichUtils.toggleInlineStyle(i, n));else {
            var l = "bgcolor" === t ? "backgroundColor" : t;
            a.has(l + "-" + n) || (i = g.RichUtils.toggleInlineStyle(i, t.toLowerCase() + "-" + n), M(t, l, n));
          }
          return i;
        }

        function c(e) {
          e && e.getCurrentContent().getBlockMap().map(function (e) {
            return e.get("characterList");
          }).toList().flatten().forEach(function (e) {
            e && 0 === e.indexOf("color-") ? M("color", "color", e.substr(6)) : e && 0 === e.indexOf("bgcolor-") ? M("bgcolor", "backgroundColor", e.substr(8)) : e && 0 === e.indexOf("fontsize-") ? M("fontSize", "fontSize", +e.substr(9)) : e && 0 === e.indexOf("fontfamily-") && M("fontFamily", "fontFamily", e.substr(11));
          });
        }

        function s(e, t, n) {
          var o = e.getInlineStyleAt(n).toList(),
              r = o.filter(function (e) {
            return e.startsWith(t.toLowerCase());
          });
          if (r && r.size > 0) return r.get(0);
        }

        function u(e, t) {
          var n = e.getCurrentInlineStyle().toList(),
              o = n.filter(function (e) {
            return e.startsWith(t.toLowerCase());
          });
          if (o && o.size > 0) return o.get(0);
        }

        function d(e, t) {
          if (e && t && t.length > 0) {
            var n = function () {
              var n = e.getSelection(),
                  o = {};
              if (n.isCollapsed()) return t.forEach(function (t) {
                o[t] = u(e, t);
              }), {
                v: o
              };
              var r = n.getStartOffset(),
                  i = n.getEndOffset(),
                  a = (0, y.getSelectedBlocksList)(e);

              if (a.size > 0) {
                for (var l = 0; l < a.size; l += 1) {
                  !function (e) {
                    var n = 0 === e ? r : 0,
                        l = e === a.size - 1 ? i : a.get(e).getText().length;
                    n === l && 0 === n ? (n = 1, l = 2) : n === l && (n -= 1);

                    for (var c = n; c < l; c += 1) {
                      !function (r) {
                        r === n ? t.forEach(function (t) {
                          o[t] = s(a.get(e), t, r);
                        }) : t.forEach(function (t) {
                          o[t] && o[t] !== s(a.get(e), t, r) && (o[t] = void 0);
                        });
                      }(c);
                    }
                  }(l);
                }

                return {
                  v: o
                };
              }
            }();

            if ("object" === (void 0 === n ? "undefined" : m(n))) return n.v;
          }

          return {};
        }

        function p(e) {
          var t = e.getCurrentInlineStyle(),
              n = e.getCurrentContent();
          return t.forEach(function (t) {
            n = g.Modifier.removeInlineStyle(n, e.getSelection(), t);
          }), g.EditorState.push(e, n, "change-inline-style");
        }

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getCustomStyleMap = void 0;

        var f = Object.assign || function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = arguments[t];

            for (var o in n) {
              Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
            }
          }

          return e;
        },
            m = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        };

        t.getSelectionInlineStyle = r, t.getSelectionEntity = i, t.getEntityRange = a, t.toggleCustomInlineStyle = l, t.extractInlineStyle = c, t.getSelectionCustomInlineStyle = d, t.removeAllInlineStyles = p;

        var g = n(0),
            y = n(1),
            h = {
          color: {},
          bgcolor: {},
          fontSize: {},
          fontFamily: {},
          CODE: {
            fontFamily: "monospace",
            wordWrap: "break-word",
            background: "#f1f1f1",
            borderRadius: 3,
            padding: "1px 3px"
          },
          SUPERSCRIPT: {
            fontSize: 11,
            position: "relative",
            top: -8,
            display: "inline-flex"
          },
          SUBSCRIPT: {
            fontSize: 11,
            position: "relative",
            bottom: -8,
            display: "inline-flex"
          }
        },
            M = function M(e, t, n) {
          h[e][e.toLowerCase() + "-" + n] = o({}, "" + t, n);
        };

        t.getCustomStyleMap = function () {
          return f({}, h.color, h.bgcolor, h.fontSize, h.fontFamily, {
            CODE: h.CODE,
            SUPERSCRIPT: h.SUPERSCRIPT,
            SUBSCRIPT: h.SUBSCRIPT
          });
        };
      }, function (e, n) {
        e.exports = t;
      }, function (e, t, n) {
        "use strict";

        function o(e) {
          var t = e.getSelection();

          if (t.isCollapsed()) {
            var n = e.getCurrentContent(),
                o = t.getStartKey(),
                r = n.getBlockForKey(o);
            if (!(0, c.isListBlock)(r) && "unstyled" !== r.getType() && r.getLength() === t.getStartOffset()) return (0, l.insertNewUnstyledBlock)(e);

            if ((0, c.isListBlock)(r) && 0 === r.getLength()) {
              var i = r.getDepth();
              if (0 === i) return (0, l.removeSelectedBlocksStyle)(e);
              if (i > 0) return (0, c.changeDepth)(e, -1, i);
            }
          }
        }

        function r(e) {
          return 13 === e.which && (e.getModifierState("Shift") || e.getModifierState("Alt") || e.getModifierState("Control"));
        }

        function i(e, t) {
          return r(t) ? e.getSelection().isCollapsed() ? a.RichUtils.insertSoftNewline(e) : (0, l.addLineBreakRemovingSelection)(e) : o(e);
        }

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = i;
        var a = n(0),
            l = n(1),
            c = n(2);
      }]);
    });
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function r(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    function i(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function a(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function l(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var c = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }

      return function (t, n, o) {
        return n && e(t.prototype, n), o && e(t, o), t;
      };
    }(),
        s = n(0),
        u = o(s),
        d = n(1),
        p = o(d),
        f = n(2),
        m = o(f);

    n(29);

    var g = function (e) {
      function t() {
        var e, n, o, r;
        i(this, t);

        for (var l = arguments.length, c = Array(l), s = 0; s < l; s++) {
          c[s] = arguments[s];
        }

        return n = o = a(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(c))), o.onClick = function () {
          var e = o.props,
              t = e.disabled,
              n = e.onClick,
              r = e.value;
          t || n(r);
        }, r = n, a(o, r);
      }

      return l(t, e), c(t, [{
        key: "render",
        value: function value() {
          var e,
              t = this.props,
              n = t.children,
              o = t.className,
              i = t.activeClassName,
              a = t.active,
              l = t.disabled,
              c = t.title;
          return u.default.createElement("div", {
            className: (0, m.default)("rdw-option-wrapper", o, (e = {}, r(e, "rdw-option-active " + i, a), r(e, "rdw-option-disabled", l), e)),
            onClick: this.onClick,
            "aria-selected": a,
            title: c
          }, n);
        }
      }]), t;
    }(s.Component);

    g.propTypes = {
      onClick: p.default.func.isRequired,
      children: p.default.any,
      value: p.default.string,
      className: p.default.string,
      activeClassName: p.default.string,
      active: p.default.bool,
      disabled: p.default.bool,
      title: p.default.string
    }, g.defaultProps = {
      activeClassName: ""
    }, t.default = g;
  }, function (e, t, n) {
    "use strict";

    function o(e, t) {
      if (e) for (var n in e) {
        ({}).hasOwnProperty.call(e, n) && t(n, e[n]);
      }
    }

    function r(e, t) {
      var n = !1;
      if (e) for (var o in e) {
        if ({}.hasOwnProperty.call(e, o) && t === o) {
          n = !0;
          break;
        }
      }
      return n;
    }

    function i(e) {
      return !e || !e.trim();
    }

    function a(e) {
      return "[object Object]" === Object.prototype.toString.call(e);
    }

    function l(e, t) {
      var n = Object.keys(e).filter(function (e) {
        return t.indexOf(e) < 0;
      }),
          o = {};
      return n && n.length > 0 && n.forEach(function (t) {
        o[t] = e[t];
      }), o;
    }

    function c(e) {
      e.stopPropagation();
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.forEach = o, t.hasProperty = r, t.isEmptyString = i, t.isMap = a, t.filter = l, t.stopPropagation = c;
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var r = n(30),
        i = o(r),
        a = n(32),
        l = o(a);
    e.exports = {
      Dropdown: i.default,
      DropdownOption: l.default
    };
  }, function (e, t, n) {
    "use strict";

    var o = n(6),
        r = function r(e) {
      return e[e.options[0]].icon;
    },
        i = function e(t, n) {
      if (t && void 0 === n) return t;
      var r = {};
      return (0, o.forEach)(t, function (t, i) {
        (0, o.isMap)(i) ? r[t] = e(i, n[t]) : r[t] = void 0 !== n[t] ? n[t] : i;
      }), r;
    };

    e.exports = {
      getFirstIcon: r,
      mergeRecursive: i
    };
  }, function (e, t) {
    e.exports = n;
  }, function (e, t) {
    (function (t) {
      e.exports = t;
    }).call(t, {});
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = [];
    t.default = {
      onKeyDown: function onKeyDown(e) {
        o.forEach(function (t) {
          t(e);
        });
      },
      registerCallBack: function registerCallBack(e) {
        o.push(e);
      },
      deregisterCallBack: function deregisterCallBack(e) {
        o = o.filter(function (t) {
          return t !== e;
        });
      }
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = void 0;
    t.default = {
      open: function open() {
        o = !0;
      },
      close: function close() {
        o = !1;
      },
      isOpen: function isOpen() {
        return o;
      }
    };
  }, function (e, t, n) {
    e.exports = n(14);
  }, function (e, t, n) {
    "use strict";

    var o = n(15),
        r = function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }(o);

    e.exports = {
      Editor: r.default
    };
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function r(e) {
      if (Array.isArray(e)) {
        for (var t = 0, n = Array(e.length); t < e.length; t++) {
          n[t] = e[t];
        }

        return n;
      }

      return Array.from(e);
    }

    function i(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function a(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function l(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var c = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var o in n) {
          Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
        }
      }

      return e;
    },
        s = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }

      return function (t, n, o) {
        return n && e(t.prototype, n), o && e(t, o), t;
      };
    }(),
        u = n(0),
        d = o(u),
        p = n(1),
        f = o(p),
        m = n(3),
        g = n(4),
        y = n(2),
        h = o(y),
        M = n(20),
        b = o(M),
        j = n(21),
        w = o(j),
        k = n(11),
        N = o(k),
        C = n(12),
        E = o(C),
        L = n(22),
        D = o(L),
        S = n(8),
        v = n(6),
        x = n(23),
        I = n(26),
        A = o(I),
        T = n(79),
        O = o(T),
        _ = n(82),
        z = o(_),
        P = n(88),
        U = o(P),
        F = n(90),
        B = o(F),
        Y = n(94),
        R = o(Y),
        Q = n(120),
        H = o(Q);

    n(135), n(136);

    var Z = function (e) {
      function t(e) {
        i(this, t);
        var n = a(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
        W.call(n);
        var o = (0, S.mergeRecursive)(R.default, e.toolbar);
        n.state = {
          editorState: void 0,
          editorFocused: !1,
          toolbar: o
        };
        var r = e.wrapperId ? e.wrapperId : Math.floor(1e4 * Math.random());
        return n.wrapperId = "rdw-wrapper-" + r, n.modalHandler = new b.default(), n.focusHandler = new w.default(), n.blockRendererFn = (0, B.default)({
          isReadOnly: n.isReadOnly,
          isImageAlignmentEnabled: n.isImageAlignmentEnabled,
          getEditorState: n.getEditorState,
          onChange: n.onChange
        }, e.customBlockRenderFunc), n.editorProps = n.filterEditorProps(e), n.customStyleMap = n.getStyleMap(e), n;
      }

      return l(t, e), s(t, [{
        key: "componentWillMount",
        value: function value() {
          this.compositeDecorator = this.getCompositeDecorator();
          var e = this.createEditorState(this.compositeDecorator);
          (0, g.extractInlineStyle)(e), this.setState({
            editorState: e
          });
        }
      }, {
        key: "componentDidMount",
        value: function value() {
          this.modalHandler.init(this.wrapperId);
        }
      }, {
        key: "componentWillReceiveProps",
        value: function value(e) {
          var t = {};

          if (this.props.toolbar !== e.toolbar) {
            var n = (0, S.mergeRecursive)(R.default, e.toolbar);
            t.toolbar = n;
          }

          if ((0, v.hasProperty)(e, "editorState") && this.props.editorState !== e.editorState) e.editorState ? t.editorState = m.EditorState.set(e.editorState, {
            decorator: this.compositeDecorator
          }) : t.editorState = m.EditorState.createEmpty(this.compositeDecorator);else if ((0, v.hasProperty)(e, "contentState") && this.props.contentState !== e.contentState) if (e.contentState) {
            var o = this.changeEditorState(e.contentState);
            o && (t.editorState = o);
          } else t.editorState = m.EditorState.createEmpty(this.compositeDecorator);
          e.editorState === this.props.editorState && e.contentState === this.props.contentState || (0, g.extractInlineStyle)(t.editorState), this.setState(t), this.editorProps = this.filterEditorProps(e), this.customStyleMap = this.getStyleMap(e);
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.state,
              t = e.editorState,
              n = e.editorFocused,
              o = e.toolbar,
              r = this.props,
              i = r.locale,
              a = r.localization,
              l = a.locale,
              s = a.translations,
              u = r.toolbarCustomButtons,
              p = r.toolbarOnFocus,
              f = r.toolbarClassName,
              y = r.toolbarHidden,
              M = r.editorClassName,
              b = r.wrapperClassName,
              j = r.toolbarStyle,
              w = r.editorStyle,
              k = r.wrapperStyle,
              C = r.uploadCallback,
              E = r.ariaLabel,
              L = {
            modalHandler: this.modalHandler,
            editorState: t,
            onChange: this.onChange,
            translations: c({}, H.default[i || l], s)
          },
              S = n || this.focusHandler.isInputFocused() || !p;
          return d.default.createElement("div", {
            id: this.wrapperId,
            className: (0, h.default)(b, "rdw-editor-wrapper"),
            style: k,
            onClick: this.modalHandler.onEditorClick,
            onBlur: this.onWrapperBlur,
            "aria-label": "rdw-wrapper"
          }, !y && d.default.createElement("div", {
            className: (0, h.default)("rdw-editor-toolbar", f),
            style: c({
              visibility: S ? "visible" : "hidden"
            }, j),
            onMouseDown: this.preventDefault,
            "aria-label": "rdw-toolbar",
            "aria-hidden": (!n && p).toString(),
            onFocus: this.onToolbarFocus
          }, o.options.map(function (e, t) {
            var n = A.default[e],
                r = o[e];
            return "image" === e && C && (r.uploadCallback = C), d.default.createElement(n, c({
              key: t
            }, L, {
              config: r
            }));
          }), u && u.map(function (e, t) {
            return d.default.cloneElement(e, c({
              key: t
            }, L));
          })), d.default.createElement("div", {
            ref: this.setWrapperReference,
            className: (0, h.default)(M, "rdw-editor-main"),
            style: w,
            onClick: this.focusEditor,
            onFocus: this.onEditorFocus,
            onBlur: this.onEditorBlur,
            onKeyDown: N.default.onKeyDown,
            onMouseDown: this.onEditorMouseDown
          }, d.default.createElement(m.Editor, c({
            ref: this.setEditorReference,
            onTab: this.onTab,
            onUpArrow: this.onUpDownArrow,
            onDownArrow: this.onUpDownArrow,
            editorState: t,
            onChange: this.onChange,
            blockStyleFn: D.default,
            customStyleMap: this.getStyleMap(this.props),
            handleReturn: this.handleReturn,
            handlePastedText: this.handlePastedText,
            blockRendererFn: this.blockRendererFn,
            handleKeyCommand: this.handleKeyCommand,
            ariaLabel: E || "rdw-editor",
            blockRenderMap: g.blockRenderMap
          }, this.editorProps))));
        }
      }]), t;
    }(u.Component);

    Z.propTypes = {
      onChange: f.default.func,
      onEditorStateChange: f.default.func,
      onContentStateChange: f.default.func,
      initialContentState: f.default.object,
      defaultContentState: f.default.object,
      contentState: f.default.object,
      editorState: f.default.object,
      defaultEditorState: f.default.object,
      toolbarOnFocus: f.default.bool,
      spellCheck: f.default.bool,
      stripPastedStyles: f.default.bool,
      toolbar: f.default.object,
      toolbarCustomButtons: f.default.array,
      toolbarClassName: f.default.string,
      toolbarHidden: f.default.bool,
      locale: f.default.string,
      localization: f.default.object,
      editorClassName: f.default.string,
      wrapperClassName: f.default.string,
      toolbarStyle: f.default.object,
      editorStyle: f.default.object,
      wrapperStyle: f.default.object,
      uploadCallback: f.default.func,
      onFocus: f.default.func,
      onBlur: f.default.func,
      onTab: f.default.func,
      mention: f.default.object,
      hashtag: f.default.object,
      textAlignment: f.default.string,
      readOnly: f.default.bool,
      tabIndex: f.default.number,
      placeholder: f.default.string,
      ariaLabel: f.default.string,
      ariaOwneeID: f.default.string,
      ariaActiveDescendantID: f.default.string,
      ariaAutoComplete: f.default.string,
      ariaDescribedBy: f.default.string,
      ariaExpanded: f.default.string,
      ariaHasPopup: f.default.string,
      customBlockRenderFunc: f.default.func,
      wrapperId: f.default.number,
      customDecorators: f.default.array,
      editorRef: f.default.func
    }, Z.defaultProps = {
      toolbarOnFocus: !1,
      toolbarHidden: !1,
      stripPastedStyles: !1,
      localization: {
        locale: "en",
        translations: {}
      },
      customDecorators: []
    };

    var W = function W() {
      var e = this;
      this.onEditorBlur = function () {
        e.setState({
          editorFocused: !1
        });
      }, this.onEditorFocus = function (t) {
        var n = e.props.onFocus;
        e.setState({
          editorFocused: !0
        });
        var o = e.focusHandler.isEditorFocused();
        n && o && n(t);
      }, this.onEditorMouseDown = function () {
        e.focusHandler.onEditorMouseDown();
      }, this.onTab = function (t) {
        var n = e.props.onTab;

        if (!n || !n(t)) {
          var o = (0, g.changeDepth)(e.state.editorState, t.shiftKey ? -1 : 1, 4);
          o && o !== e.state.editorState && (e.onChange(o), t.preventDefault());
        }
      }, this.onUpDownArrow = function (e) {
        E.default.isOpen() && e.preventDefault();
      }, this.onToolbarFocus = function (t) {
        var n = e.props.onFocus;
        n && e.focusHandler.isToolbarFocused() && n(t);
      }, this.onWrapperBlur = function (t) {
        var n = e.props.onBlur;
        n && e.focusHandler.isEditorBlur(t) && n(t, e.getEditorState());
      }, this.onChange = function (t) {
        var n = e.props,
            o = n.readOnly,
            r = n.onEditorStateChange;
        o || "atomic" === (0, g.getSelectedBlocksType)(t) && t.getSelection().isCollapsed || (r && r(t, e.props.wrapperId), (0, v.hasProperty)(e.props, "editorState") ? e.afterChange(t) : e.setState({
          editorState: t
        }, e.afterChange(t)));
      }, this.setWrapperReference = function (t) {
        e.wrapper = t;
      }, this.setEditorReference = function (t) {
        e.props.editorRef && e.props.editorRef(t), e.editor = t;
      }, this.getCompositeDecorator = function () {
        var t = [].concat(r(e.props.customDecorators), [(0, O.default)({
          showOpenOptionOnHover: e.state.toolbar.link.showOpenOptionOnHover
        })]);
        return e.props.mention && t.push.apply(t, r((0, z.default)(c({}, e.props.mention, {
          onChange: e.onChange,
          getEditorState: e.getEditorState,
          getSuggestions: e.getSuggestions,
          getWrapperRef: e.getWrapperRef,
          modalHandler: e.modalHandler
        })))), e.props.hashtag && t.push((0, U.default)(e.props.hashtag)), new m.CompositeDecorator(t);
      }, this.getWrapperRef = function () {
        return e.wrapper;
      }, this.getEditorState = function () {
        return e.state.editorState;
      }, this.getSuggestions = function () {
        return e.props.mention && e.props.mention.suggestions;
      }, this.afterChange = function (t) {
        setTimeout(function () {
          var n = e.props,
              o = n.onChange,
              r = n.onContentStateChange;
          o && o((0, m.convertToRaw)(t.getCurrentContent())), r && r((0, m.convertToRaw)(t.getCurrentContent()));
        });
      }, this.isReadOnly = function () {
        return e.props.readOnly;
      }, this.isImageAlignmentEnabled = function () {
        return e.state.toolbar.image.alignmentEnabled;
      }, this.createEditorState = function (t) {
        var n = void 0;
        if ((0, v.hasProperty)(e.props, "editorState")) e.props.editorState && (n = m.EditorState.set(e.props.editorState, {
          decorator: t
        }));else if ((0, v.hasProperty)(e.props, "defaultEditorState")) e.props.defaultEditorState && (n = m.EditorState.set(e.props.defaultEditorState, {
          decorator: t
        }));else if ((0, v.hasProperty)(e.props, "contentState")) {
          if (e.props.contentState) {
            var o = (0, m.convertFromRaw)(e.props.contentState);
            n = m.EditorState.createWithContent(o, t), n = m.EditorState.moveSelectionToEnd(n);
          }
        } else if ((0, v.hasProperty)(e.props, "defaultContentState") || (0, v.hasProperty)(e.props, "initialContentState")) {
          var r = e.props.defaultContentState || e.props.initialContentState;
          r && (r = (0, m.convertFromRaw)(r), n = m.EditorState.createWithContent(r, t), n = m.EditorState.moveSelectionToEnd(n));
        }
        return n || (n = m.EditorState.createEmpty(t)), n;
      }, this.filterEditorProps = function (e) {
        return (0, v.filter)(e, ["onChange", "onEditorStateChange", "onContentStateChange", "initialContentState", "defaultContentState", "contentState", "editorState", "defaultEditorState", "locale", "localization", "toolbarOnFocus", "toolbar", "toolbarCustomButtons", "toolbarClassName", "editorClassName", "toolbarHidden", "wrapperClassName", "toolbarStyle", "editorStyle", "wrapperStyle", "uploadCallback", "onFocus", "onBlur", "onTab", "mention", "hashtag", "ariaLabel", "customBlockRenderFunc", "customDecorators", "handlePastedText", "customStyleMap"]);
      }, this.getStyleMap = function (e) {
        return c({}, (0, g.getCustomStyleMap)(), e.customStyleMap);
      }, this.changeEditorState = function (t) {
        var n = (0, m.convertFromRaw)(t),
            o = e.state.editorState;
        return o = m.EditorState.push(o, n, "insert-characters"), o = m.EditorState.moveSelectionToEnd(o);
      }, this.focusEditor = function () {
        setTimeout(function () {
          e.editor.focus();
        });
      }, this.handleKeyCommand = function (t) {
        var n = e.state,
            o = n.editorState,
            r = n.toolbar.inline;

        if (r && r.options.indexOf(t) >= 0) {
          var i = m.RichUtils.handleKeyCommand(o, t);
          if (i) return e.onChange(i), !0;
        }

        return !1;
      }, this.handleReturn = function (t) {
        if (E.default.isOpen()) return !0;
        var n = (0, g.handleNewLine)(e.state.editorState, t);
        return !!n && (e.onChange(n), !0);
      }, this.handlePastedText = function (t, n) {
        var o = e.state.editorState;
        return e.props.handlePastedText ? e.props.handlePastedText(t, n, o, e.onChange) : !e.props.stripPastedStyles && (0, x.handlePastedText)(t, n, o, e.onChange);
      }, this.preventDefault = function (t) {
        "INPUT" === t.target.tagName || "LABEL" === t.target.tagName ? e.focusHandler.onInputMouseDown() : t.preventDefault();
      };
    };

    t.default = Z;
  }, function (e, t, n) {
    "use strict";

    var o = n(17),
        r = n(18),
        i = n(19);

    e.exports = function () {
      function e(e, t, n, o, a, l) {
        l !== i && r(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
      }

      function t() {
        return e;
      }

      e.isRequired = e;
      var n = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t
      };
      return n.checkPropTypes = o, n.PropTypes = n, n;
    };
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return function () {
        return e;
      };
    }

    var r = function r() {};

    r.thatReturns = o, r.thatReturnsFalse = o(!1), r.thatReturnsTrue = o(!0), r.thatReturnsNull = o(null), r.thatReturnsThis = function () {
      return this;
    }, r.thatReturnsArgument = function (e) {
      return e;
    }, e.exports = r;
  }, function (e, t, n) {
    "use strict";

    function o(e, t, n, o, i, a, l, c) {
      if (r(t), !e) {
        var s;
        if (void 0 === t) s = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
          var u = [n, o, i, a, l, c],
              d = 0;
          s = new Error(t.replace(/%s/g, function () {
            return u[d++];
          })), s.name = "Invariant Violation";
        }
        throw s.framesToPop = 1, s;
      }
    }

    var r = function r(e) {};

    e.exports = o;
  }, function (e, t, n) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t, n) {
    "use strict";

    function o(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = function e() {
      var t = this;
      o(this, e), this.callBacks = [], this.suggestionCallback = void 0, this.editorFlag = !1, this.suggestionFlag = !1, this.closeAllModals = function (e) {
        t.callBacks.forEach(function (t) {
          t(e);
        });
      }, this.init = function (e) {
        var n = document.getElementById(e);
        n && n.addEventListener("click", function () {
          t.editorFlag = !0;
        }), document && (document.addEventListener("click", function () {
          t.editorFlag ? t.editorFlag = !1 : (t.closeAllModals(), t.suggestionCallback && t.suggestionCallback());
        }), document.addEventListener("keydown", function (e) {
          "Escape" === e.key && t.closeAllModals();
        }));
      }, this.onEditorClick = function () {
        t.closeModals(), !t.suggestionFlag && t.suggestionCallback ? t.suggestionCallback() : t.suggestionFlag = !1;
      }, this.closeModals = function (e) {
        t.closeAllModals(e);
      }, this.registerCallBack = function (e) {
        t.callBacks.push(e);
      }, this.deregisterCallBack = function (e) {
        t.callBacks = t.callBacks.filter(function (t) {
          return t !== e;
        });
      }, this.setSuggestionCallback = function (e) {
        t.suggestionCallback = e;
      }, this.removeSuggestionCallback = function () {
        t.suggestionCallback = void 0;
      }, this.onSuggestionClick = function () {
        t.suggestionFlag = !0;
      };
    };

    t.default = r;
  }, function (e, t, n) {
    "use strict";

    function o(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = function e() {
      var t = this;
      o(this, e), this.inputFocused = !1, this.editorMouseDown = !1, this.onEditorMouseDown = function () {
        t.editorFocused = !0;
      }, this.onInputMouseDown = function () {
        t.inputFocused = !0;
      }, this.isEditorBlur = function (e) {
        return "INPUT" !== e.target.tagName && "LABEL" !== e.target.tagName || t.editorFocused ? !("INPUT" === e.target.tagName && "LABEL" === e.target.tagName || t.inputFocused) && (t.editorFocused = !1, !0) : (t.inputFocused = !1, !0);
      }, this.isEditorFocused = function () {
        return !t.inputFocused || (t.inputFocused = !1, !1);
      }, this.isToolbarFocused = function () {
        return !t.editorFocused || (t.editorFocused = !1, !1);
      }, this.isInputFocused = function () {
        return t.inputFocused;
      };
    };

    t.default = r;
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      var t = e.getData() && e.getData().get("text-align");
      return t ? "rdw-" + t + "-aligned-block" : "";
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.handlePastedText = void 0;

    var o = n(4),
        r = n(3),
        i = n(24),
        a = function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }(i),
        l = n(9);

    t.handlePastedText = function (e, t, n, i) {
      var c = (0, o.getSelectedBlock)(n);

      if (c && "code" === c.type) {
        var s = r.Modifier.replaceText(n.getCurrentContent(), n.getSelection(), e, n.getCurrentInlineStyle());
        return i(r.EditorState.push(n, s, "insert-characters")), !0;
      }

      if (t) {
        var u = (0, a.default)(t),
            d = n.getCurrentContent();
        return u.entityMap.forEach(function (e, t) {
          d = d.mergeEntityData(t, e);
        }), d = r.Modifier.replaceWithFragment(d, n.getSelection(), new l.List(u.contentBlocks)), i(r.EditorState.push(n, d, "insert-characters")), !0;
      }

      return !1;
    };
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      var o,
          r,
          i,
          a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      };
      !function (l, c) {
        "object" == a(t) && "object" == a(e) ? e.exports = c(n(9), n(3)) : (r = [n(9), n(3)], o = c, void 0 !== (i = "function" == typeof o ? o.apply(t, r) : o) && (e.exports = i));
      }("undefined" != typeof self && self, function (e, t) {
        return function (e) {
          function t(o) {
            if (n[o]) return n[o].exports;
            var r = n[o] = {
              i: o,
              l: !1,
              exports: {}
            };
            return e[o].call(r.exports, r, r.exports, t), r.l = !0, r.exports;
          }

          var n = {};
          return t.m = e, t.c = n, t.d = function (e, n, o) {
            t.o(e, n) || Object.defineProperty(e, n, {
              configurable: !1,
              enumerable: !0,
              get: o
            });
          }, t.n = function (e) {
            var n = e && e.__esModule ? function () {
              return e.default;
            } : function () {
              return e;
            };
            return t.d(n, "a", n), n;
          }, t.o = function (e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
          }, t.p = "", t(t.s = 2);
        }([function (t, n) {
          t.exports = e;
        }, function (e, n) {
          e.exports = t;
        }, function (e, t, n) {
          e.exports = n(3);
        }, function (e, t, n) {
          function o(e) {
            return e && e.__esModule ? e : {
              default: e
            };
          }

          function r(e, t, n, o, i, a) {
            var c = e.nodeName.toLowerCase();

            if (a) {
              var s = a(c, e);

              if (s) {
                var u = l.Entity.__create(s.type, s.mutability, s.data || {});

                return {
                  chunk: (0, d.getAtomicBlockChunk)(u)
                };
              }
            }

            if ("#text" === c && "\n" !== e.textContent) return (0, d.createTextChunk)(e, t, i);
            if ("br" === c) return {
              chunk: (0, d.getSoftNewlineChunk)()
            };

            if ("img" === c && e instanceof HTMLImageElement) {
              var p = {};
              p.src = e.getAttribute ? e.getAttribute("src") || e.src : e.src, p.alt = e.alt, p.height = e.style.height, p.width = e.style.width, e.style.float && (p.alignment = e.style.float);

              var m = l.Entity.__create("IMAGE", "MUTABLE", p);

              return {
                chunk: (0, d.getAtomicBlockChunk)(m)
              };
            }

            if ("iframe" === c && e instanceof HTMLIFrameElement) {
              var y = {};
              y.src = e.getAttribute ? e.getAttribute("src") || e.src : e.src, y.height = e.height, y.width = e.width;

              var M = l.Entity.__create("EMBEDDED_LINK", "MUTABLE", y);

              return {
                chunk: (0, d.getAtomicBlockChunk)(M)
              };
            }

            var j = (0, f.default)(c, o),
                w = void 0;
            j && ("ul" === c || "ol" === c ? (o = c, n += 1) : ("unordered-list-item" !== j && "ordered-list-item" !== j && (o = "", n = -1), k ? (w = (0, d.getFirstBlockChunk)(j, (0, h.default)(e)), k = !1) : w = (0, d.getBlockDividerChunk)(j, n, (0, h.default)(e)))), w || (w = (0, d.getEmptyChunk)()), t = (0, g.default)(c, e, t);

            for (var N = e.firstChild; N;) {
              var C = (0, b.default)(N),
                  E = r(N, t, n, o, C || i, a),
                  L = E.chunk;
              w = (0, d.joinChunks)(w, L), N = N.nextSibling;
            }

            return {
              chunk: w
            };
          }

          function i(e, t) {
            var n = e.trim().replace(w, j),
                o = (0, u.default)(n);
            return o ? (k = !0, {
              chunk: r(o, new c.OrderedSet(), -1, "", void 0, t).chunk
            }) : null;
          }

          function a(e, t) {
            var n = i(e, t);

            if (n) {
              var o = n.chunk,
                  r = new c.OrderedMap({});
              o.entities && o.entities.forEach(function (e) {
                e && (r = r.set(e, l.Entity.__get(e)));
              });
              var a = 0;
              return {
                contentBlocks: o.text.split("\r").map(function (e, t) {
                  var n = a + e.length,
                      r = o && o.inlines.slice(a, n),
                      i = o && o.entities.slice(a, n),
                      s = new c.List(r.map(function (e, t) {
                    var n = {
                      style: e,
                      entity: null
                    };
                    return i[t] && (n.entity = i[t]), l.CharacterMetadata.create(n);
                  }));
                  return a = n, new l.ContentBlock({
                    key: (0, l.genKey)(),
                    type: o && o.blocks[t] && o.blocks[t].type || "unstyled",
                    depth: o && o.blocks[t] && o.blocks[t].depth,
                    data: o && o.blocks[t] && o.blocks[t].data || new c.Map({}),
                    text: e,
                    characterList: s
                  });
                }),
                entityMap: r
              };
            }

            return null;
          }

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.default = a;
          var l = n(1),
              c = n(0),
              s = n(4),
              u = o(s),
              d = n(5),
              p = n(6),
              f = o(p),
              m = n(7),
              g = o(m),
              y = n(8),
              h = o(y),
              M = n(9),
              b = o(M),
              j = " ",
              w = new RegExp("&nbsp;", "g"),
              k = !0;
        }, function (e, t, n) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          });

          var o = function o(e) {
            var t,
                n = null;
            return document.implementation && document.implementation.createHTMLDocument && (t = document.implementation.createHTMLDocument("foo"), t.documentElement.innerHTML = e, n = t.getElementsByTagName("body")[0]), n;
          };

          t.default = o;
        }, function (e, t, n) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.joinChunks = t.getAtomicBlockChunk = t.getBlockDividerChunk = t.getFirstBlockChunk = t.getEmptyChunk = t.getSoftNewlineChunk = t.createTextChunk = t.getWhitespaceChunk = void 0;

          var o = n(0),
              r = t.getWhitespaceChunk = function (e) {
            return {
              text: " ",
              inlines: [new o.OrderedSet()],
              entities: [e],
              blocks: []
            };
          };

          t.createTextChunk = function (e, t, n) {
            var o = e.textContent;
            return "" === o.trim() ? {
              chunk: r(n)
            } : {
              chunk: {
                text: o,
                inlines: Array(o.length).fill(t),
                entities: Array(o.length).fill(n),
                blocks: []
              }
            };
          }, t.getSoftNewlineChunk = function () {
            return {
              text: "\n",
              inlines: [new o.OrderedSet()],
              entities: new Array(1),
              blocks: []
            };
          }, t.getEmptyChunk = function () {
            return {
              text: "",
              inlines: [],
              entities: [],
              blocks: []
            };
          }, t.getFirstBlockChunk = function (e, t) {
            return {
              text: "",
              inlines: [],
              entities: [],
              blocks: [{
                type: e,
                depth: 0,
                data: t || new o.Map({})
              }]
            };
          }, t.getBlockDividerChunk = function (e, t, n) {
            return {
              text: "\r",
              inlines: [],
              entities: [],
              blocks: [{
                type: e,
                depth: Math.max(0, Math.min(4, t)),
                data: n || new o.Map({})
              }]
            };
          }, t.getAtomicBlockChunk = function (e) {
            return {
              text: "\r ",
              inlines: [new o.OrderedSet()],
              entities: [e],
              blocks: [{
                type: "atomic",
                depth: 0,
                data: new o.Map({})
              }]
            };
          }, t.joinChunks = function (e, t) {
            return {
              text: e.text + t.text,
              inlines: e.inlines.concat(t.inlines),
              entities: e.entities.concat(t.entities),
              blocks: e.blocks.concat(t.blocks)
            };
          };
        }, function (e, t, n) {
          function o(e, t) {
            var n = i.filter(function (n) {
              return n.element === e && (!n.wrapper || n.wrapper === t) || n.wrapper === e || n.aliasedElements && n.aliasedElements.indexOf(e) > -1;
            }).keySeq().toSet().toArray();
            if (1 === n.length) return n[0];
          }

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.default = o;
          var r = n(0),
              i = new r.Map({
            "header-one": {
              element: "h1"
            },
            "header-two": {
              element: "h2"
            },
            "header-three": {
              element: "h3"
            },
            "header-four": {
              element: "h4"
            },
            "header-five": {
              element: "h5"
            },
            "header-six": {
              element: "h6"
            },
            "unordered-list-item": {
              element: "li",
              wrapper: "ul"
            },
            "ordered-list-item": {
              element: "li",
              wrapper: "ol"
            },
            blockquote: {
              element: "blockquote"
            },
            code: {
              element: "pre"
            },
            atomic: {
              element: "figure"
            },
            unstyled: {
              element: "p",
              aliasedElements: ["div"]
            }
          });
        }, function (e, t, n) {
          function o(e, t, n) {
            var o = r[e],
                i = void 0;
            if (o) i = n.add(o).toOrderedSet();else if (t instanceof HTMLElement) {
              i = n;
              var a = t;
              i = i.withMutations(function (e) {
                var t = a.style.color,
                    n = a.style.backgroundColor,
                    o = a.style.fontSize,
                    r = a.style.fontFamily.replace(/^"|"$/g, "");
                t && e.add("color-" + t.replace(/ /g, "")), n && e.add("bgcolor-" + n.replace(/ /g, "")), o && e.add("fontsize-" + o.replace(/px$/g, "")), r && e.add("fontfamily-" + r);
              }).toOrderedSet();
            }
            return i;
          }

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.default = o;
          var r = {
            code: "CODE",
            del: "STRIKETHROUGH",
            em: "ITALIC",
            strong: "BOLD",
            ins: "UNDERLINE",
            sub: "SUBSCRIPT",
            sup: "SUPERSCRIPT"
          };
        }, function (e, t, n) {
          function o(e) {
            if (e.style.textAlign) return new r.Map({
              "text-align": e.style.textAlign
            });
          }

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.default = o;
          var r = n(0);
        }, function (e, t, n) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          });

          var o = n(1),
              r = function r(e) {
            var t = void 0;

            if (e instanceof HTMLAnchorElement) {
              var n = {};
              e.dataset && void 0 !== e.dataset.mention ? (n.url = e.href, n.text = e.innerHTML, n.value = e.dataset.value, t = o.Entity.__create("MENTION", "IMMUTABLE", n)) : (n.url = e.getAttribute ? e.getAttribute("href") || e.href : e.href, n.title = e.innerHTML, n.targetOption = e.target, t = o.Entity.__create("LINK", "MUTABLE", n));
            }

            return t;
          };

          t.default = r;
        }]);
      });
    }).call(t, n(25)(e));
  }, function (e, t, n) {
    "use strict";

    e.exports = function (e) {
      return e.webpackPolyfill || (e.deprecate = function () {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", {
        enumerable: !0,
        get: function get() {
          return e.l;
        }
      }), Object.defineProperty(e, "id", {
        enumerable: !0,
        get: function get() {
          return e.i;
        }
      }), e.webpackPolyfill = 1), e;
    };
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var r = n(27),
        i = o(r),
        a = n(35),
        l = o(a),
        c = n(38),
        s = o(c),
        u = n(41),
        d = o(u),
        p = n(44),
        f = o(p),
        m = n(47),
        g = o(m),
        y = n(50),
        h = o(y),
        M = n(53),
        b = o(M),
        j = n(62),
        w = o(j),
        k = n(65),
        N = o(k),
        C = n(68),
        E = o(C),
        L = n(73),
        D = o(L),
        S = n(76),
        v = o(S);
    e.exports = {
      inline: i.default,
      blockType: l.default,
      fontSize: s.default,
      fontFamily: d.default,
      list: f.default,
      textAlign: g.default,
      colorPicker: h.default,
      link: b.default,
      embedded: w.default,
      emoji: N.default,
      image: E.default,
      remove: D.default,
      history: v.default
    };
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var l = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }

      return function (t, n, o) {
        return n && e(t.prototype, n), o && e(t, o), t;
      };
    }(),
        c = n(0),
        s = o(c),
        u = n(1),
        d = o(u),
        p = n(4),
        f = n(3),
        m = n(6),
        g = n(28),
        y = o(g),
        h = function (e) {
      function t() {
        var e, n, o, a;
        r(this, t);

        for (var l = arguments.length, c = Array(l), s = 0; s < l; s++) {
          c[s] = arguments[s];
        }

        return n = o = i(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(c))), o.state = {
          currentStyles: {}
        }, o.onExpandEvent = function () {
          o.signalExpanded = !o.state.expanded;
        }, o.expandCollapse = function () {
          o.setState({
            expanded: o.signalExpanded
          }), o.signalExpanded = !1;
        }, o.toggleInlineStyle = function (e) {
          var t = "monospace" === e ? "CODE" : e.toUpperCase(),
              n = o.props,
              r = n.editorState,
              i = n.onChange,
              a = f.RichUtils.toggleInlineStyle(r, t);

          if ("subscript" === e || "superscript" === e) {
            var l = "subscript" === e ? "SUPERSCRIPT" : "SUBSCRIPT",
                c = f.Modifier.removeInlineStyle(a.getCurrentContent(), a.getSelection(), l);
            a = f.EditorState.push(a, c, "change-inline-style");
          }

          a && i(a);
        }, o.changeKeys = function (e) {
          if (e) {
            var t = {};
            return (0, m.forEach)(e, function (e, n) {
              t["CODE" === e ? "monospace" : e.toLowerCase()] = n;
            }), t;
          }
        }, o.doExpand = function () {
          o.setState({
            expanded: !0
          });
        }, o.doCollapse = function () {
          o.setState({
            expanded: !1
          });
        }, a = n, i(o, a);
      }

      return a(t, e), l(t, [{
        key: "componentWillMount",
        value: function value() {
          var e = this.props,
              t = e.editorState,
              n = e.modalHandler;
          t && this.setState({
            currentStyles: this.changeKeys((0, p.getSelectionInlineStyle)(t))
          }), n.registerCallBack(this.expandCollapse);
        }
      }, {
        key: "componentWillReceiveProps",
        value: function value(e) {
          e.editorState && this.props.editorState !== e.editorState && this.setState({
            currentStyles: this.changeKeys((0, p.getSelectionInlineStyle)(e.editorState))
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.props.modalHandler.deregisterCallBack(this.expandCollapse);
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.config,
              n = e.translations,
              o = this.state,
              r = o.expanded,
              i = o.currentStyles,
              a = t.component || y.default;
          return s.default.createElement(a, {
            config: t,
            translations: n,
            currentState: i,
            expanded: r,
            onExpandEvent: this.onExpandEvent,
            doExpand: this.doExpand,
            doCollapse: this.doCollapse,
            onChange: this.toggleInlineStyle
          });
        }
      }]), t;
    }(c.Component);

    h.propTypes = {
      onChange: d.default.func.isRequired,
      editorState: d.default.object.isRequired,
      modalHandler: d.default.object,
      config: d.default.object,
      translations: d.default.object
    }, t.default = h;
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var l = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }

      return function (t, n, o) {
        return n && e(t.prototype, n), o && e(t, o), t;
      };
    }(),
        c = n(0),
        s = o(c),
        u = n(1),
        d = o(u),
        p = n(2),
        f = o(p),
        m = n(8),
        g = n(5),
        y = o(g),
        h = n(7);

    n(34);

    var M = function (e) {
      function t() {
        return r(this, t), i(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return a(t, e), l(t, [{
        key: "renderInFlatList",
        value: function value() {
          var e = this.props,
              t = e.config,
              n = e.currentState,
              o = e.onChange,
              r = e.translations;
          return s.default.createElement("div", {
            className: (0, f.default)("rdw-inline-wrapper", t.className),
            "aria-label": "rdw-inline-control"
          }, t.options.map(function (e, i) {
            return s.default.createElement(y.default, {
              key: i,
              value: e,
              onClick: o,
              className: (0, f.default)(t[e].className),
              active: !0 === n[e] || "MONOSPACE" === e && n.CODE,
              title: t[e].title || r["components.controls.inline." + e]
            }, s.default.createElement("img", {
              alt: "",
              src: t[e].icon
            }));
          }));
        }
      }, {
        key: "renderInDropDown",
        value: function value() {
          var e = this.props,
              t = e.config,
              n = e.expanded,
              o = e.doExpand,
              r = e.onExpandEvent,
              i = e.doCollapse,
              a = e.currentState,
              l = e.onChange,
              c = e.translations,
              u = t.className,
              d = t.dropdownClassName,
              p = t.title;
          return s.default.createElement(h.Dropdown, {
            className: (0, f.default)("rdw-inline-dropdown", u),
            optionWrapperClassName: (0, f.default)(d),
            onChange: l,
            expanded: n,
            doExpand: o,
            doCollapse: i,
            onExpandEvent: r,
            "aria-label": "rdw-inline-control",
            title: p
          }, s.default.createElement("img", {
            src: (0, m.getFirstIcon)(t),
            alt: ""
          }), t.options.map(function (e, n) {
            return s.default.createElement(h.DropdownOption, {
              key: n,
              value: e,
              className: (0, f.default)("rdw-inline-dropdownoption", t[e].className),
              active: !0 === a[e] || "MONOSPACE" === e && a.CODE,
              title: t[e].title || c["components.controls.inline." + e]
            }, s.default.createElement("img", {
              src: t[e].icon,
              alt: ""
            }));
          }));
        }
      }, {
        key: "render",
        value: function value() {
          return this.props.config.inDropdown ? this.renderInDropDown() : this.renderInFlatList();
        }
      }]), t;
    }(c.Component);

    M.propTypes = {
      expanded: d.default.bool,
      doExpand: d.default.func,
      doCollapse: d.default.func,
      onExpandEvent: d.default.func,
      config: d.default.object,
      onChange: d.default.func,
      currentState: d.default.object,
      translations: d.default.object
    }, t.default = M;
  }, function (e, t) {
    e.exports = {
      "rdw-option-wrapper": "rdw-option-wrapper",
      "rdw-option-active": "rdw-option-active",
      "rdw-option-disabled": "rdw-option-disabled"
    };
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var l = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }

      return function (t, n, o) {
        return n && e(t.prototype, n), o && e(t, o), t;
      };
    }(),
        c = n(0),
        s = o(c),
        u = n(1),
        d = o(u),
        p = n(2),
        f = o(p);

    n(31);

    var m = n(6),
        g = function (e) {
      function t() {
        var e, n, o, a;
        r(this, t);

        for (var l = arguments.length, c = Array(l), s = 0; s < l; s++) {
          c[s] = arguments[s];
        }

        return n = o = i(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(c))), o.state = {
          highlighted: -1
        }, o.onChange = function (e) {
          var t = o.props.onChange;
          t && t(e), o.toggleExpansion();
        }, o.setHighlighted = function (e) {
          o.setState({
            highlighted: e
          });
        }, o.toggleExpansion = function () {
          var e = o.props,
              t = e.doExpand,
              n = e.doCollapse;
          e.expanded ? n() : t();
        }, a = n, i(o, a);
      }

      return a(t, e), l(t, [{
        key: "componentWillReceiveProps",
        value: function value(e) {
          this.props.expanded && !e.expanded && this.setState({
            highlighted: -1
          });
        }
      }, {
        key: "render",
        value: function value() {
          var e = this,
              t = this.props,
              n = t.expanded,
              o = t.children,
              r = t.className,
              i = t.optionWrapperClassName,
              a = t.ariaLabel,
              l = t.onExpandEvent,
              c = t.title,
              u = this.state.highlighted,
              d = o.slice(1, o.length);
          return s.default.createElement("div", {
            className: (0, f.default)("rdw-dropdown-wrapper", r),
            "aria-expanded": n,
            "aria-label": a || "rdw-dropdown"
          }, s.default.createElement("a", {
            className: "rdw-dropdown-selectedtext",
            onClick: l,
            title: c
          }, o[0], s.default.createElement("div", {
            className: (0, f.default)({
              "rdw-dropdown-carettoclose": n,
              "rdw-dropdown-carettoopen": !n
            })
          })), n ? s.default.createElement("ul", {
            className: (0, f.default)("rdw-dropdown-optionwrapper", i),
            onClick: m.stopPropagation
          }, s.default.Children.map(d, function (t, n) {
            return t && s.default.cloneElement(t, {
              onSelect: e.onChange,
              highlighted: u === n,
              setHighlighted: e.setHighlighted,
              index: n
            });
          })) : void 0);
        }
      }]), t;
    }(c.Component);

    g.propTypes = {
      children: d.default.any,
      onChange: d.default.func,
      className: d.default.string,
      expanded: d.default.bool,
      doExpand: d.default.func,
      doCollapse: d.default.func,
      onExpandEvent: d.default.func,
      optionWrapperClassName: d.default.string,
      ariaLabel: d.default.string,
      title: d.default.string
    }, t.default = g;
  }, function (e, t) {
    e.exports = {
      "rdw-dropdown-wrapper": "rdw-dropdown-wrapper",
      "rdw-dropdown-carettoopen": "rdw-dropdown-carettoopen",
      "rdw-dropdown-carettoclose": "rdw-dropdown-carettoclose",
      "rdw-dropdown-selectedtext": "rdw-dropdown-selectedtext",
      "rdw-dropdown-optionwrapper": "rdw-dropdown-optionwrapper"
    };
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function r(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    function i(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function a(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function l(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var c = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }

      return function (t, n, o) {
        return n && e(t.prototype, n), o && e(t, o), t;
      };
    }(),
        s = n(0),
        u = o(s),
        d = n(1),
        p = o(d),
        f = n(2),
        m = o(f);

    n(33);

    var g = function (e) {
      function t() {
        var e, n, o, r;
        i(this, t);

        for (var l = arguments.length, c = Array(l), s = 0; s < l; s++) {
          c[s] = arguments[s];
        }

        return n = o = a(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(c))), o.onClick = function (e) {
          var t = o.props,
              n = t.onSelect,
              r = t.onClick,
              i = t.value;
          t.disabled || (n && n(i), r && (e.stopPropagation(), r(i)));
        }, o.setHighlighted = function () {
          var e = o.props;
          (0, e.setHighlighted)(e.index);
        }, o.resetHighlighted = function () {
          (0, o.props.setHighlighted)(-1);
        }, r = n, a(o, r);
      }

      return l(t, e), c(t, [{
        key: "render",
        value: function value() {
          var e,
              t = this.props,
              n = t.children,
              o = t.active,
              i = t.disabled,
              a = t.highlighted,
              l = t.className,
              c = t.activeClassName,
              s = t.disabledClassName,
              d = t.highlightedClassName,
              p = t.title;
          return u.default.createElement("li", {
            className: (0, m.default)("rdw-dropdownoption-default", l, (e = {}, r(e, "rdw-dropdownoption-active " + c, o), r(e, "rdw-dropdownoption-highlighted " + d, a), r(e, "rdw-dropdownoption-disabled " + s, i), e)),
            onMouseEnter: this.setHighlighted,
            onMouseLeave: this.resetHighlighted,
            onClick: this.onClick,
            title: p
          }, n);
        }
      }]), t;
    }(s.Component);

    g.propTypes = {
      children: p.default.any,
      value: p.default.any,
      onClick: p.default.func,
      onSelect: p.default.func,
      setHighlighted: p.default.func,
      index: p.default.number,
      disabled: p.default.bool,
      active: p.default.bool,
      highlighted: p.default.bool,
      className: p.default.string,
      activeClassName: p.default.string,
      disabledClassName: p.default.string,
      highlightedClassName: p.default.string,
      title: p.default.string
    }, g.defaultProps = {
      activeClassName: "",
      disabledClassName: "",
      highlightedClassName: ""
    }, t.default = g;
  }, function (e, t) {
    e.exports = {
      "rdw-dropdownoption-default": "rdw-dropdownoption-default",
      "rdw-dropdownoption-highlighted": "rdw-dropdownoption-highlighted",
      "rdw-dropdownoption-active": "rdw-dropdownoption-active",
      "rdw-dropdownoption-disabled": "rdw-dropdownoption-disabled"
    };
  }, function (e, t) {
    e.exports = {
      "rdw-inline-wrapper": "rdw-inline-wrapper",
      "rdw-inline-dropdown": "rdw-inline-dropdown",
      "rdw-inline-dropdownoption": "rdw-inline-dropdownoption"
    };
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var l = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }

      return function (t, n, o) {
        return n && e(t.prototype, n), o && e(t, o), t;
      };
    }(),
        c = n(0),
        s = o(c),
        u = n(1),
        d = o(u),
        p = n(4),
        f = n(3),
        m = n(36),
        g = o(m),
        y = function (e) {
      function t() {
        var e, n, o, a;
        r(this, t);

        for (var l = arguments.length, c = Array(l), s = 0; s < l; s++) {
          c[s] = arguments[s];
        }

        return n = o = i(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(c))), o.state = {
          expanded: !1,
          currentBlockType: "unstyled"
        }, o.onExpandEvent = function () {
          o.signalExpanded = !o.state.expanded;
        }, o.expandCollapse = function () {
          o.setState({
            expanded: o.signalExpanded
          }), o.signalExpanded = !1;
        }, o.blocksTypes = [{
          label: "Normal",
          style: "unstyled"
        }, {
          label: "H1",
          style: "header-one"
        }, {
          label: "H2",
          style: "header-two"
        }, {
          label: "H3",
          style: "header-three"
        }, {
          label: "H4",
          style: "header-four"
        }, {
          label: "H5",
          style: "header-five"
        }, {
          label: "H6",
          style: "header-six"
        }, {
          label: "Blockquote",
          style: "blockquote"
        }, {
          label: "Code",
          style: "code"
        }], o.doExpand = function () {
          o.setState({
            expanded: !0
          });
        }, o.doCollapse = function () {
          o.setState({
            expanded: !1
          });
        }, o.toggleBlockType = function (e) {
          var t = o.blocksTypes.find(function (t) {
            return t.label === e;
          }).style,
              n = o.props,
              r = n.editorState,
              i = n.onChange,
              a = f.RichUtils.toggleBlockType(r, t);
          a && i(a);
        }, a = n, i(o, a);
      }

      return a(t, e), l(t, [{
        key: "componentWillMount",
        value: function value() {
          var e = this.props,
              t = e.editorState,
              n = e.modalHandler;
          t && this.setState({
            currentBlockType: (0, p.getSelectedBlocksType)(t)
          }), n.registerCallBack(this.expandCollapse);
        }
      }, {
        key: "componentWillReceiveProps",
        value: function value(e) {
          e.editorState && this.props.editorState !== e.editorState && this.setState({
            currentBlockType: (0, p.getSelectedBlocksType)(e.editorState)
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.props.modalHandler.deregisterCallBack(this.expandCollapse);
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.config,
              n = e.translations,
              o = this.state,
              r = o.expanded,
              i = o.currentBlockType,
              a = t.component || g.default,
              l = this.blocksTypes.find(function (e) {
            return e.style === i;
          });
          return s.default.createElement(a, {
            config: t,
            translations: n,
            currentState: {
              blockType: l && l.label
            },
            onChange: this.toggleBlockType,
            expanded: r,
            onExpandEvent: this.onExpandEvent,
            doExpand: this.doExpand,
            doCollapse: this.doCollapse
          });
        }
      }]), t;
    }(c.Component);

    y.propTypes = {
      onChange: d.default.func.isRequired,
      editorState: d.default.object,
      modalHandler: d.default.object,
      config: d.default.object,
      translations: d.default.object
    }, t.default = y;
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var l = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }

      return function (t, n, o) {
        return n && e(t.prototype, n), o && e(t, o), t;
      };
    }(),
        c = n(0),
        s = o(c),
        u = n(1),
        d = o(u),
        p = n(2),
        f = o(p),
        m = n(5),
        g = o(m),
        y = n(7);

    n(37);

    var h = function (e) {
      function t(e) {
        r(this, t);
        var n = i(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
        return n.getBlockTypes = function (e) {
          return [{
            label: "Normal",
            displayName: e["components.controls.blocktype.normal"]
          }, {
            label: "H1",
            displayName: e["components.controls.blocktype.h1"]
          }, {
            label: "H2",
            displayName: e["components.controls.blocktype.h2"]
          }, {
            label: "H3",
            displayName: e["components.controls.blocktype.h3"]
          }, {
            label: "H4",
            displayName: e["components.controls.blocktype.h4"]
          }, {
            label: "H5",
            displayName: e["components.controls.blocktype.h5"]
          }, {
            label: "H6",
            displayName: e["components.controls.blocktype.h6"]
          }, {
            label: "Blockquote",
            displayName: e["components.controls.blocktype.blockquote"]
          }, {
            label: "Code",
            displayName: e["components.controls.blocktype.code"]
          }];
        }, n.state = {
          blockTypes: n.getBlockTypes(e.translations)
        }, n;
      }

      return a(t, e), l(t, [{
        key: "componentWillReceiveProps",
        value: function value(e) {
          this.props.translations !== e.translations && this.setState({
            blockTypes: this.getBlockTypes(e.translations)
          });
        }
      }, {
        key: "renderFlat",
        value: function value(e) {
          var t = this.props,
              n = t.config.className,
              o = t.onChange,
              r = t.currentState.blockType;
          return s.default.createElement("div", {
            className: (0, f.default)("rdw-inline-wrapper", n)
          }, e.map(function (e, t) {
            return s.default.createElement(g.default, {
              key: t,
              value: e.label,
              active: r === e.label,
              onClick: o
            }, e.displayName);
          }));
        }
      }, {
        key: "renderInDropdown",
        value: function value(e) {
          var t = this.props,
              n = t.config,
              o = n.className,
              r = n.dropdownClassName,
              i = n.title,
              a = t.currentState.blockType,
              l = t.expanded,
              c = t.doExpand,
              u = t.onExpandEvent,
              d = t.doCollapse,
              p = t.onChange,
              m = t.translations,
              g = this.state.blockTypes,
              h = g.filter(function (e) {
            return e.label === a;
          }),
              M = h && h[0] && h[0].displayName;
          return s.default.createElement("div", {
            className: "rdw-block-wrapper",
            "aria-label": "rdw-block-control"
          }, s.default.createElement(y.Dropdown, {
            className: (0, f.default)("rdw-block-dropdown", o),
            optionWrapperClassName: (0, f.default)(r),
            onChange: p,
            expanded: l,
            doExpand: c,
            doCollapse: d,
            onExpandEvent: u,
            title: i || m["components.controls.blocktype.blocktype"]
          }, s.default.createElement("span", null, M || m["components.controls.blocktype.blocktype"]), e.map(function (e, t) {
            return s.default.createElement(y.DropdownOption, {
              active: a === e.label,
              value: e.label,
              key: t
            }, e.displayName);
          })));
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props.config,
              t = e.inDropdown,
              n = this.state.blockTypes,
              o = n.filter(function (t) {
            var n = t.label;
            return e.options.indexOf(n) > -1;
          });
          return t ? this.renderInDropdown(o) : this.renderFlat(o);
        }
      }]), t;
    }(c.Component);

    h.propTypes = {
      expanded: d.default.bool,
      onExpandEvent: d.default.func,
      doExpand: d.default.func,
      doCollapse: d.default.func,
      onChange: d.default.func,
      config: d.default.object,
      currentState: d.default.object,
      translations: d.default.object
    }, t.default = h;
  }, function (e, t) {
    e.exports = {
      "rdw-block-wrapper": "rdw-block-wrapper",
      "rdw-block-dropdown": "rdw-block-dropdown"
    };
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var l = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }

      return function (t, n, o) {
        return n && e(t.prototype, n), o && e(t, o), t;
      };
    }(),
        c = n(0),
        s = o(c),
        u = n(1),
        d = o(u),
        p = n(4),
        f = n(39),
        m = o(f),
        g = function (e) {
      function t() {
        var e, n, o, a;
        r(this, t);

        for (var l = arguments.length, c = Array(l), s = 0; s < l; s++) {
          c[s] = arguments[s];
        }

        return n = o = i(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(c))), o.state = {
          expanded: void 0,
          currentFontSize: void 0
        }, o.onExpandEvent = function () {
          o.signalExpanded = !o.state.expanded;
        }, o.expandCollapse = function () {
          o.setState({
            expanded: o.signalExpanded
          }), o.signalExpanded = !1;
        }, o.doExpand = function () {
          o.setState({
            expanded: !0
          });
        }, o.doCollapse = function () {
          o.setState({
            expanded: !1
          });
        }, o.toggleFontSize = function (e) {
          var t = o.props,
              n = t.editorState,
              r = t.onChange,
              i = (0, p.toggleCustomInlineStyle)(n, "fontSize", e);
          i && r(i);
        }, a = n, i(o, a);
      }

      return a(t, e), l(t, [{
        key: "componentWillMount",
        value: function value() {
          var e = this.props,
              t = e.editorState,
              n = e.modalHandler;
          t && this.setState({
            currentFontSize: (0, p.getSelectionCustomInlineStyle)(t, ["FONTSIZE"]).FONTSIZE
          }), n.registerCallBack(this.expandCollapse);
        }
      }, {
        key: "componentWillReceiveProps",
        value: function value(e) {
          e.editorState && this.props.editorState !== e.editorState && this.setState({
            currentFontSize: (0, p.getSelectionCustomInlineStyle)(e.editorState, ["FONTSIZE"]).FONTSIZE
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.props.modalHandler.deregisterCallBack(this.expandCollapse);
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.config,
              n = e.translations,
              o = this.state,
              r = o.expanded,
              i = o.currentFontSize,
              a = t.component || m.default,
              l = i && Number(i.substring(9));
          return s.default.createElement(a, {
            config: t,
            translations: n,
            currentState: {
              fontSize: l
            },
            onChange: this.toggleFontSize,
            expanded: r,
            onExpandEvent: this.onExpandEvent,
            doExpand: this.doExpand,
            doCollapse: this.doCollapse
          });
        }
      }]), t;
    }(c.Component);

    g.propTypes = {
      onChange: d.default.func.isRequired,
      editorState: d.default.object,
      modalHandler: d.default.object,
      config: d.default.object,
      translations: d.default.object
    }, t.default = g;
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var l = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }

      return function (t, n, o) {
        return n && e(t.prototype, n), o && e(t, o), t;
      };
    }(),
        c = n(0),
        s = o(c),
        u = n(1),
        d = o(u),
        p = n(2),
        f = o(p),
        m = n(7);

    n(40);

    var g = function (e) {
      function t() {
        var e, n, o, a;
        r(this, t);

        for (var l = arguments.length, c = Array(l), s = 0; s < l; s++) {
          c[s] = arguments[s];
        }

        return n = o = i(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(c))), o.state = {
          defaultFontSize: void 0
        }, a = n, i(o, a);
      }

      return a(t, e), l(t, [{
        key: "componentDidMount",
        value: function value() {
          var e = document.getElementsByClassName("DraftEditor-root");

          if (e && e.length > 0) {
            var t = window.getComputedStyle(e[0]),
                n = t.getPropertyValue("font-size");
            n = n.substring(0, n.length - 2), this.setState({
              defaultFontSize: n
            });
          }
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.config,
              n = t.icon,
              o = t.className,
              r = t.dropdownClassName,
              i = t.options,
              a = t.title,
              l = e.onChange,
              c = e.expanded,
              u = e.doCollapse,
              d = e.onExpandEvent,
              p = e.doExpand,
              g = e.translations,
              y = this.props.currentState.fontSize,
              h = this.state.defaultFontSize;
          return h = Number(h), y = y || i && i.indexOf(h) >= 0 && h, s.default.createElement("div", {
            className: "rdw-fontsize-wrapper",
            "aria-label": "rdw-font-size-control"
          }, s.default.createElement(m.Dropdown, {
            className: (0, f.default)("rdw-fontsize-dropdown", o),
            optionWrapperClassName: (0, f.default)(r),
            onChange: l,
            expanded: c,
            doExpand: p,
            doCollapse: u,
            onExpandEvent: d,
            title: a || g["components.controls.fontsize.fontsize"]
          }, y ? s.default.createElement("span", null, y) : s.default.createElement("img", {
            src: n,
            alt: ""
          }), i.map(function (e, t) {
            return s.default.createElement(m.DropdownOption, {
              className: "rdw-fontsize-option",
              active: y === e,
              value: e,
              key: t
            }, e);
          })));
        }
      }]), t;
    }(c.Component);

    g.propTypes = {
      expanded: d.default.bool,
      onExpandEvent: d.default.func,
      doExpand: d.default.func,
      doCollapse: d.default.func,
      onChange: d.default.func,
      config: d.default.object,
      currentState: d.default.object,
      translations: d.default.object
    }, t.default = g;
  }, function (e, t) {
    e.exports = {
      "rdw-fontsize-wrapper": "rdw-fontsize-wrapper",
      "rdw-fontsize-dropdown": "rdw-fontsize-dropdown",
      "rdw-fontsize-option": "rdw-fontsize-option"
    };
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var l = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }

      return function (t, n, o) {
        return n && e(t.prototype, n), o && e(t, o), t;
      };
    }(),
        c = n(0),
        s = o(c),
        u = n(1),
        d = o(u),
        p = n(4),
        f = n(42),
        m = o(f),
        g = function (e) {
      function t() {
        var e, n, o, a;
        r(this, t);

        for (var l = arguments.length, c = Array(l), s = 0; s < l; s++) {
          c[s] = arguments[s];
        }

        return n = o = i(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(c))), o.state = {
          expanded: void 0,
          currentFontFamily: void 0
        }, o.onExpandEvent = function () {
          o.signalExpanded = !o.state.expanded;
        }, o.expandCollapse = function () {
          o.setState({
            expanded: o.signalExpanded
          }), o.signalExpanded = !1;
        }, o.doExpand = function () {
          o.setState({
            expanded: !0
          });
        }, o.doCollapse = function () {
          o.setState({
            expanded: !1
          });
        }, o.toggleFontFamily = function (e) {
          var t = o.props,
              n = t.editorState,
              r = t.onChange,
              i = (0, p.toggleCustomInlineStyle)(n, "fontFamily", e);
          i && r(i);
        }, a = n, i(o, a);
      }

      return a(t, e), l(t, [{
        key: "componentWillMount",
        value: function value() {
          var e = this.props,
              t = e.editorState,
              n = e.modalHandler;
          t && this.setState({
            currentFontFamily: (0, p.getSelectionCustomInlineStyle)(t, ["FONTFAMILY"]).FONTFAMILY
          }), n.registerCallBack(this.expandCollapse);
        }
      }, {
        key: "componentWillReceiveProps",
        value: function value(e) {
          e.editorState && this.props.editorState !== e.editorState && this.setState({
            currentFontFamily: (0, p.getSelectionCustomInlineStyle)(e.editorState, ["FONTFAMILY"]).FONTFAMILY
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.props.modalHandler.deregisterCallBack(this.expandCollapse);
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.config,
              n = e.translations,
              o = this.state,
              r = o.expanded,
              i = o.currentFontFamily,
              a = t.component || m.default,
              l = i && i.substring(11);
          return s.default.createElement(a, {
            translations: n,
            config: t,
            currentState: {
              fontFamily: l
            },
            onChange: this.toggleFontFamily,
            expanded: r,
            onExpandEvent: this.onExpandEvent,
            doExpand: this.doExpand,
            doCollapse: this.doCollapse
          });
        }
      }]), t;
    }(c.Component);

    g.propTypes = {
      onChange: d.default.func.isRequired,
      editorState: d.default.object,
      modalHandler: d.default.object,
      config: d.default.object,
      translations: d.default.object
    }, t.default = g;
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var l = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }

      return function (t, n, o) {
        return n && e(t.prototype, n), o && e(t, o), t;
      };
    }(),
        c = n(0),
        s = o(c),
        u = n(1),
        d = o(u),
        p = n(2),
        f = o(p),
        m = n(7);

    n(43);

    var g = function (e) {
      function t() {
        var e, n, o, a;
        r(this, t);

        for (var l = arguments.length, c = Array(l), s = 0; s < l; s++) {
          c[s] = arguments[s];
        }

        return n = o = i(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(c))), o.state = {
          defaultFontFamily: void 0
        }, a = n, i(o, a);
      }

      return a(t, e), l(t, [{
        key: "componentDidMount",
        value: function value() {
          var e = document.getElementsByClassName("DraftEditor-root");

          if (e && e.length > 0) {
            var t = window.getComputedStyle(e[0]),
                n = t.getPropertyValue("font-family");
            this.setState({
              defaultFontFamily: n
            });
          }
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.state.defaultFontFamily,
              t = this.props,
              n = t.config,
              o = n.className,
              r = n.dropdownClassName,
              i = n.options,
              a = n.title,
              l = t.translations,
              c = t.onChange,
              u = t.expanded,
              d = t.doCollapse,
              p = t.onExpandEvent,
              g = t.doExpand,
              y = this.props.currentState.fontFamily;
          return y = y || i && e && i.some(function (t) {
            return t.toLowerCase() === e.toLowerCase();
          }) && e, s.default.createElement("div", {
            className: "rdw-fontfamily-wrapper",
            "aria-label": "rdw-font-family-control"
          }, s.default.createElement(m.Dropdown, {
            className: (0, f.default)("rdw-fontfamily-dropdown", o),
            optionWrapperClassName: (0, f.default)("rdw-fontfamily-optionwrapper", r),
            onChange: c,
            expanded: u,
            doExpand: g,
            doCollapse: d,
            onExpandEvent: p,
            title: a || l["components.controls.fontfamily.fontfamily"]
          }, s.default.createElement("span", {
            className: "rdw-fontfamily-placeholder"
          }, y || l["components.controls.fontfamily.fontfamily"]), i.map(function (e, t) {
            return s.default.createElement(m.DropdownOption, {
              active: y === e,
              value: e,
              key: t
            }, e);
          })));
        }
      }]), t;
    }(c.Component);

    g.propTypes = {
      expanded: d.default.bool,
      onExpandEvent: d.default.func,
      doExpand: d.default.func,
      doCollapse: d.default.func,
      onChange: d.default.func,
      config: d.default.object,
      currentState: d.default.object,
      translations: d.default.object
    }, t.default = g;
  }, function (e, t) {
    e.exports = {
      "rdw-fontfamily-wrapper": "rdw-fontfamily-wrapper",
      "rdw-fontfamily-dropdown": "rdw-fontfamily-dropdown",
      "rdw-fontfamily-placeholder": "rdw-fontfamily-placeholder",
      "rdw-fontfamily-optionwrapper": "rdw-fontfamily-optionwrapper"
    };
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var l = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }

      return function (t, n, o) {
        return n && e(t.prototype, n), o && e(t, o), t;
      };
    }(),
        c = n(0),
        s = o(c),
        u = n(1),
        d = o(u),
        p = n(3),
        f = n(4),
        m = n(45),
        g = o(m),
        y = function (e) {
      function t() {
        var e, n, o, a;
        r(this, t);

        for (var l = arguments.length, c = Array(l), s = 0; s < l; s++) {
          c[s] = arguments[s];
        }

        return n = o = i(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(c))), o.state = {
          expanded: !1,
          currentBlock: void 0
        }, o.onExpandEvent = function () {
          o.signalExpanded = !o.state.expanded;
        }, o.onChange = function (e) {
          "unordered" === e ? o.toggleBlockType("unordered-list-item") : "ordered" === e ? o.toggleBlockType("ordered-list-item") : "indent" === e ? o.adjustDepth(1) : o.adjustDepth(-1);
        }, o.expandCollapse = function () {
          o.setState({
            expanded: o.signalExpanded
          }), o.signalExpanded = !1;
        }, o.doExpand = function () {
          o.setState({
            expanded: !0
          });
        }, o.doCollapse = function () {
          o.setState({
            expanded: !1
          });
        }, o.toggleBlockType = function (e) {
          var t = o.props,
              n = t.onChange,
              r = t.editorState,
              i = p.RichUtils.toggleBlockType(r, e);
          i && n(i);
        }, o.adjustDepth = function (e) {
          var t = o.props,
              n = t.onChange,
              r = t.editorState,
              i = (0, f.changeDepth)(r, e, 4);
          i && n(i);
        }, o.isIndentDisabled = function () {
          var e = o.props.editorState,
              t = o.state.currentBlock,
              n = (0, f.getBlockBeforeSelectedBlock)(e);
          return !n || !(0, f.isListBlock)(t) || n.get("type") !== t.get("type") || n.get("depth") < t.get("depth");
        }, o.isOutdentDisabled = function () {
          var e = o.state.currentBlock;
          return !e || !(0, f.isListBlock)(e) || e.get("depth") <= 0;
        }, a = n, i(o, a);
      }

      return a(t, e), l(t, [{
        key: "componentWillMount",
        value: function value() {
          var e = this.props,
              t = e.editorState,
              n = e.modalHandler;
          t && this.setState({
            currentBlock: (0, f.getSelectedBlock)(t)
          }), n.registerCallBack(this.expandCollapse);
        }
      }, {
        key: "componentWillReceiveProps",
        value: function value(e) {
          if (e.editorState && this.props.editorState !== e.editorState) {
            (0, f.getSelectedBlock)(e.editorState);
            this.setState({
              currentBlock: (0, f.getSelectedBlock)(e.editorState)
            });
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.props.modalHandler.deregisterCallBack(this.expandCollapse);
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.config,
              n = e.translations,
              o = this.state,
              r = o.expanded,
              i = o.currentBlock,
              a = t.component || g.default,
              l = void 0;
          "unordered-list-item" === i.get("type") ? l = "unordered" : "ordered-list-item" === i.get("type") && (l = "ordered");
          var c = this.isIndentDisabled(),
              u = this.isOutdentDisabled();
          return s.default.createElement(a, {
            config: t,
            translations: n,
            currentState: {
              listType: l
            },
            expanded: r,
            onExpandEvent: this.onExpandEvent,
            doExpand: this.doExpand,
            doCollapse: this.doCollapse,
            onChange: this.onChange,
            indentDisabled: c,
            outdentDisabled: u
          });
        }
      }]), t;
    }(c.Component);

    y.propTypes = {
      onChange: d.default.func.isRequired,
      editorState: d.default.object.isRequired,
      modalHandler: d.default.object,
      config: d.default.object,
      translations: d.default.object
    }, t.default = y;
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var l = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }

      return function (t, n, o) {
        return n && e(t.prototype, n), o && e(t, o), t;
      };
    }(),
        c = n(0),
        s = o(c),
        u = n(1),
        d = o(u),
        p = n(2),
        f = o(p),
        m = n(8),
        g = n(7),
        y = n(5),
        h = o(y);

    n(46);

    var M = function (e) {
      function t() {
        var e, n, o, a;
        r(this, t);

        for (var l = arguments.length, c = Array(l), s = 0; s < l; s++) {
          c[s] = arguments[s];
        }

        return n = o = i(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(c))), o.options = ["unordered", "ordered", "indent", "outdent"], o.toggleBlockType = function (e) {
          (0, o.props.onChange)(e);
        }, o.indent = function () {
          (0, o.props.onChange)("indent");
        }, o.outdent = function () {
          (0, o.props.onChange)("outdent");
        }, a = n, i(o, a);
      }

      return a(t, e), l(t, [{
        key: "renderInFlatList",
        value: function value() {
          var e = this.props,
              t = e.config,
              n = e.currentState.listType,
              o = e.translations,
              r = e.indentDisabled,
              i = e.outdentDisabled,
              a = t.options,
              l = t.unordered,
              c = t.ordered,
              u = t.indent,
              d = t.outdent,
              p = t.className;
          return s.default.createElement("div", {
            className: (0, f.default)("rdw-list-wrapper", p),
            "aria-label": "rdw-list-control"
          }, a.indexOf("unordered") >= 0 && s.default.createElement(h.default, {
            value: "unordered",
            onClick: this.toggleBlockType,
            className: (0, f.default)(l.className),
            active: "unordered" === n,
            title: l.title || o["components.controls.list.unordered"]
          }, s.default.createElement("img", {
            src: l.icon,
            alt: ""
          })), a.indexOf("ordered") >= 0 && s.default.createElement(h.default, {
            value: "ordered",
            onClick: this.toggleBlockType,
            className: (0, f.default)(c.className),
            active: "ordered" === n,
            title: c.title || o["components.controls.list.ordered"]
          }, s.default.createElement("img", {
            src: c.icon,
            alt: ""
          })), a.indexOf("indent") >= 0 && s.default.createElement(h.default, {
            onClick: this.indent,
            disabled: r,
            className: (0, f.default)(u.className),
            title: u.title || o["components.controls.list.indent"]
          }, s.default.createElement("img", {
            src: u.icon,
            alt: ""
          })), a.indexOf("outdent") >= 0 && s.default.createElement(h.default, {
            onClick: this.outdent,
            disabled: i,
            className: (0, f.default)(d.className),
            title: d.title || o["components.controls.list.outdent"]
          }, s.default.createElement("img", {
            src: d.icon,
            alt: ""
          })));
        }
      }, {
        key: "renderInDropDown",
        value: function value() {
          var e = this,
              t = this.props,
              n = t.config,
              o = t.expanded,
              r = t.doCollapse,
              i = t.doExpand,
              a = t.onExpandEvent,
              l = t.onChange,
              c = t.currentState.listType,
              u = t.translations,
              d = n.options,
              p = n.className,
              y = n.dropdownClassName,
              h = n.title;
          return s.default.createElement(g.Dropdown, {
            className: (0, f.default)("rdw-list-dropdown", p),
            optionWrapperClassName: (0, f.default)(y),
            onChange: l,
            expanded: o,
            doExpand: i,
            doCollapse: r,
            onExpandEvent: a,
            "aria-label": "rdw-list-control",
            title: h || u["components.controls.list.list"]
          }, s.default.createElement("img", {
            src: (0, m.getFirstIcon)(n),
            alt: ""
          }), this.options.filter(function (e) {
            return d.indexOf(e) >= 0;
          }).map(function (t, o) {
            return s.default.createElement(g.DropdownOption, {
              key: o,
              value: t,
              disabled: e.props[t + "Disabled"],
              className: (0, f.default)("rdw-list-dropdownOption", n[t].className),
              active: c === t,
              title: n[t].title || u["components.controls.list." + t]
            }, s.default.createElement("img", {
              src: n[t].icon,
              alt: ""
            }));
          }));
        }
      }, {
        key: "render",
        value: function value() {
          return this.props.config.inDropdown ? this.renderInDropDown() : this.renderInFlatList();
        }
      }]), t;
    }(c.Component);

    M.propTypes = {
      expanded: d.default.bool,
      doExpand: d.default.func,
      doCollapse: d.default.func,
      onExpandEvent: d.default.func,
      config: d.default.object,
      onChange: d.default.func,
      currentState: d.default.object,
      translations: d.default.object,
      indentDisabled: d.default.bool,
      outdentDisabled: d.default.bool
    }, t.default = M;
  }, function (e, t) {
    e.exports = {
      "rdw-list-wrapper": "rdw-list-wrapper",
      "rdw-list-dropdown": "rdw-list-dropdown",
      "rdw-list-dropdownOption": "rdw-list-dropdownOption"
    };
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var l = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }

      return function (t, n, o) {
        return n && e(t.prototype, n), o && e(t, o), t;
      };
    }(),
        c = n(0),
        s = o(c),
        u = n(1),
        d = o(u),
        p = n(4),
        f = n(48),
        m = o(f),
        g = function (e) {
      function t() {
        var e, n, o, a;
        r(this, t);

        for (var l = arguments.length, c = Array(l), s = 0; s < l; s++) {
          c[s] = arguments[s];
        }

        return n = o = i(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(c))), o.state = {
          currentTextAlignment: void 0
        }, o.onExpandEvent = function () {
          o.signalExpanded = !o.state.expanded;
        }, o.expandCollapse = function () {
          o.setState({
            expanded: o.signalExpanded
          }), o.signalExpanded = !1;
        }, o.doExpand = function () {
          o.setState({
            expanded: !0
          });
        }, o.doCollapse = function () {
          o.setState({
            expanded: !1
          });
        }, o.addBlockAlignmentData = function (e) {
          var t = o.props,
              n = t.editorState,
              r = t.onChange;
          r(o.state.currentTextAlignment !== e ? (0, p.setBlockData)(n, {
            "text-align": e
          }) : (0, p.setBlockData)(n, {
            "text-align": void 0
          }));
        }, a = n, i(o, a);
      }

      return a(t, e), l(t, [{
        key: "componentWillMount",
        value: function value() {
          this.props.modalHandler.registerCallBack(this.expandCollapse);
        }
      }, {
        key: "componentWillReceiveProps",
        value: function value(e) {
          e.editorState !== this.props.editorState && this.setState({
            currentTextAlignment: (0, p.getSelectedBlocksMetadata)(e.editorState).get("text-align")
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.props.modalHandler.deregisterCallBack(this.expandCollapse);
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.config,
              n = e.translations,
              o = this.state,
              r = o.expanded,
              i = o.currentTextAlignment,
              a = t.component || m.default;
          return s.default.createElement(a, {
            config: t,
            translations: n,
            expanded: r,
            onExpandEvent: this.onExpandEvent,
            doExpand: this.doExpand,
            doCollapse: this.doCollapse,
            currentState: {
              textAlignment: i
            },
            onChange: this.addBlockAlignmentData
          });
        }
      }]), t;
    }(c.Component);

    g.propTypes = {
      editorState: d.default.object.isRequired,
      onChange: d.default.func.isRequired,
      modalHandler: d.default.object,
      config: d.default.object,
      translations: d.default.object
    }, t.default = g;
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var l = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }

      return function (t, n, o) {
        return n && e(t.prototype, n), o && e(t, o), t;
      };
    }(),
        c = n(0),
        s = o(c),
        u = n(1),
        d = o(u),
        p = n(2),
        f = o(p),
        m = n(5),
        g = o(m),
        y = n(7),
        h = n(8);

    n(49);

    var M = function (e) {
      function t() {
        return r(this, t), i(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return a(t, e), l(t, [{
        key: "renderInFlatList",
        value: function value() {
          var e = this.props,
              t = e.config,
              n = t.options,
              o = t.left,
              r = t.center,
              i = t.right,
              a = t.justify,
              l = t.className,
              c = e.onChange,
              u = e.currentState.textAlignment,
              d = e.translations;
          return s.default.createElement("div", {
            className: (0, f.default)("rdw-text-align-wrapper", l),
            "aria-label": "rdw-textalign-control"
          }, n.indexOf("left") >= 0 && s.default.createElement(g.default, {
            value: "left",
            className: (0, f.default)(o.className),
            active: "left" === u,
            onClick: c,
            title: o.title || d["components.controls.textalign.left"]
          }, s.default.createElement("img", {
            src: o.icon,
            alt: ""
          })), n.indexOf("center") >= 0 && s.default.createElement(g.default, {
            value: "center",
            className: (0, f.default)(r.className),
            active: "center" === u,
            onClick: c,
            title: r.title || d["components.controls.textalign.center"]
          }, s.default.createElement("img", {
            src: r.icon,
            alt: ""
          })), n.indexOf("right") >= 0 && s.default.createElement(g.default, {
            value: "right",
            className: (0, f.default)(i.className),
            active: "right" === u,
            onClick: c,
            title: i.title || d["components.controls.textalign.right"]
          }, s.default.createElement("img", {
            src: i.icon,
            alt: ""
          })), n.indexOf("justify") >= 0 && s.default.createElement(g.default, {
            value: "justify",
            className: (0, f.default)(a.className),
            active: "justify" === u,
            onClick: c,
            title: a.title || d["components.controls.textalign.justify"]
          }, s.default.createElement("img", {
            src: a.icon,
            alt: ""
          })));
        }
      }, {
        key: "renderInDropDown",
        value: function value() {
          var e = this.props,
              t = e.config,
              n = e.expanded,
              o = e.doExpand,
              r = e.onExpandEvent,
              i = e.doCollapse,
              a = e.currentState.textAlignment,
              l = e.onChange,
              c = e.translations,
              u = t.options,
              d = t.left,
              p = t.center,
              m = t.right,
              g = t.justify,
              M = t.className,
              b = t.dropdownClassName,
              j = t.title;
          return s.default.createElement(y.Dropdown, {
            className: (0, f.default)("rdw-text-align-dropdown", M),
            optionWrapperClassName: (0, f.default)(b),
            onChange: l,
            expanded: n,
            doExpand: o,
            doCollapse: i,
            onExpandEvent: r,
            "aria-label": "rdw-textalign-control",
            title: j || c["components.controls.textalign.textalign"]
          }, s.default.createElement("img", {
            src: a && t[a] && t[a].icon || (0, h.getFirstIcon)(t),
            alt: ""
          }), u.indexOf("left") >= 0 && s.default.createElement(y.DropdownOption, {
            value: "left",
            active: "left" === a,
            className: (0, f.default)("rdw-text-align-dropdownOption", d.className),
            title: d.title || c["components.controls.textalign.left"]
          }, s.default.createElement("img", {
            src: d.icon,
            alt: ""
          })), u.indexOf("center") >= 0 && s.default.createElement(y.DropdownOption, {
            value: "center",
            active: "center" === a,
            className: (0, f.default)("rdw-text-align-dropdownOption", p.className),
            title: p.title || c["components.controls.textalign.center"]
          }, s.default.createElement("img", {
            src: p.icon,
            alt: ""
          })), u.indexOf("right") >= 0 && s.default.createElement(y.DropdownOption, {
            value: "right",
            active: "right" === a,
            className: (0, f.default)("rdw-text-align-dropdownOption", m.className),
            title: m.title || c["components.controls.textalign.right"]
          }, s.default.createElement("img", {
            src: m.icon,
            alt: ""
          })), u.indexOf("justify") >= 0 && s.default.createElement(y.DropdownOption, {
            value: "justify",
            active: "justify" === a,
            className: (0, f.default)("rdw-text-align-dropdownOption", g.className),
            title: g.title || c["components.controls.textalign.justify"]
          }, s.default.createElement("img", {
            src: g.icon,
            alt: ""
          })));
        }
      }, {
        key: "render",
        value: function value() {
          return this.props.config.inDropdown ? this.renderInDropDown() : this.renderInFlatList();
        }
      }]), t;
    }(c.Component);

    M.propTypes = {
      expanded: d.default.bool,
      doExpand: d.default.func,
      doCollapse: d.default.func,
      onExpandEvent: d.default.func,
      config: d.default.object,
      onChange: d.default.func,
      currentState: d.default.object,
      translations: d.default.object
    }, t.default = M;
  }, function (e, t) {
    e.exports = {
      "rdw-text-align-wrapper": "rdw-text-align-wrapper",
      "rdw-text-align-dropdown": "rdw-text-align-dropdown",
      "rdw-text-align-dropdownOption": "rdw-text-align-dropdownOption",
      "rdw-right-aligned-block": "rdw-right-aligned-block",
      "rdw-left-aligned-block": "rdw-left-aligned-block",
      "rdw-center-aligned-block": "rdw-center-aligned-block",
      "rdw-justify-aligned-block": "rdw-justify-aligned-block"
    };
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var l = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }

      return function (t, n, o) {
        return n && e(t.prototype, n), o && e(t, o), t;
      };
    }(),
        c = n(0),
        s = o(c),
        u = n(1),
        d = o(u),
        p = n(4),
        f = n(51),
        m = o(f),
        g = function (e) {
      function t() {
        var e, n, o, a;
        r(this, t);

        for (var l = arguments.length, c = Array(l), s = 0; s < l; s++) {
          c[s] = arguments[s];
        }

        return n = o = i(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(c))), o.state = {
          expanded: !1,
          currentColor: void 0,
          currentBgColor: void 0
        }, o.onExpandEvent = function () {
          o.signalExpanded = !o.state.expanded;
        }, o.expandCollapse = function () {
          o.setState({
            expanded: o.signalExpanded
          }), o.signalExpanded = !1;
        }, o.doExpand = function () {
          o.setState({
            expanded: !0
          });
        }, o.doCollapse = function () {
          o.setState({
            expanded: !1
          });
        }, o.toggleColor = function (e, t) {
          var n = o.props,
              r = n.editorState,
              i = n.onChange,
              a = (0, p.toggleCustomInlineStyle)(r, e, t);
          a && i(a), o.doCollapse();
        }, a = n, i(o, a);
      }

      return a(t, e), l(t, [{
        key: "componentWillMount",
        value: function value() {
          var e = this.props,
              t = e.editorState,
              n = e.modalHandler;
          t && this.setState({
            currentColor: (0, p.getSelectionCustomInlineStyle)(t, ["COLOR"]).COLOR,
            currentBgColor: (0, p.getSelectionCustomInlineStyle)(t, ["BGCOLOR"]).BGCOLOR
          }), n.registerCallBack(this.expandCollapse);
        }
      }, {
        key: "componentWillReceiveProps",
        value: function value(e) {
          var t = {};
          e.editorState && this.props.editorState !== e.editorState && (t.currentColor = (0, p.getSelectionCustomInlineStyle)(e.editorState, ["COLOR"]).COLOR, t.currentBgColor = (0, p.getSelectionCustomInlineStyle)(e.editorState, ["BGCOLOR"]).BGCOLOR), this.setState(t);
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.props.modalHandler.deregisterCallBack(this.expandCollapse);
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.config,
              n = e.translations,
              o = this.state,
              r = o.currentColor,
              i = o.currentBgColor,
              a = o.expanded,
              l = t.component || m.default,
              c = r && r.substring(6),
              u = i && i.substring(8);
          return s.default.createElement(l, {
            config: t,
            translations: n,
            onChange: this.toggleColor,
            expanded: a,
            onExpandEvent: this.onExpandEvent,
            doExpand: this.doExpand,
            doCollapse: this.doCollapse,
            currentState: {
              color: c,
              bgColor: u
            }
          });
        }
      }]), t;
    }(c.Component);

    g.propTypes = {
      onChange: d.default.func.isRequired,
      editorState: d.default.object.isRequired,
      modalHandler: d.default.object,
      config: d.default.object,
      translations: d.default.object
    }, t.default = g;
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var l = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }

      return function (t, n, o) {
        return n && e(t.prototype, n), o && e(t, o), t;
      };
    }(),
        c = n(0),
        s = o(c),
        u = n(1),
        d = o(u),
        p = n(2),
        f = o(p),
        m = n(6),
        g = n(5),
        y = o(g);

    n(52);

    var h = function (e) {
      function t() {
        var e, n, o, a;
        r(this, t);

        for (var l = arguments.length, c = Array(l), u = 0; u < l; u++) {
          c[u] = arguments[u];
        }

        return n = o = i(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(c))), o.state = {
          currentStyle: "color"
        }, o.onChange = function (e) {
          (0, o.props.onChange)(o.state.currentStyle, e);
        }, o.setCurrentStyleColor = function () {
          o.setState({
            currentStyle: "color"
          });
        }, o.setCurrentStyleBgcolor = function () {
          o.setState({
            currentStyle: "bgcolor"
          });
        }, o.renderModal = function () {
          var e = o.props,
              t = e.config,
              n = t.popupClassName,
              r = t.colors,
              i = e.currentState,
              a = i.color,
              l = i.bgColor,
              c = e.translations,
              u = o.state.currentStyle,
              d = "color" === u ? a : l;
          return s.default.createElement("div", {
            className: (0, f.default)("rdw-colorpicker-modal", n),
            onClick: m.stopPropagation
          }, s.default.createElement("span", {
            className: "rdw-colorpicker-modal-header"
          }, s.default.createElement("span", {
            className: (0, f.default)("rdw-colorpicker-modal-style-label", {
              "rdw-colorpicker-modal-style-label-active": "color" === u
            }),
            onClick: o.setCurrentStyleColor
          }, c["components.controls.colorpicker.text"]), s.default.createElement("span", {
            className: (0, f.default)("rdw-colorpicker-modal-style-label", {
              "rdw-colorpicker-modal-style-label-active": "bgcolor" === u
            }),
            onClick: o.setCurrentStyleBgcolor
          }, c["components.controls.colorpicker.background"])), s.default.createElement("span", {
            className: "rdw-colorpicker-modal-options"
          }, r.map(function (e, t) {
            return s.default.createElement(y.default, {
              value: e,
              key: t,
              className: "rdw-colorpicker-option",
              activeClassName: "rdw-colorpicker-option-active",
              active: d === e,
              onClick: o.onChange
            }, s.default.createElement("span", {
              style: {
                backgroundColor: e
              },
              className: "rdw-colorpicker-cube"
            }));
          })));
        }, a = n, i(o, a);
      }

      return a(t, e), l(t, [{
        key: "componentWillReceiveProps",
        value: function value(e) {
          !this.props.expanded && e.expanded && this.setState({
            currentStyle: "color"
          });
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.config,
              n = t.icon,
              o = t.className,
              r = t.title,
              i = e.expanded,
              a = e.onExpandEvent,
              l = e.translations;
          return s.default.createElement("div", {
            className: "rdw-colorpicker-wrapper",
            "aria-haspopup": "true",
            "aria-expanded": i,
            "aria-label": "rdw-color-picker",
            title: r || l["components.controls.colorpicker.colorpicker"]
          }, s.default.createElement(y.default, {
            onClick: a,
            className: (0, f.default)(o)
          }, s.default.createElement("img", {
            src: n,
            alt: ""
          })), i ? this.renderModal() : void 0);
        }
      }]), t;
    }(c.Component);

    h.propTypes = {
      expanded: d.default.bool,
      onExpandEvent: d.default.func,
      onChange: d.default.func,
      config: d.default.object,
      currentState: d.default.object,
      translations: d.default.object
    }, t.default = h;
  }, function (e, t) {
    e.exports = {
      "rdw-colorpicker-wrapper": "rdw-colorpicker-wrapper",
      "rdw-colorpicker-modal": "rdw-colorpicker-modal",
      "rdw-colorpicker-modal-header": "rdw-colorpicker-modal-header",
      "rdw-colorpicker-modal-style-label": "rdw-colorpicker-modal-style-label",
      "rdw-colorpicker-modal-style-label-active": "rdw-colorpicker-modal-style-label-active",
      "rdw-colorpicker-modal-options": "rdw-colorpicker-modal-options",
      "rdw-colorpicker-cube": "rdw-colorpicker-cube",
      "rdw-colorpicker-option": "rdw-colorpicker-option",
      "rdw-colorpicker-option-active": "rdw-colorpicker-option-active"
    };
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var l = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }

      return function (t, n, o) {
        return n && e(t.prototype, n), o && e(t, o), t;
      };
    }(),
        c = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var o in n) {
          Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
        }
      }

      return e;
    },
        s = n(0),
        u = o(s),
        d = n(1),
        p = o(d),
        f = n(3),
        m = n(4),
        g = n(54),
        y = o(g),
        h = n(60),
        M = o(h),
        b = (0, y.default)(),
        j = function j(e) {
      var t = b.match(e.target);
      return c({}, e, {
        target: t && t[0] && t[0].url || e.target
      });
    },
        w = function (e) {
      function t() {
        var e, n, o, a;
        r(this, t);

        for (var l = arguments.length, c = Array(l), s = 0; s < l; s++) {
          c[s] = arguments[s];
        }

        return n = o = i(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(c))), o.state = {
          expanded: !1,
          link: void 0,
          selectionText: void 0
        }, o.onExpandEvent = function () {
          o.signalExpanded = !o.state.expanded;
        }, o.onChange = function (e, t, n, r) {
          var i = o.props.config.linkCallback;

          if ("link" === e) {
            var a = i || j,
                l = a({
              title: t,
              target: n,
              targetOption: r
            });
            o.addLink(l.title, l.target, l.targetOption);
          } else o.removeLink();
        }, o.getCurrentValues = function () {
          var e = o.props.editorState,
              t = o.state.currentEntity,
              n = e.getCurrentContent(),
              r = {};

          if (t && "LINK" === n.getEntity(t).get("type")) {
            r.link = {};
            var i = t && (0, m.getEntityRange)(e, t);
            r.link.target = t && n.getEntity(t).get("data").url, r.link.targetOption = t && n.getEntity(t).get("data").targetOption, r.link.title = i && i.text;
          }

          return r.selectionText = (0, m.getSelectionText)(e), r;
        }, o.doExpand = function () {
          o.setState({
            expanded: !0
          });
        }, o.expandCollapse = function () {
          o.setState({
            expanded: o.signalExpanded
          }), o.signalExpanded = !1;
        }, o.doCollapse = function () {
          o.setState({
            expanded: !1
          });
        }, o.removeLink = function () {
          var e = o.props,
              t = e.editorState,
              n = e.onChange,
              r = o.state.currentEntity,
              i = t.getSelection();

          if (r) {
            var a = (0, m.getEntityRange)(t, r);
            i = i.getIsBackward() ? i.merge({
              anchorOffset: a.end,
              focusOffset: a.start
            }) : i.merge({
              anchorOffset: a.start,
              focusOffset: a.end
            }), n(f.RichUtils.toggleLink(t, i, null));
          }
        }, o.addLink = function (e, t, n) {
          var r = o.props,
              i = r.editorState,
              a = r.onChange,
              l = o.state.currentEntity,
              c = i.getSelection();

          if (l) {
            var s = (0, m.getEntityRange)(i, l);
            c = c.getIsBackward() ? c.merge({
              anchorOffset: s.end,
              focusOffset: s.start
            }) : c.merge({
              anchorOffset: s.start,
              focusOffset: s.end
            });
          }

          var u = i.getCurrentContent().createEntity("LINK", "MUTABLE", {
            url: t,
            targetOption: n
          }).getLastCreatedEntityKey(),
              d = f.Modifier.replaceText(i.getCurrentContent(), c, "" + e, i.getCurrentInlineStyle(), u),
              p = f.EditorState.push(i, d, "insert-characters");
          c = p.getSelection().merge({
            anchorOffset: c.get("anchorOffset") + e.length,
            focusOffset: c.get("anchorOffset") + e.length
          }), p = f.EditorState.acceptSelection(p, c), d = f.Modifier.insertText(p.getCurrentContent(), c, " ", p.getCurrentInlineStyle(), void 0), a(f.EditorState.push(p, d, "insert-characters")), o.doCollapse();
        }, a = n, i(o, a);
      }

      return a(t, e), l(t, [{
        key: "componentWillMount",
        value: function value() {
          var e = this.props,
              t = e.editorState,
              n = e.modalHandler;
          t && this.setState({
            currentEntity: (0, m.getSelectionEntity)(t)
          }), n.registerCallBack(this.expandCollapse);
        }
      }, {
        key: "componentWillReceiveProps",
        value: function value(e) {
          var t = {};
          e.editorState && this.props.editorState !== e.editorState && (t.currentEntity = (0, m.getSelectionEntity)(e.editorState)), this.setState(t);
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.props.modalHandler.deregisterCallBack(this.expandCollapse);
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.config,
              n = e.translations,
              o = this.state.expanded,
              r = this.getCurrentValues(),
              i = r.link,
              a = r.selectionText,
              l = t.component || M.default;
          return u.default.createElement(l, {
            config: t,
            translations: n,
            expanded: o,
            onExpandEvent: this.onExpandEvent,
            doExpand: this.doExpand,
            doCollapse: this.doCollapse,
            currentState: {
              link: i,
              selectionText: a
            },
            onChange: this.onChange
          });
        }
      }]), t;
    }(s.Component);

    w.propTypes = {
      editorState: p.default.object.isRequired,
      onChange: p.default.func.isRequired,
      modalHandler: p.default.object,
      config: p.default.object,
      translations: p.default.object
    }, t.default = w;
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return Array.prototype.slice.call(arguments, 1).forEach(function (t) {
        t && Object.keys(t).forEach(function (n) {
          e[n] = t[n];
        });
      }), e;
    }

    function r(e) {
      return Object.prototype.toString.call(e);
    }

    function i(e) {
      return "[object String]" === r(e);
    }

    function a(e) {
      return "[object Object]" === r(e);
    }

    function l(e) {
      return "[object RegExp]" === r(e);
    }

    function c(e) {
      return "[object Function]" === r(e);
    }

    function s(e) {
      return e.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
    }

    function u(e) {
      return Object.keys(e || {}).reduce(function (e, t) {
        return e || M.hasOwnProperty(t);
      }, !1);
    }

    function d(e) {
      e.__index__ = -1, e.__text_cache__ = "";
    }

    function p(e) {
      return function (t, n) {
        var o = t.slice(n);
        return e.test(o) ? o.match(e)[0].length : 0;
      };
    }

    function f() {
      return function (e, t) {
        t.normalize(e);
      };
    }

    function m(e) {
      function t(e) {
        return e.replace("%TLDS%", r.src_tlds);
      }

      function o(e, t) {
        throw new Error('(LinkifyIt) Invalid schema "' + e + '": ' + t);
      }

      var r = e.re = n(55)(e.__opts__),
          u = e.__tlds__.slice();

      e.onCompile(), e.__tlds_replaced__ || u.push(j), u.push(r.src_xn), r.src_tlds = u.join("|"), r.email_fuzzy = RegExp(t(r.tpl_email_fuzzy), "i"), r.link_fuzzy = RegExp(t(r.tpl_link_fuzzy), "i"), r.link_no_ip_fuzzy = RegExp(t(r.tpl_link_no_ip_fuzzy), "i"), r.host_fuzzy_test = RegExp(t(r.tpl_host_fuzzy_test), "i");
      var m = [];
      e.__compiled__ = {}, Object.keys(e.__schemas__).forEach(function (t) {
        var n = e.__schemas__[t];

        if (null !== n) {
          var r = {
            validate: null,
            link: null
          };
          return e.__compiled__[t] = r, a(n) ? (l(n.validate) ? r.validate = p(n.validate) : c(n.validate) ? r.validate = n.validate : o(t, n), void (c(n.normalize) ? r.normalize = n.normalize : n.normalize ? o(t, n) : r.normalize = f())) : i(n) ? void m.push(t) : void o(t, n);
        }
      }), m.forEach(function (t) {
        e.__compiled__[e.__schemas__[t]] && (e.__compiled__[t].validate = e.__compiled__[e.__schemas__[t]].validate, e.__compiled__[t].normalize = e.__compiled__[e.__schemas__[t]].normalize);
      }), e.__compiled__[""] = {
        validate: null,
        normalize: f()
      };
      var g = Object.keys(e.__compiled__).filter(function (t) {
        return t.length > 0 && e.__compiled__[t];
      }).map(s).join("|");
      e.re.schema_test = RegExp("(^|(?!_)(?:[><｜]|" + r.src_ZPCc + "))(" + g + ")", "i"), e.re.schema_search = RegExp("(^|(?!_)(?:[><｜]|" + r.src_ZPCc + "))(" + g + ")", "ig"), e.re.pretest = RegExp("(" + e.re.schema_test.source + ")|(" + e.re.host_fuzzy_test.source + ")|@", "i"), d(e);
    }

    function g(e, t) {
      var n = e.__index__,
          o = e.__last_index__,
          r = e.__text_cache__.slice(n, o);

      this.schema = e.__schema__.toLowerCase(), this.index = n + t, this.lastIndex = o + t, this.raw = r, this.text = r, this.url = r;
    }

    function y(e, t) {
      var n = new g(e, t);
      return e.__compiled__[n.schema].normalize(n, e), n;
    }

    function h(e, t) {
      if (!(this instanceof h)) return new h(e, t);
      t || u(e) && (t = e, e = {}), this.__opts__ = o({}, M, t), this.__index__ = -1, this.__last_index__ = -1, this.__schema__ = "", this.__text_cache__ = "", this.__schemas__ = o({}, b, e), this.__compiled__ = {}, this.__tlds__ = w, this.__tlds_replaced__ = !1, this.re = {}, m(this);
    }

    var M = {
      fuzzyLink: !0,
      fuzzyEmail: !0,
      fuzzyIP: !1
    },
        b = {
      "http:": {
        validate: function validate(e, t, n) {
          var o = e.slice(t);
          return n.re.http || (n.re.http = new RegExp("^\\/\\/" + n.re.src_auth + n.re.src_host_port_strict + n.re.src_path, "i")), n.re.http.test(o) ? o.match(n.re.http)[0].length : 0;
        }
      },
      "https:": "http:",
      "ftp:": "http:",
      "//": {
        validate: function validate(e, t, n) {
          var o = e.slice(t);
          return n.re.no_http || (n.re.no_http = new RegExp("^" + n.re.src_auth + "(?:localhost|(?:(?:" + n.re.src_domain + ")\\.)+" + n.re.src_domain_root + ")" + n.re.src_port + n.re.src_host_terminator + n.re.src_path, "i")), n.re.no_http.test(o) ? t >= 3 && ":" === e[t - 3] ? 0 : t >= 3 && "/" === e[t - 3] ? 0 : o.match(n.re.no_http)[0].length : 0;
        }
      },
      "mailto:": {
        validate: function validate(e, t, n) {
          var o = e.slice(t);
          return n.re.mailto || (n.re.mailto = new RegExp("^" + n.re.src_email_name + "@" + n.re.src_host_strict, "i")), n.re.mailto.test(o) ? o.match(n.re.mailto)[0].length : 0;
        }
      }
    },
        j = "a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]",
        w = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф".split("|");
    h.prototype.add = function (e, t) {
      return this.__schemas__[e] = t, m(this), this;
    }, h.prototype.set = function (e) {
      return this.__opts__ = o(this.__opts__, e), this;
    }, h.prototype.test = function (e) {
      if (this.__text_cache__ = e, this.__index__ = -1, !e.length) return !1;
      var t, n, o, r, i, a, l, c;
      if (this.re.schema_test.test(e)) for (l = this.re.schema_search, l.lastIndex = 0; null !== (t = l.exec(e));) {
        if (r = this.testSchemaAt(e, t[2], l.lastIndex)) {
          this.__schema__ = t[2], this.__index__ = t.index + t[1].length, this.__last_index__ = t.index + t[0].length + r;
          break;
        }
      }
      return this.__opts__.fuzzyLink && this.__compiled__["http:"] && (c = e.search(this.re.host_fuzzy_test)) >= 0 && (this.__index__ < 0 || c < this.__index__) && null !== (n = e.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) && (i = n.index + n[1].length, (this.__index__ < 0 || i < this.__index__) && (this.__schema__ = "", this.__index__ = i, this.__last_index__ = n.index + n[0].length)), this.__opts__.fuzzyEmail && this.__compiled__["mailto:"] && e.indexOf("@") >= 0 && null !== (o = e.match(this.re.email_fuzzy)) && (i = o.index + o[1].length, a = o.index + o[0].length, (this.__index__ < 0 || i < this.__index__ || i === this.__index__ && a > this.__last_index__) && (this.__schema__ = "mailto:", this.__index__ = i, this.__last_index__ = a)), this.__index__ >= 0;
    }, h.prototype.pretest = function (e) {
      return this.re.pretest.test(e);
    }, h.prototype.testSchemaAt = function (e, t, n) {
      return this.__compiled__[t.toLowerCase()] ? this.__compiled__[t.toLowerCase()].validate(e, n, this) : 0;
    }, h.prototype.match = function (e) {
      var t = 0,
          n = [];
      this.__index__ >= 0 && this.__text_cache__ === e && (n.push(y(this, t)), t = this.__last_index__);

      for (var o = t ? e.slice(t) : e; this.test(o);) {
        n.push(y(this, t)), o = o.slice(this.__last_index__), t += this.__last_index__;
      }

      return n.length ? n : null;
    }, h.prototype.tlds = function (e, t) {
      return e = Array.isArray(e) ? e : [e], t ? (this.__tlds__ = this.__tlds__.concat(e).sort().filter(function (e, t, n) {
        return e !== n[t - 1];
      }).reverse(), m(this), this) : (this.__tlds__ = e.slice(), this.__tlds_replaced__ = !0, m(this), this);
    }, h.prototype.normalize = function (e) {
      e.schema || (e.url = "http://" + e.url), "mailto:" !== e.schema || /^mailto:/i.test(e.url) || (e.url = "mailto:" + e.url);
    }, h.prototype.onCompile = function () {}, e.exports = h;
  }, function (e, t, n) {
    "use strict";

    e.exports = function (e) {
      var t = {};
      t.src_Any = n(56).source, t.src_Cc = n(57).source, t.src_Z = n(58).source, t.src_P = n(59).source, t.src_ZPCc = [t.src_Z, t.src_P, t.src_Cc].join("|"), t.src_ZCc = [t.src_Z, t.src_Cc].join("|");
      return t.src_pseudo_letter = "(?:(?![><｜]|" + t.src_ZPCc + ")" + t.src_Any + ")", t.src_ip4 = "(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)", t.src_auth = "(?:(?:(?!" + t.src_ZCc + "|[@/\\[\\]()]).)+@)?", t.src_port = "(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?", t.src_host_terminator = "(?=$|[><｜]|" + t.src_ZPCc + ")(?!-|_|:\\d|\\.-|\\.(?!$|" + t.src_ZPCc + "))", t.src_path = "(?:[/?#](?:(?!" + t.src_ZCc + "|[><｜]|[()[\\]{}.,\"'?!\\-]).|\\[(?:(?!" + t.src_ZCc + "|\\]).)*\\]|\\((?:(?!" + t.src_ZCc + "|[)]).)*\\)|\\{(?:(?!" + t.src_ZCc + '|[}]).)*\\}|\\"(?:(?!' + t.src_ZCc + '|["]).)+\\"|\\\'(?:(?!' + t.src_ZCc + "|[']).)+\\'|\\'(?=" + t.src_pseudo_letter + "|[-]).|\\.{2,3}[a-zA-Z0-9%/]|\\.(?!" + t.src_ZCc + "|[.]).|" + (e && e["---"] ? "\\-(?!--(?:[^-]|$))(?:-*)|" : "\\-+|") + "\\,(?!" + t.src_ZCc + ").|\\!(?!" + t.src_ZCc + "|[!]).|\\?(?!" + t.src_ZCc + "|[?]).)+|\\/)?", t.src_email_name = '[\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]+', t.src_xn = "xn--[a-z0-9\\-]{1,59}", t.src_domain_root = "(?:" + t.src_xn + "|" + t.src_pseudo_letter + "{1,63})", t.src_domain = "(?:" + t.src_xn + "|(?:" + t.src_pseudo_letter + ")|(?:" + t.src_pseudo_letter + "(?:-(?!-)|" + t.src_pseudo_letter + "){0,61}" + t.src_pseudo_letter + "))", t.src_host = "(?:(?:(?:(?:" + t.src_domain + ")\\.)*" + t.src_domain + "))", t.tpl_host_fuzzy = "(?:" + t.src_ip4 + "|(?:(?:(?:" + t.src_domain + ")\\.)+(?:%TLDS%)))", t.tpl_host_no_ip_fuzzy = "(?:(?:(?:" + t.src_domain + ")\\.)+(?:%TLDS%))", t.src_host_strict = t.src_host + t.src_host_terminator, t.tpl_host_fuzzy_strict = t.tpl_host_fuzzy + t.src_host_terminator, t.src_host_port_strict = t.src_host + t.src_port + t.src_host_terminator, t.tpl_host_port_fuzzy_strict = t.tpl_host_fuzzy + t.src_port + t.src_host_terminator, t.tpl_host_port_no_ip_fuzzy_strict = t.tpl_host_no_ip_fuzzy + t.src_port + t.src_host_terminator, t.tpl_host_fuzzy_test = "localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:" + t.src_ZPCc + "|>|$))", t.tpl_email_fuzzy = "(^|[><｜]|\\(|" + t.src_ZCc + ")(" + t.src_email_name + "@" + t.tpl_host_fuzzy_strict + ")", t.tpl_link_fuzzy = "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + t.src_ZPCc + "))((?![$+<=>^`|｜])" + t.tpl_host_port_fuzzy_strict + t.src_path + ")", t.tpl_link_no_ip_fuzzy = "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + t.src_ZPCc + "))((?![$+<=>^`|｜])" + t.tpl_host_port_no_ip_fuzzy_strict + t.src_path + ")", t;
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
  }, function (e, t, n) {
    "use strict";

    e.exports = /[\0-\x1F\x7F-\x9F]/;
  }, function (e, t, n) {
    "use strict";

    e.exports = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
  }, function (e, t, n) {
    "use strict";

    e.exports = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E44\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD807[\uDC41-\uDC45\uDC70\uDC71]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function r(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    function i(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function a(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function l(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var c = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }

      return function (t, n, o) {
        return n && e(t.prototype, n), o && e(t, o), t;
      };
    }(),
        s = n(0),
        u = o(s),
        d = n(1),
        p = o(d),
        f = n(2),
        m = o(f),
        g = n(6),
        y = n(8),
        h = n(5),
        M = o(h),
        b = n(7);

    n(61);

    var j = function (e) {
      function t() {
        var e, n, o, l;
        i(this, t);

        for (var c = arguments.length, s = Array(c), u = 0; u < c; u++) {
          s[u] = arguments[u];
        }

        return n = o = a(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(s))), o.state = {
          showModal: !1,
          linkTarget: "",
          linkTitle: "",
          linkTargetOption: o.props.config.defaultTargetOption
        }, o.removeLink = function () {
          (0, o.props.onChange)("unlink");
        }, o.addLink = function () {
          var e = o.props.onChange,
              t = o.state;
          e("link", t.linkTitle, t.linkTarget, t.linkTargetOption);
        }, o.updateValue = function (e) {
          o.setState(r({}, "" + e.target.name, e.target.value));
        }, o.updateTargetOption = function (e) {
          o.setState({
            linkTargetOption: e.target.checked ? "_blank" : "_self"
          });
        }, o.hideModal = function () {
          o.setState({
            showModal: !1
          });
        }, o.signalExpandShowModal = function () {
          var e = o.props,
              t = e.onExpandEvent,
              n = e.currentState,
              r = n.link,
              i = n.selectionText,
              a = o.state.linkTargetOption;
          t(), o.setState({
            showModal: !0,
            linkTarget: r && r.target || "",
            linkTargetOption: r && r.targetOption || a,
            linkTitle: r && r.title || i
          });
        }, o.forceExpandAndShowModal = function () {
          var e = o.props,
              t = e.doExpand,
              n = e.currentState,
              r = n.link,
              i = n.selectionText,
              a = o.state.linkTargetOption;
          t(), o.setState({
            showModal: !0,
            linkTarget: r && r.target,
            linkTargetOption: r && r.targetOption || a,
            linkTitle: r && r.title || i
          });
        }, l = n, a(o, l);
      }

      return l(t, e), c(t, [{
        key: "componentWillReceiveProps",
        value: function value(e) {
          this.props.expanded && !e.expanded && this.setState({
            showModal: !1,
            linkTarget: "",
            linkTitle: "",
            linkTargetOption: this.props.config.defaultTargetOption
          });
        }
      }, {
        key: "renderAddLinkModal",
        value: function value() {
          var e = this.props,
              t = e.config.popupClassName,
              n = e.doCollapse,
              o = e.translations,
              r = this.state,
              i = r.linkTitle,
              a = r.linkTarget,
              l = r.linkTargetOption;
          return u.default.createElement("div", {
            className: (0, m.default)("rdw-link-modal", t),
            onClick: g.stopPropagation
          }, u.default.createElement("label", {
            className: "rdw-link-modal-label",
            htmlFor: "linkTitle"
          }, o["components.controls.link.linkTitle"]), u.default.createElement("input", {
            id: "linkTitle",
            className: "rdw-link-modal-input",
            onChange: this.updateValue,
            onBlur: this.updateValue,
            name: "linkTitle",
            value: i
          }), u.default.createElement("label", {
            className: "rdw-link-modal-label",
            htmlFor: "linkTarget"
          }, o["components.controls.link.linkTarget"]), u.default.createElement("input", {
            id: "linkTarget",
            className: "rdw-link-modal-input",
            onChange: this.updateValue,
            onBlur: this.updateValue,
            name: "linkTarget",
            value: a
          }), u.default.createElement("label", {
            className: "rdw-link-modal-target-option",
            htmlFor: "openLinkInNewWindow"
          }, u.default.createElement("input", {
            id: "openLinkInNewWindow",
            type: "checkbox",
            defaultChecked: "_blank" === l,
            value: "_blank",
            onChange: this.updateTargetOption
          }), u.default.createElement("span", null, o["components.controls.link.linkTargetOption"])), u.default.createElement("span", {
            className: "rdw-link-modal-buttonsection"
          }, u.default.createElement("button", {
            className: "rdw-link-modal-btn",
            onClick: this.addLink,
            disabled: !a || !i
          }, o["generic.add"]), u.default.createElement("button", {
            className: "rdw-link-modal-btn",
            onClick: n
          }, o["generic.cancel"])));
        }
      }, {
        key: "renderInFlatList",
        value: function value() {
          var e = this.props,
              t = e.config,
              n = t.options,
              o = t.link,
              r = t.unlink,
              i = t.className,
              a = e.currentState,
              l = e.expanded,
              c = e.translations,
              s = this.state.showModal;
          return u.default.createElement("div", {
            className: (0, m.default)("rdw-link-wrapper", i),
            "aria-label": "rdw-link-control"
          }, n.indexOf("link") >= 0 && u.default.createElement(M.default, {
            value: "unordered-list-item",
            className: (0, m.default)(o.className),
            onClick: this.signalExpandShowModal,
            "aria-haspopup": "true",
            "aria-expanded": s,
            title: o.title || c["components.controls.link.link"]
          }, u.default.createElement("img", {
            src: o.icon,
            alt: ""
          })), n.indexOf("unlink") >= 0 && u.default.createElement(M.default, {
            disabled: !a.link,
            value: "ordered-list-item",
            className: (0, m.default)(r.className),
            onClick: this.removeLink,
            title: r.title || c["components.controls.link.unlink"]
          }, u.default.createElement("img", {
            src: r.icon,
            alt: ""
          })), l && s ? this.renderAddLinkModal() : void 0);
        }
      }, {
        key: "renderInDropDown",
        value: function value() {
          var e = this.props,
              t = e.expanded,
              n = e.onExpandEvent,
              o = e.doCollapse,
              r = e.doExpand,
              i = e.onChange,
              a = e.config,
              l = e.currentState,
              c = e.translations,
              s = a.options,
              d = a.link,
              p = a.unlink,
              f = a.className,
              g = a.dropdownClassName,
              h = a.title,
              M = this.state.showModal;
          return u.default.createElement("div", {
            className: "rdw-link-wrapper",
            "aria-haspopup": "true",
            "aria-label": "rdw-link-control",
            "aria-expanded": t,
            title: h
          }, u.default.createElement(b.Dropdown, {
            className: (0, m.default)("rdw-link-dropdown", f),
            optionWrapperClassName: (0, m.default)(g),
            onChange: i,
            expanded: t && !M,
            doExpand: r,
            doCollapse: o,
            onExpandEvent: n
          }, u.default.createElement("img", {
            src: (0, y.getFirstIcon)(a),
            alt: ""
          }), s.indexOf("link") >= 0 && u.default.createElement(b.DropdownOption, {
            onClick: this.forceExpandAndShowModal,
            className: (0, m.default)("rdw-link-dropdownoption", d.className),
            title: d.title || c["components.controls.link.link"]
          }, u.default.createElement("img", {
            src: d.icon,
            alt: ""
          })), s.indexOf("unlink") >= 0 && u.default.createElement(b.DropdownOption, {
            onClick: this.removeLink,
            disabled: !l.link,
            className: (0, m.default)("rdw-link-dropdownoption", p.className),
            title: p.title || c["components.controls.link.unlink"]
          }, u.default.createElement("img", {
            src: p.icon,
            alt: ""
          }))), t && M ? this.renderAddLinkModal() : void 0);
        }
      }, {
        key: "render",
        value: function value() {
          return this.props.config.inDropdown ? this.renderInDropDown() : this.renderInFlatList();
        }
      }]), t;
    }(s.Component);

    j.propTypes = {
      expanded: p.default.bool,
      doExpand: p.default.func,
      doCollapse: p.default.func,
      onExpandEvent: p.default.func,
      config: p.default.object,
      onChange: p.default.func,
      currentState: p.default.object,
      translations: p.default.object
    }, t.default = j;
  }, function (e, t) {
    e.exports = {
      "rdw-link-wrapper": "rdw-link-wrapper",
      "rdw-link-dropdown": "rdw-link-dropdown",
      "rdw-link-dropdownOption": "rdw-link-dropdownOption",
      "rdw-link-dropdownPlaceholder": "rdw-link-dropdownPlaceholder",
      "rdw-link-modal": "rdw-link-modal",
      "rdw-link-modal-label": "rdw-link-modal-label",
      "rdw-link-modal-input": "rdw-link-modal-input",
      "rdw-link-modal-buttonsection": "rdw-link-modal-buttonsection",
      "rdw-link-modal-target-option": "rdw-link-modal-target-option",
      "rdw-link-modal-btn": "rdw-link-modal-btn",
      "rdw-link-dropdownoption": "rdw-link-dropdownoption",
      "rdw-history-dropdown": "rdw-history-dropdown"
    };
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var l = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }

      return function (t, n, o) {
        return n && e(t.prototype, n), o && e(t, o), t;
      };
    }(),
        c = n(0),
        s = o(c),
        u = n(1),
        d = o(u),
        p = n(3),
        f = n(63),
        m = o(f),
        g = function (e) {
      function t() {
        var e, n, o, a;
        r(this, t);

        for (var l = arguments.length, c = Array(l), s = 0; s < l; s++) {
          c[s] = arguments[s];
        }

        return n = o = i(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(c))), o.state = {
          expanded: !1
        }, o.onExpandEvent = function () {
          o.signalExpanded = !o.state.expanded;
        }, o.expandCollapse = function () {
          o.setState({
            expanded: o.signalExpanded
          }), o.signalExpanded = !1;
        }, o.doExpand = function () {
          o.setState({
            expanded: !0
          });
        }, o.doCollapse = function () {
          o.setState({
            expanded: !1
          });
        }, o.addEmbeddedLink = function (e, t, n) {
          var r = o.props,
              i = r.editorState,
              a = r.onChange,
              l = r.config.embedCallback,
              c = l ? l(e) : e,
              s = i.getCurrentContent().createEntity("EMBEDDED_LINK", "MUTABLE", {
            src: c,
            height: t,
            width: n
          }).getLastCreatedEntityKey();
          a(p.AtomicBlockUtils.insertAtomicBlock(i, s, " ")), o.doCollapse();
        }, a = n, i(o, a);
      }

      return a(t, e), l(t, [{
        key: "componentWillMount",
        value: function value() {
          this.props.modalHandler.registerCallBack(this.expandCollapse);
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.props.modalHandler.deregisterCallBack(this.expandCollapse);
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.config,
              n = e.translations,
              o = this.state.expanded,
              r = t.component || m.default;
          return s.default.createElement(r, {
            config: t,
            translations: n,
            onChange: this.addEmbeddedLink,
            expanded: o,
            onExpandEvent: this.onExpandEvent,
            doExpand: this.doExpand,
            doCollapse: this.doCollapse
          });
        }
      }]), t;
    }(c.Component);

    g.propTypes = {
      editorState: d.default.object.isRequired,
      onChange: d.default.func.isRequired,
      modalHandler: d.default.object,
      config: d.default.object,
      translations: d.default.object
    }, t.default = g;
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function r(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    function i(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function a(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function l(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var c = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }

      return function (t, n, o) {
        return n && e(t.prototype, n), o && e(t, o), t;
      };
    }(),
        s = n(0),
        u = o(s),
        d = n(1),
        p = o(d),
        f = n(2),
        m = o(f),
        g = n(6),
        y = n(5),
        h = o(y);

    n(64);

    var M = function (e) {
      function t() {
        var e, n, o, l;
        i(this, t);

        for (var c = arguments.length, s = Array(c), u = 0; u < c; u++) {
          s[u] = arguments[u];
        }

        return n = o = a(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(s))), o.state = {
          embeddedLink: "",
          height: o.props.config.defaultSize.height,
          width: o.props.config.defaultSize.width
        }, o.onChange = function () {
          var e = o.props.onChange,
              t = o.state;
          e(t.embeddedLink, t.height, t.width);
        }, o.updateValue = function (e) {
          o.setState(r({}, "" + e.target.name, e.target.value));
        }, l = n, a(o, l);
      }

      return l(t, e), c(t, [{
        key: "componentWillReceiveProps",
        value: function value(e) {
          if (this.props.expanded && !e.expanded) {
            var t = this.props.config.defaultSize,
                n = t.height,
                o = t.width;
            this.setState({
              embeddedLink: "",
              height: n,
              width: o
            });
          }
        }
      }, {
        key: "rendeEmbeddedLinkModal",
        value: function value() {
          var e = this.state,
              t = e.embeddedLink,
              n = e.height,
              o = e.width,
              r = this.props,
              i = r.config.popupClassName,
              a = r.doCollapse,
              l = r.translations;
          return u.default.createElement("div", {
            className: (0, m.default)("rdw-embedded-modal", i),
            onClick: g.stopPropagation
          }, u.default.createElement("div", {
            className: "rdw-embedded-modal-header"
          }, u.default.createElement("span", {
            className: "rdw-embedded-modal-header-option"
          }, l["components.controls.embedded.embeddedlink"], u.default.createElement("span", {
            className: "rdw-embedded-modal-header-label"
          }))), u.default.createElement("div", {
            className: "rdw-embedded-modal-link-section"
          }, u.default.createElement("span", {
            className: "rdw-embedded-modal-link-input-wrapper"
          }, u.default.createElement("input", {
            className: "rdw-embedded-modal-link-input",
            placeholder: l["components.controls.embedded.enterlink"],
            onChange: this.updateValue,
            onBlur: this.updateValue,
            value: t,
            name: "embeddedLink"
          }), u.default.createElement("span", {
            className: "rdw-image-mandatory-sign"
          }, "*")), u.default.createElement("div", {
            className: "rdw-embedded-modal-size"
          }, u.default.createElement("span", null, u.default.createElement("input", {
            onChange: this.updateValue,
            onBlur: this.updateValue,
            value: n,
            name: "height",
            className: "rdw-embedded-modal-size-input",
            placeholder: "Height"
          }), u.default.createElement("span", {
            className: "rdw-image-mandatory-sign"
          }, "*")), u.default.createElement("span", null, u.default.createElement("input", {
            onChange: this.updateValue,
            onBlur: this.updateValue,
            value: o,
            name: "width",
            className: "rdw-embedded-modal-size-input",
            placeholder: "Width"
          }), u.default.createElement("span", {
            className: "rdw-image-mandatory-sign"
          }, "*")))), u.default.createElement("span", {
            className: "rdw-embedded-modal-btn-section"
          }, u.default.createElement("button", {
            type: "button",
            className: "rdw-embedded-modal-btn",
            onClick: this.onChange,
            disabled: !t || !n || !o
          }, l["generic.add"]), u.default.createElement("button", {
            type: "button",
            className: "rdw-embedded-modal-btn",
            onClick: a
          }, l["generic.cancel"])));
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.config,
              n = t.icon,
              o = t.className,
              r = t.title,
              i = e.expanded,
              a = e.onExpandEvent,
              l = e.translations;
          return u.default.createElement("div", {
            className: "rdw-embedded-wrapper",
            "aria-haspopup": "true",
            "aria-expanded": i,
            "aria-label": "rdw-embedded-control"
          }, u.default.createElement(h.default, {
            className: (0, m.default)(o),
            value: "unordered-list-item",
            onClick: a,
            title: r || l["components.controls.embedded.embedded"]
          }, u.default.createElement("img", {
            src: n,
            alt: ""
          })), i ? this.rendeEmbeddedLinkModal() : void 0);
        }
      }]), t;
    }(s.Component);

    M.propTypes = {
      expanded: p.default.bool,
      onExpandEvent: p.default.func,
      onChange: p.default.func,
      config: p.default.object,
      translations: p.default.object,
      doCollapse: p.default.func
    }, t.default = M;
  }, function (e, t) {
    e.exports = {
      "rdw-embedded-wrapper": "rdw-embedded-wrapper",
      "rdw-embedded-modal": "rdw-embedded-modal",
      "rdw-embedded-modal-header": "rdw-embedded-modal-header",
      "rdw-embedded-modal-header-option": "rdw-embedded-modal-header-option",
      "rdw-embedded-modal-header-label": "rdw-embedded-modal-header-label",
      "rdw-embedded-modal-link-section": "rdw-embedded-modal-link-section",
      "rdw-embedded-modal-link-input": "rdw-embedded-modal-link-input",
      "rdw-embedded-modal-link-input-wrapper": "rdw-embedded-modal-link-input-wrapper",
      "rdw-embedded-modal-btn-section": "rdw-embedded-modal-btn-section",
      "rdw-embedded-modal-btn": "rdw-embedded-modal-btn",
      "rdw-embedded-modal-size": "rdw-embedded-modal-size",
      "rdw-embedded-modal-size-input": "rdw-embedded-modal-size-input"
    };
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var l = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }

      return function (t, n, o) {
        return n && e(t.prototype, n), o && e(t, o), t;
      };
    }(),
        c = n(0),
        s = o(c),
        u = n(1),
        d = o(u),
        p = n(3),
        f = n(66),
        m = o(f),
        g = function (e) {
      function t() {
        var e, n, o, a;
        r(this, t);

        for (var l = arguments.length, c = Array(l), s = 0; s < l; s++) {
          c[s] = arguments[s];
        }

        return n = o = i(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(c))), o.state = {
          expanded: !1
        }, o.onExpandEvent = function () {
          o.signalExpanded = !o.state.expanded;
        }, o.expandCollapse = function () {
          o.setState({
            expanded: o.signalExpanded
          }), o.signalExpanded = !1;
        }, o.doExpand = function () {
          o.setState({
            expanded: !0
          });
        }, o.doCollapse = function () {
          o.setState({
            expanded: !1
          });
        }, o.addEmoji = function (e) {
          var t = o.props,
              n = t.editorState,
              r = t.onChange,
              i = p.Modifier.replaceText(n.getCurrentContent(), n.getSelection(), e, n.getCurrentInlineStyle());
          r(p.EditorState.push(n, i, "insert-characters")), o.doCollapse();
        }, a = n, i(o, a);
      }

      return a(t, e), l(t, [{
        key: "componentWillMount",
        value: function value() {
          this.props.modalHandler.registerCallBack(this.expandCollapse);
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.props.modalHandler.deregisterCallBack(this.expandCollapse);
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.config,
              n = e.translations,
              o = this.state.expanded,
              r = t.component || m.default;
          return s.default.createElement(r, {
            config: t,
            translations: n,
            onChange: this.addEmoji,
            expanded: o,
            onExpandEvent: this.onExpandEvent,
            doExpand: this.doExpand,
            doCollapse: this.doCollapse,
            onCollpase: this.closeModal
          });
        }
      }]), t;
    }(c.Component);

    g.propTypes = {
      editorState: d.default.object.isRequired,
      onChange: d.default.func.isRequired,
      modalHandler: d.default.object,
      config: d.default.object,
      translations: d.default.object
    }, t.default = g;
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var l = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }

      return function (t, n, o) {
        return n && e(t.prototype, n), o && e(t, o), t;
      };
    }(),
        c = n(0),
        s = o(c),
        u = n(1),
        d = o(u),
        p = n(2),
        f = o(p),
        m = n(6),
        g = n(5),
        y = o(g);

    n(67);

    var h = function (e) {
      function t() {
        var e, n, o, a;
        r(this, t);

        for (var l = arguments.length, c = Array(l), s = 0; s < l; s++) {
          c[s] = arguments[s];
        }

        return n = o = i(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(c))), o.onChange = function (e) {
          (0, o.props.onChange)(e.target.innerHTML);
        }, a = n, i(o, a);
      }

      return a(t, e), l(t, [{
        key: "renderEmojiModal",
        value: function value() {
          var e = this,
              t = this.props.config,
              n = t.popupClassName,
              o = t.emojis;
          return s.default.createElement("div", {
            className: (0, f.default)("rdw-emoji-modal", n),
            onClick: m.stopPropagation
          }, o.map(function (t, n) {
            return s.default.createElement("span", {
              key: n,
              className: "rdw-emoji-icon",
              alt: "",
              onClick: e.onChange
            }, t);
          }));
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.config,
              n = t.icon,
              o = t.className,
              r = t.title,
              i = e.expanded,
              a = e.onExpandEvent,
              l = e.translations;
          return s.default.createElement("div", {
            className: "rdw-emoji-wrapper",
            "aria-haspopup": "true",
            "aria-label": "rdw-emoji-control",
            "aria-expanded": i,
            title: r || l["components.controls.emoji.emoji"]
          }, s.default.createElement(y.default, {
            className: (0, f.default)(o),
            value: "unordered-list-item",
            onClick: a
          }, s.default.createElement("img", {
            src: n,
            alt: ""
          })), i ? this.renderEmojiModal() : void 0);
        }
      }]), t;
    }(c.Component);

    h.propTypes = {
      expanded: d.default.bool,
      onExpandEvent: d.default.func,
      onChange: d.default.func,
      config: d.default.object,
      translations: d.default.object
    }, t.default = h;
  }, function (e, t) {
    e.exports = {
      "rdw-emoji-wrapper": "rdw-emoji-wrapper",
      "rdw-emoji-modal": "rdw-emoji-modal",
      "rdw-emoji-icon": "rdw-emoji-icon"
    };
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var l = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }

      return function (t, n, o) {
        return n && e(t.prototype, n), o && e(t, o), t;
      };
    }(),
        c = n(0),
        s = o(c),
        u = n(1),
        d = o(u),
        p = n(3),
        f = n(69),
        m = o(f),
        g = function (e) {
      function t() {
        var e, n, o, a;
        r(this, t);

        for (var l = arguments.length, c = Array(l), s = 0; s < l; s++) {
          c[s] = arguments[s];
        }

        return n = o = i(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(c))), o.state = {
          expanded: !1
        }, o.onExpandEvent = function () {
          o.signalExpanded = !o.state.expanded;
        }, o.doExpand = function () {
          o.setState({
            expanded: !0
          });
        }, o.doCollapse = function () {
          o.setState({
            expanded: !1
          });
        }, o.expandCollapse = function () {
          o.setState({
            expanded: o.signalExpanded
          }), o.signalExpanded = !1;
        }, o.addImage = function (e, t, n, r) {
          var i = o.props,
              a = i.editorState,
              l = i.onChange,
              c = i.config,
              s = {
            src: e,
            height: t,
            width: n
          };
          c.alt.present && (s.alt = r);
          var u = a.getCurrentContent().createEntity("IMAGE", "MUTABLE", s).getLastCreatedEntityKey();
          l(p.AtomicBlockUtils.insertAtomicBlock(a, u, " ")), o.doCollapse();
        }, a = n, i(o, a);
      }

      return a(t, e), l(t, [{
        key: "componentWillMount",
        value: function value() {
          this.props.modalHandler.registerCallBack(this.expandCollapse);
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.props.modalHandler.deregisterCallBack(this.expandCollapse);
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.config,
              n = e.translations,
              o = this.state.expanded,
              r = t.component || m.default;
          return s.default.createElement(r, {
            config: t,
            translations: n,
            onChange: this.addImage,
            expanded: o,
            onExpandEvent: this.onExpandEvent,
            doExpand: this.doExpand,
            doCollapse: this.doCollapse
          });
        }
      }]), t;
    }(c.Component);

    g.propTypes = {
      editorState: d.default.object.isRequired,
      onChange: d.default.func.isRequired,
      modalHandler: d.default.object,
      config: d.default.object,
      translations: d.default.object
    }, t.default = g;
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function r(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    function i(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function a(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function l(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var c = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }

      return function (t, n, o) {
        return n && e(t.prototype, n), o && e(t, o), t;
      };
    }(),
        s = n(0),
        u = o(s),
        d = n(1),
        p = o(d),
        f = n(2),
        m = o(f),
        g = n(5),
        y = o(g),
        h = n(70),
        M = o(h);

    n(72);

    var b = function (e) {
      function t() {
        var e, n, o, l;
        i(this, t);

        for (var c = arguments.length, s = Array(c), u = 0; u < c; u++) {
          s[u] = arguments[u];
        }

        return n = o = a(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(s))), o.state = {
          imgSrc: "",
          dragEnter: !1,
          uploadHighlighted: o.props.config.uploadEnabled && !!o.props.config.uploadCallback,
          showImageLoading: !1,
          height: o.props.config.defaultSize.height,
          width: o.props.config.defaultSize.width,
          alt: ""
        }, o.onDragEnter = function (e) {
          o.stopPropagation(e), o.setState({
            dragEnter: !0
          });
        }, o.onImageDrop = function (e) {
          e.preventDefault(), e.stopPropagation(), o.setState({
            dragEnter: !1
          });
          var t = void 0,
              n = void 0;
          e.dataTransfer.items ? (t = e.dataTransfer.items, n = !0) : (t = e.dataTransfer.files, n = !1);

          for (var r = 0; r < t.length; r += 1) {
            if ((!n || "file" === t[r].kind) && t[r].type.match("^image/")) {
              var i = n ? t[r].getAsFile() : t[r];
              o.uploadImage(i);
            }
          }
        }, o.showImageUploadOption = function () {
          o.setState({
            uploadHighlighted: !0
          });
        }, o.addImageFromState = function () {
          var e = o.state,
              t = e.imgSrc,
              n = e.alt,
              r = o.state,
              i = r.height,
              a = r.width,
              l = o.props.onChange;
          isNaN(i) || (i += "px"), isNaN(a) || (a += "px"), l(t, i, a, n);
        }, o.showImageURLOption = function () {
          o.setState({
            uploadHighlighted: !1
          });
        }, o.toggleShowImageLoading = function () {
          var e = !o.state.showImageLoading;
          o.setState({
            showImageLoading: e
          });
        }, o.updateValue = function (e) {
          o.setState(r({}, "" + e.target.name, e.target.value));
        }, o.selectImage = function (e) {
          e.target.files && e.target.files.length > 0 && o.uploadImage(e.target.files[0]);
        }, o.uploadImage = function (e) {
          o.toggleShowImageLoading(), (0, o.props.config.uploadCallback)(e).then(function (e) {
            var t = e.data;
            o.setState({
              showImageLoading: !1,
              dragEnter: !1,
              imgSrc: t.link || t.url
            }), o.fileUpload = !1;
          }).catch(function () {
            o.setState({
              showImageLoading: !1,
              dragEnter: !1
            });
          });
        }, o.fileUploadClick = function (e) {
          o.fileUpload = !0, e.stopPropagation();
        }, o.stopPropagation = function (e) {
          o.fileUpload ? o.fileUpload = !1 : (e.preventDefault(), e.stopPropagation());
        }, l = n, a(o, l);
      }

      return l(t, e), c(t, [{
        key: "componentWillReceiveProps",
        value: function value(e) {
          this.props.expanded && !e.expanded ? this.setState({
            imgSrc: "",
            dragEnter: !1,
            uploadHighlighted: this.props.config.uploadEnabled && !!this.props.config.uploadCallback,
            showImageLoading: !1,
            height: this.props.config.defaultSize.height,
            width: this.props.config.defaultSize.width,
            alt: ""
          }) : e.config.uploadCallback === this.props.config.uploadCallback && e.config.uploadEnabled === this.props.config.uploadEnabled || this.setState({
            uploadHighlighted: e.config.uploadEnabled && !!e.config.uploadCallback
          });
        }
      }, {
        key: "renderAddImageModal",
        value: function value() {
          var e = this.state,
              t = e.imgSrc,
              n = e.uploadHighlighted,
              o = e.showImageLoading,
              r = e.dragEnter,
              i = e.height,
              a = e.width,
              l = e.alt,
              c = this.props,
              s = c.config,
              d = s.popupClassName,
              p = s.uploadCallback,
              f = s.uploadEnabled,
              g = s.urlEnabled,
              y = s.previewImage,
              h = s.inputAccept,
              b = s.alt,
              j = c.doCollapse,
              w = c.translations;
          return u.default.createElement("div", {
            className: (0, m.default)("rdw-image-modal", d),
            onClick: this.stopPropagation
          }, u.default.createElement("div", {
            className: "rdw-image-modal-header"
          }, f && p && u.default.createElement("span", {
            onClick: this.showImageUploadOption,
            className: "rdw-image-modal-header-option"
          }, w["components.controls.image.fileUpload"], u.default.createElement("span", {
            className: (0, m.default)("rdw-image-modal-header-label", {
              "rdw-image-modal-header-label-highlighted": n
            })
          })), g && u.default.createElement("span", {
            onClick: this.showImageURLOption,
            className: "rdw-image-modal-header-option"
          }, w["components.controls.image.byURL"], u.default.createElement("span", {
            className: (0, m.default)("rdw-image-modal-header-label", {
              "rdw-image-modal-header-label-highlighted": !n
            })
          }))), n ? u.default.createElement("div", {
            onClick: this.fileUploadClick
          }, u.default.createElement("div", {
            onDragEnter: this.onDragEnter,
            onDragOver: this.stopPropagation,
            onDrop: this.onImageDrop,
            className: (0, m.default)("rdw-image-modal-upload-option", {
              "rdw-image-modal-upload-option-highlighted": r
            })
          }, u.default.createElement("label", {
            htmlFor: "file",
            className: "rdw-image-modal-upload-option-label"
          }, y && t ? u.default.createElement("img", {
            src: t,
            alt: t,
            className: "rdw-image-modal-upload-option-image-preview"
          }) : t || w["components.controls.image.dropFileText"])), u.default.createElement("input", {
            type: "file",
            id: "file",
            accept: h,
            onChange: this.selectImage,
            className: "rdw-image-modal-upload-option-input"
          })) : u.default.createElement("div", {
            className: "rdw-image-modal-url-section"
          }, u.default.createElement("input", {
            className: "rdw-image-modal-url-input",
            placeholder: w["components.controls.image.enterlink"],
            name: "imgSrc",
            onChange: this.updateValue,
            onBlur: this.updateValue,
            value: t
          }), u.default.createElement("span", {
            className: "rdw-image-mandatory-sign"
          }, "*")), b.present && u.default.createElement("div", {
            className: "rdw-image-modal-size"
          }, u.default.createElement("span", {
            className: "rdw-image-modal-alt-lbl"
          }, "Alt Text"), u.default.createElement("input", {
            onChange: this.updateValue,
            onBlur: this.updateValue,
            value: l,
            name: "alt",
            className: "rdw-image-modal-alt-input",
            placeholder: "alt"
          }), u.default.createElement("span", {
            className: "rdw-image-mandatory-sign"
          }, b.mandatory && "*")), u.default.createElement("div", {
            className: "rdw-image-modal-size"
          }, "↕ ", u.default.createElement("input", {
            onChange: this.updateValue,
            onBlur: this.updateValue,
            value: i,
            name: "height",
            className: "rdw-image-modal-size-input",
            placeholder: "Height"
          }), u.default.createElement("span", {
            className: "rdw-image-mandatory-sign"
          }, "*"), " ↔ ", u.default.createElement("input", {
            onChange: this.updateValue,
            onBlur: this.updateValue,
            value: a,
            name: "width",
            className: "rdw-image-modal-size-input",
            placeholder: "Width"
          }), u.default.createElement("span", {
            className: "rdw-image-mandatory-sign"
          }, "*")), u.default.createElement("span", {
            className: "rdw-image-modal-btn-section"
          }, u.default.createElement("button", {
            className: "rdw-image-modal-btn",
            onClick: this.addImageFromState,
            disabled: !t || !i || !a || b.mandatory && !l
          }, w["generic.add"]), u.default.createElement("button", {
            className: "rdw-image-modal-btn",
            onClick: j
          }, w["generic.cancel"])), o ? u.default.createElement("div", {
            className: "rdw-image-modal-spinner"
          }, u.default.createElement(M.default, null)) : void 0);
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.config,
              n = t.icon,
              o = t.className,
              r = t.title,
              i = e.expanded,
              a = e.onExpandEvent,
              l = e.translations;
          return u.default.createElement("div", {
            className: "rdw-image-wrapper",
            "aria-haspopup": "true",
            "aria-expanded": i,
            "aria-label": "rdw-image-control"
          }, u.default.createElement(y.default, {
            className: (0, m.default)(o),
            value: "unordered-list-item",
            onClick: a,
            title: r || l["components.controls.image.image"]
          }, u.default.createElement("img", {
            src: n,
            alt: ""
          })), i ? this.renderAddImageModal() : void 0);
        }
      }]), t;
    }(s.Component);

    b.propTypes = {
      expanded: p.default.bool,
      onExpandEvent: p.default.func,
      doCollapse: p.default.func,
      onChange: p.default.func,
      config: p.default.object,
      translations: p.default.object
    }, t.default = b;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var o = n(0),
        r = function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }(o);

    n(71), t.default = function () {
      return r.default.createElement("div", {
        className: "rdw-spinner"
      }, r.default.createElement("div", {
        className: "rdw-bounce1"
      }), r.default.createElement("div", {
        className: "rdw-bounce2"
      }), r.default.createElement("div", {
        className: "rdw-bounce3"
      }));
    };
  }, function (e, t) {
    e.exports = {
      "rdw-spinner": "rdw-spinner",
      "sk-bouncedelay": "sk-bouncedelay",
      "rdw-bounce1": "rdw-bounce1",
      "rdw-bounce2": "rdw-bounce2"
    };
  }, function (e, t) {
    e.exports = {
      "rdw-image-wrapper": "rdw-image-wrapper",
      "rdw-image-modal": "rdw-image-modal",
      "rdw-image-modal-header": "rdw-image-modal-header",
      "rdw-image-modal-header-option": "rdw-image-modal-header-option",
      "rdw-image-modal-header-label": "rdw-image-modal-header-label",
      "rdw-image-modal-header-label-highlighted": "rdw-image-modal-header-label-highlighted",
      "rdw-image-modal-upload-option": "rdw-image-modal-upload-option",
      "rdw-image-modal-upload-option-highlighted": "rdw-image-modal-upload-option-highlighted",
      "rdw-image-modal-upload-option-label": "rdw-image-modal-upload-option-label",
      "rdw-image-modal-upload-option-image-preview": "rdw-image-modal-upload-option-image-preview",
      "rdw-image-modal-upload-option-input": "rdw-image-modal-upload-option-input",
      "rdw-image-modal-url-section": "rdw-image-modal-url-section",
      "rdw-image-modal-url-input": "rdw-image-modal-url-input",
      "rdw-image-modal-btn-section": "rdw-image-modal-btn-section",
      "rdw-image-modal-btn": "rdw-image-modal-btn",
      "rdw-image-modal-spinner": "rdw-image-modal-spinner",
      "rdw-image-modal-alt-input": "rdw-image-modal-alt-input",
      "rdw-image-modal-alt-lbl": "rdw-image-modal-alt-lbl",
      "rdw-image-modal-size": "rdw-image-modal-size",
      "rdw-image-modal-size-input": "rdw-image-modal-size-input",
      "rdw-image-mandatory-sign": "rdw-image-mandatory-sign"
    };
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var l = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }

      return function (t, n, o) {
        return n && e(t.prototype, n), o && e(t, o), t;
      };
    }(),
        c = n(0),
        s = o(c),
        u = n(1),
        d = o(u),
        p = n(3),
        f = n(4),
        m = n(6),
        g = n(74),
        y = o(g),
        h = function (e) {
      function t() {
        var e, n, o, a;
        r(this, t);

        for (var l = arguments.length, c = Array(l), s = 0; s < l; s++) {
          c[s] = arguments[s];
        }

        return n = o = i(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(c))), o.state = {
          expanded: !1
        }, o.onExpandEvent = function () {
          o.signalExpanded = !o.state.expanded;
        }, o.expandCollapse = function () {
          o.setState({
            expanded: o.signalExpanded
          }), o.signalExpanded = !1;
        }, o.removeInlineStyles = function () {
          var e = o.props,
              t = e.editorState;
          (0, e.onChange)(o.removeAllInlineStyles(t));
        }, o.removeAllInlineStyles = function (e) {
          var t = e.getCurrentContent();
          ["BOLD", "ITALIC", "UNDERLINE", "STRIKETHROUGH", "MONOSPACE", "SUPERSCRIPT", "SUBSCRIPT"].forEach(function (n) {
            t = p.Modifier.removeInlineStyle(t, e.getSelection(), n);
          });
          var n = (0, f.getSelectionCustomInlineStyle)(e, ["FONTSIZE", "FONTFAMILY", "COLOR", "BGCOLOR"]);
          return (0, m.forEach)(n, function (n, o) {
            o && (t = p.Modifier.removeInlineStyle(t, e.getSelection(), o));
          }), p.EditorState.push(e, t, "change-inline-style");
        }, o.doExpand = function () {
          o.setState({
            expanded: !0
          });
        }, o.doCollapse = function () {
          o.setState({
            expanded: !1
          });
        }, a = n, i(o, a);
      }

      return a(t, e), l(t, [{
        key: "componentWillMount",
        value: function value() {
          this.props.modalHandler.registerCallBack(this.expandCollapse);
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.props.modalHandler.deregisterCallBack(this.expandCollapse);
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.config,
              n = e.translations,
              o = this.state.expanded,
              r = t.component || y.default;
          return s.default.createElement(r, {
            config: t,
            translations: n,
            expanded: o,
            onExpandEvent: this.onExpandEvent,
            doExpand: this.doExpand,
            doCollapse: this.doCollapse,
            onChange: this.removeInlineStyles
          });
        }
      }]), t;
    }(c.Component);

    h.propTypes = {
      onChange: d.default.func.isRequired,
      editorState: d.default.object.isRequired,
      config: d.default.object,
      translations: d.default.object,
      modalHandler: d.default.object
    }, t.default = h;
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(0),
        i = o(r),
        a = n(1),
        l = o(a),
        c = n(2),
        s = o(c),
        u = n(5),
        d = o(u);
    n(75);

    var p = function p(e) {
      var t = e.config,
          n = e.onChange,
          o = e.translations,
          r = t.icon,
          a = t.className,
          l = t.title;
      return i.default.createElement("div", {
        className: "rdw-remove-wrapper",
        "aria-label": "rdw-remove-control"
      }, i.default.createElement(d.default, {
        className: (0, s.default)(a),
        onClick: n,
        title: l || o["components.controls.remove.remove"]
      }, i.default.createElement("img", {
        src: r,
        alt: ""
      })));
    };

    p.propTypes = {
      onChange: l.default.func,
      config: l.default.object,
      translations: l.default.object
    }, t.default = p;
  }, function (e, t) {
    e.exports = {
      "rdw-remove-wrapper": "rdw-remove-wrapper"
    };
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var l = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }

      return function (t, n, o) {
        return n && e(t.prototype, n), o && e(t, o), t;
      };
    }(),
        c = n(0),
        s = o(c),
        u = n(1),
        d = o(u),
        p = n(3),
        f = n(77),
        m = o(f),
        g = function (e) {
      function t() {
        var e, n, o, a;
        r(this, t);

        for (var l = arguments.length, c = Array(l), s = 0; s < l; s++) {
          c[s] = arguments[s];
        }

        return n = o = i(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(c))), o.state = {
          expanded: !1,
          undoDisabled: !1,
          redoDisabled: !1
        }, o.onExpandEvent = function () {
          o.signalExpanded = !o.state.expanded;
        }, o.onChange = function (e) {
          var t = o.props,
              n = t.editorState,
              r = t.onChange,
              i = p.EditorState[e](n);
          i && r(i);
        }, o.doExpand = function () {
          o.setState({
            expanded: !0
          });
        }, o.doCollapse = function () {
          o.setState({
            expanded: !1
          });
        }, o.expandCollapse = function () {
          o.setState({
            expanded: o.signalExpanded
          }), o.signalExpanded = !1;
        }, a = n, i(o, a);
      }

      return a(t, e), l(t, [{
        key: "componentWillMount",
        value: function value() {
          var e = this.props,
              t = e.editorState,
              n = e.modalHandler;
          t && this.setState({
            undoDisabled: 0 === t.getUndoStack().size,
            redoDisabled: 0 === t.getRedoStack().size
          }), n.registerCallBack(this.expandCollapse);
        }
      }, {
        key: "componentWillReceiveProps",
        value: function value(e) {
          e.editorState && this.props.editorState !== e.editorState && this.setState({
            undoDisabled: 0 === e.editorState.getUndoStack().size,
            redoDisabled: 0 === e.editorState.getRedoStack().size
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.props.modalHandler.deregisterCallBack(this.expandCollapse);
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.config,
              n = e.translations,
              o = this.state,
              r = o.undoDisabled,
              i = o.redoDisabled,
              a = o.expanded,
              l = t.component || m.default;
          return s.default.createElement(l, {
            config: t,
            translations: n,
            currentState: {
              undoDisabled: r,
              redoDisabled: i
            },
            expanded: a,
            onExpandEvent: this.onExpandEvent,
            doExpand: this.doExpand,
            doCollapse: this.doCollapse,
            onChange: this.onChange
          });
        }
      }]), t;
    }(c.Component);

    g.propTypes = {
      onChange: d.default.func.isRequired,
      editorState: d.default.object,
      modalHandler: d.default.object,
      config: d.default.object,
      translations: d.default.object
    }, t.default = g;
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var l = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }

      return function (t, n, o) {
        return n && e(t.prototype, n), o && e(t, o), t;
      };
    }(),
        c = n(0),
        s = o(c),
        u = n(1),
        d = o(u),
        p = n(2),
        f = o(p),
        m = n(8),
        g = n(5),
        y = o(g),
        h = n(7);

    n(78);

    var M = function (e) {
      function t() {
        var e, n, o, a;
        r(this, t);

        for (var l = arguments.length, c = Array(l), s = 0; s < l; s++) {
          c[s] = arguments[s];
        }

        return n = o = i(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(c))), o.onChange = function (e) {
          (0, o.props.onChange)(e);
        }, a = n, i(o, a);
      }

      return a(t, e), l(t, [{
        key: "renderInDropDown",
        value: function value() {
          var e = this.props,
              t = e.config,
              n = e.expanded,
              o = e.doExpand,
              r = e.onExpandEvent,
              i = e.doCollapse,
              a = e.currentState,
              l = a.undoDisabled,
              c = a.redoDisabled,
              u = e.translations,
              d = t.options,
              p = t.undo,
              g = t.redo,
              y = t.className,
              M = t.dropdownClassName,
              b = t.title;
          return s.default.createElement(h.Dropdown, {
            className: (0, f.default)("rdw-history-dropdown", y),
            optionWrapperClassName: (0, f.default)(M),
            expanded: n,
            doExpand: o,
            doCollapse: i,
            onExpandEvent: r,
            "aria-label": "rdw-history-control",
            title: b || u["components.controls.history.history"]
          }, s.default.createElement("img", {
            src: (0, m.getFirstIcon)(t),
            alt: ""
          }), d.indexOf("undo") >= 0 && s.default.createElement(h.DropdownOption, {
            value: "undo",
            onClick: this.onChange,
            disabled: l,
            className: (0, f.default)("rdw-history-dropdownoption", p.className),
            title: p.title || u["components.controls.history.undo"]
          }, s.default.createElement("img", {
            src: p.icon,
            alt: ""
          })), d.indexOf("redo") >= 0 && s.default.createElement(h.DropdownOption, {
            value: "redo",
            onClick: this.onChange,
            disabled: c,
            className: (0, f.default)("rdw-history-dropdownoption", g.className),
            title: g.title || u["components.controls.history.redo"]
          }, s.default.createElement("img", {
            src: g.icon,
            alt: ""
          })));
        }
      }, {
        key: "renderInFlatList",
        value: function value() {
          var e = this.props,
              t = e.config,
              n = t.options,
              o = t.undo,
              r = t.redo,
              i = t.className,
              a = e.currentState,
              l = a.undoDisabled,
              c = a.redoDisabled,
              u = e.translations;
          return s.default.createElement("div", {
            className: (0, f.default)("rdw-history-wrapper", i),
            "aria-label": "rdw-history-control"
          }, n.indexOf("undo") >= 0 && s.default.createElement(y.default, {
            value: "undo",
            onClick: this.onChange,
            className: (0, f.default)(o.className),
            disabled: l,
            title: o.title || u["components.controls.history.undo"]
          }, s.default.createElement("img", {
            src: o.icon,
            alt: ""
          })), n.indexOf("redo") >= 0 && s.default.createElement(y.default, {
            value: "redo",
            onClick: this.onChange,
            className: (0, f.default)(r.className),
            disabled: c,
            title: r.title || u["components.controls.history.redo"]
          }, s.default.createElement("img", {
            src: r.icon,
            alt: ""
          })));
        }
      }, {
        key: "render",
        value: function value() {
          return this.props.config.inDropdown ? this.renderInDropDown() : this.renderInFlatList();
        }
      }]), t;
    }(c.Component);

    M.propTypes = {
      expanded: d.default.bool,
      doExpand: d.default.func,
      doCollapse: d.default.func,
      onExpandEvent: d.default.func,
      config: d.default.object,
      onChange: d.default.func,
      currentState: d.default.object,
      translations: d.default.object
    }, t.default = M;
  }, function (e, t) {
    e.exports = {
      "rdw-history-wrapper": "rdw-history-wrapper",
      "rdw-history-dropdownoption": "rdw-history-dropdownoption",
      "rdw-history-dropdown": "rdw-history-dropdown"
    };
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    function l(e, t, n) {
      e.findEntityRanges(function (e) {
        var t = e.getEntity();
        return null !== t && "LINK" === n.getEntity(t).getType();
      }, t);
    }

    function c(e) {
      var t,
          n,
          o = e.showOpenOptionOnHover;
      return n = t = function (e) {
        function t() {
          var e, n, o, a;
          r(this, t);

          for (var l = arguments.length, c = Array(l), s = 0; s < l; s++) {
            c[s] = arguments[s];
          }

          return n = o = i(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(c))), o.state = {
            showPopOver: !1
          }, o.openLink = function () {
            var e = o.props,
                t = e.entityKey,
                n = e.contentState,
                r = n.getEntity(t).getData(),
                i = r.url,
                a = window.open(i, "blank");
            a && a.focus();
          }, o.toggleShowPopOver = function () {
            var e = !o.state.showPopOver;
            o.setState({
              showPopOver: e
            });
          }, a = n, i(o, a);
        }

        return a(t, e), s(t, [{
          key: "render",
          value: function value() {
            var e = this.props,
                t = e.children,
                n = e.entityKey,
                r = e.contentState,
                i = r.getEntity(n).getData(),
                a = i.url,
                l = i.targetOption,
                c = this.state.showPopOver;
            return d.default.createElement("span", {
              className: "rdw-link-decorator-wrapper",
              onMouseEnter: this.toggleShowPopOver,
              onMouseLeave: this.toggleShowPopOver
            }, d.default.createElement("a", {
              href: a,
              target: l
            }, t), c && o ? d.default.createElement("img", {
              src: g.default,
              alt: "",
              onClick: this.openLink,
              className: "rdw-link-decorator-icon"
            }) : void 0);
          }
        }]), t;
      }(u.Component), t.propTypes = {
        entityKey: f.default.string.isRequired,
        children: f.default.array,
        contentState: f.default.object
      }, n;
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }

      return function (t, n, o) {
        return n && e(t.prototype, n), o && e(t, o), t;
      };
    }(),
        u = n(0),
        d = o(u),
        p = n(1),
        f = o(p),
        m = n(80),
        g = o(m);

    n(81), t.default = function (e) {
      return {
        strategy: l,
        component: c(e)
      };
    };
  }, function (e, t) {
    e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTQuMDcyIDBIOC45MTVhLjkyNS45MjUgMCAwIDAgMCAxLjg0OWgyLjkyNUw2Ljk2MSA2LjcyN2EuOTE4LjkxOCAwIDAgMC0uMjcuNjU0YzAgLjI0Ny4wOTUuNDguMjcuNjU0YS45MTguOTE4IDAgMCAwIC42NTQuMjcuOTE4LjkxOCAwIDAgMCAuNjUzLS4yN2w0Ljg4LTQuODh2Mi45MjZhLjkyNS45MjUgMCAwIDAgMS44NDggMFYuOTI0QS45MjUuOTI1IDAgMCAwIDE0LjA3MiAweiIvPjxwYXRoIGQ9Ik0xMC42MjMgMTMuNDExSDEuNTg1VjQuMzcyaDYuNzk4bDEuNTg0LTEuNTg0SC43OTJBLjc5Mi43OTIgMCAwIDAgMCAzLjU4djEwLjYyNGMwIC40MzcuMzU1Ljc5Mi43OTIuNzkyaDEwLjYyNGEuNzkyLjc5MiAwIDAgMCAuNzkyLS43OTJWNS4wMjlsLTEuNTg1IDEuNTg0djYuNzk4eiIvPjwvZz48L3N2Zz4=";
  }, function (e, t) {
    e.exports = {
      "rdw-link-decorator-wrapper": "rdw-link-decorator-wrapper",
      "rdw-link-decorator-icon": "rdw-link-decorator-icon"
    };
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var r = n(83),
        i = o(r),
        a = n(85),
        l = o(a),
        c = function c(e) {
      return [new i.default(e.mentionClassName).getMentionDecorator(), new l.default(e).getSuggestionDecorator()];
    };

    e.exports = c;
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    var i = n(0),
        a = o(i),
        l = n(1),
        c = o(l),
        s = n(2),
        u = o(s);
    n(84);

    var d = function e(t) {
      r(this, e), p.call(this), this.className = t;
    },
        p = function p() {
      var e = this;
      this.getMentionComponent = function () {
        var t = e.className,
            n = function n(e) {
          var n = e.entityKey,
              o = e.children,
              r = e.contentState,
              i = r.getEntity(n).getData(),
              l = i.url,
              c = i.value;
          return a.default.createElement("a", {
            href: l || c,
            className: (0, u.default)("rdw-mention-link", t)
          }, o);
        };

        return n.propTypes = {
          entityKey: c.default.number,
          children: c.default.array,
          contentState: c.default.object
        }, n;
      }, this.getMentionDecorator = function () {
        return {
          strategy: e.findMentionEntities,
          component: e.getMentionComponent()
        };
      };
    };

    d.prototype.findMentionEntities = function (e, t, n) {
      e.findEntityRanges(function (e) {
        var t = e.getEntity();
        return null !== t && "MENTION" === n.getEntity(t).getType();
      }, t);
    }, e.exports = d;
  }, function (e, t) {
    e.exports = {
      "rdw-mention-link": "rdw-mention-link"
    };
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function r(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function i(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    function a(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function l() {
      var e,
          t,
          n = this.config;
      return t = e = function (e) {
        function t() {
          var e, o, i, l;
          a(this, t);

          for (var c = arguments.length, s = Array(c), u = 0; u < c; u++) {
            s[u] = arguments[u];
          }

          return o = i = r(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(s))), i.state = {
            style: {
              left: 15
            },
            activeOption: -1,
            showSuggestions: !0
          }, i.onEditorKeyDown = function (e) {
            var t = i.state.activeOption,
                n = {};
            "ArrowDown" === e.key ? (e.preventDefault(), t === i.filteredSuggestions.length - 1 ? n.activeOption = 0 : n.activeOption = t + 1) : "ArrowUp" === e.key ? n.activeOption = t <= 0 ? i.filteredSuggestions.length - 1 : t - 1 : "Escape" === e.key ? (n.showSuggestions = !1, j.default.close()) : "Enter" === e.key && i.addMention(), i.setState(n);
          }, i.onOptionMouseEnter = function (e) {
            var t = e.target.getAttribute("data-index");
            i.setState({
              activeOption: t
            });
          }, i.onOptionMouseLeave = function () {
            i.setState({
              activeOption: -1
            });
          }, i.setSuggestionReference = function (e) {
            i.suggestion = e;
          }, i.setDropdownReference = function (e) {
            i.dropdown = e;
          }, i.closeSuggestionDropdown = function () {
            i.setState({
              showSuggestions: !1
            });
          }, i.filteredSuggestions = [], i.filterSuggestions = function (e) {
            var t = e.children[0].props.text.substr(1),
                o = n.getSuggestions();
            i.filteredSuggestions = o && o.filter(function (e) {
              return !t || 0 === t.length || (n.caseSensitive ? e.value.indexOf(t) >= 0 : e.value.toLowerCase().indexOf(t && t.toLowerCase()) >= 0);
            });
          }, i.addMention = function () {
            var e = i.state.activeOption,
                t = n.getEditorState(),
                o = n.onChange,
                r = n.separator,
                a = n.trigger,
                l = i.filteredSuggestions[e];
            l && (0, y.default)(t, o, r, a, l);
          }, l = o, r(i, l);
        }

        return i(t, e), c(t, [{
          key: "componentDidMount",
          value: function value() {
            var e = n.getWrapperRef().getBoundingClientRect(),
                t = this.suggestion.getBoundingClientRect(),
                o = this.dropdown.getBoundingClientRect(),
                r = void 0,
                i = void 0,
                a = void 0;
            e.width < t.left - e.left + o.width ? i = 15 : r = 15, e.bottom < o.bottom && (a = 0), this.setState({
              style: {
                left: r,
                right: i,
                bottom: a
              }
            }), M.default.registerCallBack(this.onEditorKeyDown), j.default.open(), n.modalHandler.setSuggestionCallback(this.closeSuggestionDropdown), this.filterSuggestions(this.props);
          }
        }, {
          key: "componentWillReceiveProps",
          value: function value(e) {
            this.props.children !== e.children && (this.filterSuggestions(e), this.setState({
              showSuggestions: !0
            }));
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            M.default.deregisterCallBack(this.onEditorKeyDown), j.default.close(), n.modalHandler.removeSuggestionCallback();
          }
        }, {
          key: "render",
          value: function value() {
            var e = this,
                t = this.props.children,
                o = this.state,
                r = o.activeOption,
                i = o.showSuggestions,
                a = n.dropdownClassName,
                l = n.optionClassName;
            return u.default.createElement("span", {
              className: "rdw-suggestion-wrapper",
              ref: this.setSuggestionReference,
              onClick: n.modalHandler.onSuggestionClick,
              "aria-haspopup": "true",
              "aria-label": "rdw-suggestion-popup"
            }, u.default.createElement("span", null, t), i && u.default.createElement("span", {
              className: (0, m.default)("rdw-suggestion-dropdown", a),
              contentEditable: "false",
              suppressContentEditableWarning: !0,
              style: this.state.style,
              ref: this.setDropdownReference
            }, this.filteredSuggestions.map(function (t, n) {
              return u.default.createElement("span", {
                key: n,
                spellCheck: !1,
                onClick: e.addMention,
                "data-index": n,
                onMouseEnter: e.onOptionMouseEnter,
                onMouseLeave: e.onOptionMouseLeave,
                className: (0, m.default)("rdw-suggestion-option", l, {
                  "rdw-suggestion-option-active": n === r
                })
              }, t.text);
            })));
          }
        }]), t;
      }(s.Component), e.propTypes = {
        children: p.default.array
      }, t;
    }

    var c = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }

      return function (t, n, o) {
        return n && e(t.prototype, n), o && e(t, o), t;
      };
    }(),
        s = n(0),
        u = o(s),
        d = n(1),
        p = o(d),
        f = n(2),
        m = o(f),
        g = n(86),
        y = o(g),
        h = n(11),
        M = o(h),
        b = n(12),
        j = o(b);

    n(87);

    var w = function e(t) {
      a(this, e), k.call(this);
      var n = t.separator,
          o = t.trigger,
          r = t.getSuggestions,
          i = t.onChange,
          l = t.getEditorState,
          c = t.getWrapperRef,
          s = t.caseSensitive,
          u = t.dropdownClassName,
          d = t.optionClassName,
          p = t.modalHandler;
      this.config = {
        separator: n,
        trigger: o,
        getSuggestions: r,
        onChange: i,
        getEditorState: l,
        getWrapperRef: c,
        caseSensitive: s,
        dropdownClassName: u,
        optionClassName: d,
        modalHandler: p
      };
    },
        k = function k() {
      var e = this;
      this.findSuggestionEntities = function (t, n) {
        if (e.config.getEditorState()) {
          var o = e.config,
              r = o.separator,
              i = o.trigger,
              a = o.getSuggestions,
              l = o.getEditorState,
              c = l().getSelection();

          if (c.get("anchorKey") === t.get("key") && c.get("anchorKey") === c.get("focusKey")) {
            var s = t.getText();
            s = s.substr(0, c.get("focusOffset") === s.length - 1 ? s.length : c.get("focusOffset") + 1);
            var u = s.lastIndexOf(r + i),
                d = r + i;

            if ((void 0 === u || u < 0) && s[0] === i && (u = 0, d = i), u >= 0) {
              var p = s.substr(u + d.length, s.length);
              a().some(function (t) {
                return !!t.value && (e.config.caseSensitive ? t.value.indexOf(p) >= 0 : t.value.toLowerCase().indexOf(p && p.toLowerCase()) >= 0);
              }) && n(0 === u ? 0 : u + 1, s.length);
            }
          }
        }
      }, this.getSuggestionComponent = l.bind(this), this.getSuggestionDecorator = function () {
        return {
          strategy: e.findSuggestionEntities,
          component: e.getSuggestionComponent()
        };
      };
    };

    e.exports = w;
  }, function (e, t, n) {
    "use strict";

    function o(e, t, n, o, a) {
      var l = a.value,
          c = a.url,
          s = e.getCurrentContent().createEntity("MENTION", "IMMUTABLE", {
        text: "" + o + l,
        value: l,
        url: c
      }).getLastCreatedEntityKey(),
          u = (0, i.getSelectedBlock)(e),
          d = u.getText(),
          p = e.getSelection().focusOffset,
          f = (d.lastIndexOf(n + o, p) || 0) + 1,
          m = !1;
      d.length === f + 1 && (p = d.length), " " === d[p] && (m = !0);
      var g = e.getSelection().merge({
        anchorOffset: f,
        focusOffset: p
      }),
          y = r.EditorState.acceptSelection(e, g),
          h = r.Modifier.replaceText(y.getCurrentContent(), g, "" + o + l, y.getCurrentInlineStyle(), s);
      y = r.EditorState.push(y, h, "insert-characters"), m || (g = y.getSelection().merge({
        anchorOffset: f + l.length + o.length,
        focusOffset: f + l.length + o.length
      }), y = r.EditorState.acceptSelection(y, g), h = r.Modifier.insertText(y.getCurrentContent(), g, " ", y.getCurrentInlineStyle(), void 0)), t(r.EditorState.push(y, h, "insert-characters"));
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(3),
        i = n(4);
  }, function (e, t) {
    e.exports = {
      "rdw-suggestion-wrapper": "rdw-suggestion-wrapper",
      "rdw-suggestion-dropdown": "rdw-suggestion-dropdown",
      "rdw-suggestion-option": "rdw-suggestion-option",
      "rdw-suggestion-option-active": "rdw-suggestion-option-active"
    };
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    var i = n(0),
        a = o(i),
        l = n(1),
        c = o(l),
        s = n(2),
        u = o(s);
    n(89);

    var d = function e(t) {
      var n = this;
      r(this, e), this.getHashtagComponent = function () {
        var e = n.className,
            t = function t(_t) {
          var n = _t.children,
              o = n[0].props.text;
          return a.default.createElement("a", {
            href: o,
            className: (0, u.default)("rdw-hashtag-link", e)
          }, n);
        };

        return t.propTypes = {
          children: c.default.object
        }, t;
      }, this.findHashtagEntities = function (e, t) {
        for (var o = e.getText(), r = 0, i = 0; o.length > 0 && r >= 0;) {
          if (o[0] === n.hashCharacter ? (r = 0, i = 0, o = o.substr(n.hashCharacter.length)) : (r = o.indexOf(n.separator + n.hashCharacter)) >= 0 && (o = o.substr(r + (n.separator + n.hashCharacter).length), i += r + n.separator.length), r >= 0) {
            var a = o.indexOf(n.separator) >= 0 ? o.indexOf(n.separator) : o.length,
                l = o.substr(0, a);
            l && l.length > 0 && (t(i, i + l.length + n.hashCharacter.length), i += n.hashCharacter.length);
          }
        }
      }, this.getHashtagDecorator = function () {
        return {
          strategy: n.findHashtagEntities,
          component: n.getHashtagComponent()
        };
      }, this.className = t.className, this.hashCharacter = t.hashCharacter || "#", this.separator = t.separator || " ";
    },
        p = function p(e) {
      return new d(e).getHashtagDecorator();
    };

    e.exports = p;
  }, function (e, t) {
    e.exports = {
      "rdw-hashtag-link": "rdw-hashtag-link"
    };
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = n(91),
        i = o(r),
        a = n(92),
        l = o(a),
        c = function c(e, t) {
      return function (n) {
        if ("function" == typeof t) {
          var o = t(n, e, e.getEditorState);
          if (o) return o;
        }

        if ("atomic" === n.getType()) {
          var r = e.getEditorState().getCurrentContent(),
              a = r.getEntity(n.getEntityAt(0));
          if (a && "IMAGE" === a.type) return {
            component: (0, l.default)(e),
            editable: !1
          };
          if (a && "EMBEDDED_LINK" === a.type) return {
            component: i.default,
            editable: !1
          };
        }
      };
    };

    t.default = c;
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = n(0),
        i = o(r),
        a = n(1),
        l = o(a),
        c = function c(e) {
      var t = e.block,
          n = e.contentState,
          o = n.getEntity(t.getEntityAt(0)),
          r = o.getData(),
          a = r.src,
          l = r.height,
          c = r.width;
      return i.default.createElement("iframe", {
        height: l,
        width: c,
        src: a,
        frameBorder: "0",
        allowFullScreen: !0,
        title: "Wysiwyg Embedded Content"
      });
    };

    c.propTypes = {
      block: l.default.object,
      contentState: l.default.object
    }, t.default = c;
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var l = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }

      return function (t, n, o) {
        return n && e(t.prototype, n), o && e(t, o), t;
      };
    }(),
        c = n(0),
        s = o(c),
        u = n(1),
        d = o(u),
        p = n(3),
        f = n(2),
        m = o(f),
        g = n(5),
        y = o(g);

    n(93);

    var h = function h(e) {
      var t, n;
      return n = t = function (t) {
        function n() {
          var t, o, a, l;
          r(this, n);

          for (var c = arguments.length, s = Array(c), u = 0; u < c; u++) {
            s[u] = arguments[u];
          }

          return o = a = i(this, (t = n.__proto__ || Object.getPrototypeOf(n)).call.apply(t, [this].concat(s))), a.state = {
            hovered: !1
          }, a.setEntityAlignmentLeft = function () {
            a.setEntityAlignment("left");
          }, a.setEntityAlignmentRight = function () {
            a.setEntityAlignment("right");
          }, a.setEntityAlignmentCenter = function () {
            a.setEntityAlignment("none");
          }, a.setEntityAlignment = function (t) {
            var n = a.props,
                o = n.block,
                r = n.contentState,
                i = o.getEntityAt(0);
            r.mergeEntityData(i, {
              alignment: t
            }), e.onChange(p.EditorState.push(e.getEditorState(), r, "change-block-data")), a.setState({
              dummy: !0
            });
          }, a.toggleHovered = function () {
            var e = !a.state.hovered;
            a.setState({
              hovered: e
            });
          }, l = o, i(a, l);
        }

        return a(n, t), l(n, [{
          key: "renderAlignmentOptions",
          value: function value(e) {
            return s.default.createElement("div", {
              className: (0, m.default)("rdw-image-alignment-options-popup", {
                "rdw-image-alignment-options-popup-right": "right" === e
              })
            }, s.default.createElement(y.default, {
              onClick: this.setEntityAlignmentLeft,
              className: "rdw-image-alignment-option"
            }, "L"), s.default.createElement(y.default, {
              onClick: this.setEntityAlignmentCenter,
              className: "rdw-image-alignment-option"
            }, "C"), s.default.createElement(y.default, {
              onClick: this.setEntityAlignmentRight,
              className: "rdw-image-alignment-option"
            }, "R"));
          }
        }, {
          key: "render",
          value: function value() {
            var t = this.props,
                n = t.block,
                o = t.contentState,
                r = this.state.hovered,
                i = e.isReadOnly,
                a = e.isImageAlignmentEnabled,
                l = o.getEntity(n.getEntityAt(0)),
                c = l.getData(),
                u = c.src,
                d = c.alignment,
                p = c.height,
                f = c.width,
                g = c.alt;
            return s.default.createElement("span", {
              onMouseEnter: this.toggleHovered,
              onMouseLeave: this.toggleHovered,
              className: (0, m.default)("rdw-image-alignment", {
                "rdw-image-left": "left" === d,
                "rdw-image-right": "right" === d,
                "rdw-image-center": !d || "none" === d
              })
            }, s.default.createElement("span", {
              className: "rdw-image-imagewrapper"
            }, s.default.createElement("img", {
              src: u,
              alt: g,
              style: {
                height: p,
                width: f
              }
            }), !i() && r && a() ? this.renderAlignmentOptions(d) : void 0));
          }
        }]), n;
      }(c.Component), t.propTypes = {
        block: d.default.object,
        contentState: d.default.object
      }, n;
    };

    t.default = h;
  }, function (e, t) {
    e.exports = {
      "rdw-image-alignment-options-popup": "rdw-image-alignment-options-popup",
      "rdw-alignment-option-left": "rdw-alignment-option-left",
      "rdw-image-alignment-option": "rdw-image-alignment-option",
      "rdw-image-alignment": "rdw-image-alignment",
      "rdw-image-imagewrapper": "rdw-image-imagewrapper",
      "rdw-image-center": "rdw-image-center",
      "rdw-image-left": "rdw-image-left",
      "rdw-image-right": "rdw-image-right",
      "rdw-image-alignment-options-popup-right": "rdw-image-alignment-options-popup-right"
    };
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = n(95),
        i = o(r),
        a = n(96),
        l = o(a),
        c = n(97),
        s = o(c),
        u = n(98),
        d = o(u),
        p = n(99),
        f = o(p),
        m = n(100),
        g = o(m),
        y = n(101),
        h = o(y),
        M = n(102),
        b = o(M),
        j = n(103),
        w = o(j),
        k = n(104),
        N = o(k),
        C = n(105),
        E = o(C),
        L = n(106),
        D = o(L),
        S = n(107),
        v = o(S),
        x = n(108),
        I = o(x),
        A = n(109),
        T = o(A),
        O = n(110),
        _ = o(O),
        z = n(111),
        P = o(z),
        U = n(112),
        F = o(U),
        B = n(113),
        Y = o(B),
        R = n(114),
        Q = o(R),
        H = n(115),
        Z = o(H),
        W = n(116),
        G = o(W),
        J = n(117),
        V = o(J),
        q = n(118),
        K = o(q),
        X = n(119),
        $ = o(X);

    t.default = {
      options: ["inline", "blockType", "fontSize", "fontFamily", "list", "textAlign", "colorPicker", "link", "embedded", "emoji", "image", "remove", "history"],
      inline: {
        inDropdown: !1,
        className: void 0,
        component: void 0,
        dropdownClassName: void 0,
        options: ["bold", "italic", "underline", "strikethrough", "monospace", "superscript", "subscript"],
        bold: {
          icon: i.default,
          className: void 0,
          title: void 0
        },
        italic: {
          icon: l.default,
          className: void 0,
          title: void 0
        },
        underline: {
          icon: s.default,
          className: void 0,
          title: void 0
        },
        strikethrough: {
          icon: d.default,
          className: void 0,
          title: void 0
        },
        monospace: {
          icon: f.default,
          className: void 0,
          title: void 0
        },
        superscript: {
          icon: $.default,
          className: void 0,
          title: void 0
        },
        subscript: {
          icon: K.default,
          className: void 0,
          title: void 0
        }
      },
      blockType: {
        inDropdown: !0,
        options: ["Normal", "H1", "H2", "H3", "H4", "H5", "H6", "Blockquote", "Code"],
        className: void 0,
        component: void 0,
        dropdownClassName: void 0,
        title: void 0
      },
      fontSize: {
        icon: g.default,
        options: [8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36, 48, 60, 72, 96],
        className: void 0,
        component: void 0,
        dropdownClassName: void 0,
        title: void 0
      },
      fontFamily: {
        options: ["Arial", "Georgia", "Impact", "Tahoma", "Times New Roman", "Verdana"],
        className: void 0,
        component: void 0,
        dropdownClassName: void 0,
        title: void 0
      },
      list: {
        inDropdown: !1,
        className: void 0,
        component: void 0,
        dropdownClassName: void 0,
        options: ["unordered", "ordered", "indent", "outdent"],
        unordered: {
          icon: N.default,
          className: void 0,
          title: void 0
        },
        ordered: {
          icon: w.default,
          className: void 0,
          title: void 0
        },
        indent: {
          icon: h.default,
          className: void 0,
          title: void 0
        },
        outdent: {
          icon: b.default,
          className: void 0,
          title: void 0
        },
        title: void 0
      },
      textAlign: {
        inDropdown: !1,
        className: void 0,
        component: void 0,
        dropdownClassName: void 0,
        options: ["left", "center", "right", "justify"],
        left: {
          icon: E.default,
          className: void 0,
          title: void 0
        },
        center: {
          icon: D.default,
          className: void 0,
          title: void 0
        },
        right: {
          icon: v.default,
          className: void 0,
          title: void 0
        },
        justify: {
          icon: I.default,
          className: void 0,
          title: void 0
        },
        title: void 0
      },
      colorPicker: {
        icon: T.default,
        className: void 0,
        component: void 0,
        popupClassName: void 0,
        colors: ["rgb(97,189,109)", "rgb(26,188,156)", "rgb(84,172,210)", "rgb(44,130,201)", "rgb(147,101,184)", "rgb(71,85,119)", "rgb(204,204,204)", "rgb(65,168,95)", "rgb(0,168,133)", "rgb(61,142,185)", "rgb(41,105,176)", "rgb(85,57,130)", "rgb(40,50,78)", "rgb(0,0,0)", "rgb(247,218,100)", "rgb(251,160,38)", "rgb(235,107,86)", "rgb(226,80,65)", "rgb(163,143,132)", "rgb(239,239,239)", "rgb(255,255,255)", "rgb(250,197,28)", "rgb(243,121,52)", "rgb(209,72,65)", "rgb(184,49,47)", "rgb(124,112,107)", "rgb(209,213,216)"],
        title: void 0
      },
      link: {
        inDropdown: !1,
        className: void 0,
        component: void 0,
        popupClassName: void 0,
        dropdownClassName: void 0,
        showOpenOptionOnHover: !0,
        defaultTargetOption: "_self",
        options: ["link", "unlink"],
        link: {
          icon: P.default,
          className: void 0,
          title: void 0
        },
        unlink: {
          icon: F.default,
          className: void 0,
          title: void 0
        },
        linkCallback: void 0
      },
      emoji: {
        icon: Y.default,
        className: void 0,
        component: void 0,
        popupClassName: void 0,
        emojis: ["😀", "😁", "😂", "😃", "😉", "😋", "😎", "😍", "😗", "🤗", "🤔", "😣", "😫", "😴", "😌", "🤓", "😛", "😜", "😠", "😇", "😷", "😈", "👻", "😺", "😸", "😹", "😻", "😼", "😽", "🙀", "🙈", "🙉", "🙊", "👼", "👮", "🕵", "💂", "👳", "🎅", "👸", "👰", "👲", "🙍", "🙇", "🚶", "🏃", "💃", "⛷", "🏂", "🏌", "🏄", "🚣", "🏊", "⛹", "🏋", "🚴", "👫", "💪", "👈", "👉", "👉", "👆", "🖕", "👇", "🖖", "🤘", "🖐", "👌", "👍", "👎", "✊", "👊", "👏", "🙌", "🙏", "🐵", "🐶", "🐇", "🐥", "🐸", "🐌", "🐛", "🐜", "🐝", "🍉", "🍄", "🍔", "🍤", "🍨", "🍪", "🎂", "🍰", "🍾", "🍷", "🍸", "🍺", "🌍", "🚑", "⏰", "🌙", "🌝", "🌞", "⭐", "🌟", "🌠", "🌨", "🌩", "⛄", "🔥", "🎄", "🎈", "🎉", "🎊", "🎁", "🎗", "🏀", "🏈", "🎲", "🔇", "🔈", "📣", "🔔", "🎵", "🎷", "💰", "🖊", "📅", "✅", "❎", "💯"],
        title: void 0
      },
      embedded: {
        icon: Q.default,
        className: void 0,
        component: void 0,
        popupClassName: void 0,
        embedCallback: void 0,
        defaultSize: {
          height: "auto",
          width: "auto"
        },
        title: void 0
      },
      image: {
        icon: Z.default,
        className: void 0,
        component: void 0,
        popupClassName: void 0,
        urlEnabled: !0,
        uploadEnabled: !0,
        previewImage: !1,
        alignmentEnabled: !0,
        uploadCallback: void 0,
        inputAccept: "image/gif,image/jpeg,image/jpg,image/png,image/svg",
        alt: {
          present: !1,
          mandatory: !1
        },
        defaultSize: {
          height: "auto",
          width: "auto"
        },
        title: void 0
      },
      remove: {
        icon: _.default,
        className: void 0,
        component: void 0,
        title: void 0
      },
      history: {
        inDropdown: !1,
        className: void 0,
        component: void 0,
        dropdownClassName: void 0,
        options: ["undo", "redo"],
        undo: {
          icon: G.default,
          className: void 0,
          title: void 0
        },
        redo: {
          icon: V.default,
          className: void 0,
          title: void 0
        },
        title: void 0
      }
    };
  }, function (e, t) {
    e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTYuMjM2IDBjMS42NTIgMCAyLjk0LjI5OCAzLjg2Ni44OTMuOTI1LjU5NSAxLjM4OCAxLjQ4NSAxLjM4OCAyLjY2OSAwIC42MDEtLjE3MyAxLjEzOS0uNTE2IDEuNjEtLjM0My40NzQtLjg0NC44My0xLjQ5OSAxLjA2OC44NDMuMTY3IDEuNDc0LjUyMyAxLjg5NSAxLjA3MS40MTkuNTUuNjMgMS4xODMuNjMgMS45MDMgMCAxLjI0NS0uNDQ0IDIuMTg3LTEuMzMgMi44MjUtLjg4Ni42NDEtMi4xNDQuOTYxLTMuNzY5Ljk2MUgwdi0yLjE2N2gxLjQ5NFYyLjE2N0gwVjBoNi4yMzZ6TTQuMzA4IDUuNDQ2aDIuMDI0Yy43NTIgMCAxLjMzLS4xNDMgMS43MzQtLjQzLjQwNS0uMjg1LjYwOC0uNzAxLjYwOC0xLjI1IDAtLjYtLjIwNC0xLjA0NC0uNjEyLTEuMzMtLjQwOC0uMjg2LTEuMDE2LS40MjctMS44MjYtLjQyN0g0LjMwOHYzLjQzN3ptMCAxLjgwNFYxMWgyLjU5M2MuNzQ3IDAgMS4zMTQtLjE1MiAxLjcwNy0uNDUyLjM5LS4zLjU4OC0uNzQ1LjU4OC0xLjMzNCAwLS42MzYtLjE2OC0xLjEyNC0uNS0xLjQ2LS4zMzYtLjMzNS0uODY0LS41MDQtMS41ODItLjUwNEg0LjMwOHoiIGZpbGw9IiMwMDAiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==";
  }, function (e, t) {
    e.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiI+PHBhdGggZD0iTTcgM1YyaDR2MUg5Ljc1M2wtMyAxMEg4djFINHYtMWgxLjI0N2wzLTEwSDd6Ii8+PC9zdmc+";
  }, function (e, t) {
    e.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiI+PHBhdGggZD0iTTYuMDQ1IDJ2Ljk5Mkw0Ljc4NSAzdjUuMTcyYzAgLjg1OS4yNDMgMS41MTIuNzI3IDEuOTU3czEuMTI0LjY2OCAxLjkxOC42NjhjLjgzNiAwIDEuNTA5LS4yMjEgMi4wMTktLjY2NC41MTEtLjQ0Mi43NjYtMS4wOTYuNzY2LTEuOTYxVjNsLTEuMjYtLjAwOFYySDEzdi45OTJMMTEuNzM5IDN2NS4xNzJjMCAxLjIzNC0uMzk4IDIuMTgxLTEuMTk1IDIuODQtLjc5Ny42NTktMS44MzUuOTg4LTMuMTE0Ljk4OC0xLjI0MiAwLTIuMjQ4LS4zMjktMy4wMTctLjk4OC0uNzY5LS42NTktMS4xNTItMS42MDUtMS4xNTItMi44NFYzTDIgMi45OTJWMmg0LjA0NXpNMiAxM2gxMXYxSDJ6Ii8+PC9zdmc+";
  }, function (e, t) {
    e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNNC4wNCA1Ljk1NGg2LjIxNWE3LjQxMiA3LjQxMiAwIDAgMC0uNzk1LS40MzggMTEuOTA3IDExLjkwNyAwIDAgMC0xLjQ0Ny0uNTU3Yy0xLjE4OC0uMzQ4LTEuOTY2LS43MTEtMi4zMzQtMS4wODgtLjM2OC0uMzc3LS41NTItLjc3LS41NTItMS4xODEgMC0uNDk1LjE4Ny0uOTA2LjU2LTEuMjMyLjM4LS4zMzEuODg3LS40OTcgMS41MjMtLjQ5Ny42OCAwIDEuMjY2LjI1NSAxLjc1Ny43NjcuMjk1LjMxNS41ODIuODkxLjg2MSAxLjczbC4xMTcuMDE2LjcwMy4wNS4xLS4wMjRjLjAyOC0uMTUyLjA0Mi0uMjc5LjA0Mi0uMzggMC0uMzM3LS4wMzktLjg1Mi0uMTE3LTEuNTQ0YTkuMzc0IDkuMzc0IDAgMCAwLS4xNzYtLjk5NUM5Ljg4LjM3OSA5LjM4NS4yNDQgOS4wMTcuMTc2IDguMzY1LjA3IDcuODk5LjAxNiA3LjYyLjAxNmMtMS40NSAwLTIuNTQ1LjM1Ny0zLjI4NyAxLjA3MS0uNzQ3LjcyLTEuMTIgMS41ODktMS4xMiAyLjYwNyAwIC41MTEuMTMzIDEuMDQuNCAxLjU4Ni4xMjkuMjUzLjI3LjQ3OC40MjcuNjc0ek04LjI4IDguMTE0Yy41NzUuMjM2Ljk1Ny40MzYgMS4xNDcuNTk5LjQ1MS40MS42NzcuODUyLjY3NyAxLjMyNCAwIC4zODMtLjEzLjc0NS0uMzkzIDEuMDg4LS4yNS4zMzgtLjU5LjU4LTEuMDIuNzI2YTMuNDE2IDMuNDE2IDAgMCAxLTEuMTYzLjIyOGMtLjQwNyAwLS43NzUtLjA2Mi0xLjEwNC0uMTg2YTIuNjk2IDIuNjk2IDAgMCAxLS44NzgtLjQ4IDMuMTMzIDMuMTMzIDAgMCAxLS42Ny0uNzk0IDEuNTI3IDEuNTI3IDAgMCAxLS4xMDQtLjIyNyA1Ny41MjMgNTcuNTIzIDAgMCAwLS4xODgtLjQ3MyAyMS4zNzEgMjEuMzcxIDAgMCAwLS4yNTEtLjU5OWwtLjg1My4wMTd2LjM3MWwtLjAxNy4zMTNhOS45MiA5LjkyIDAgMCAwIDAgLjU3M2MuMDExLjI3LjAxNy43MDkuMDE3IDEuMzE2di4xMWMwIC4wNzkuMDIyLjE0LjA2Ny4xODUuMDgzLjA2OC4yODQuMTQ3LjYwMi4yMzdsMS4xNy4zMzdjLjQ1Mi4xMy45OTYuMTk0IDEuNjMyLjE5NC42ODYgMCAxLjI1Mi0uMDU5IDEuNjk4LS4xNzdhNC42OTQgNC42OTQgMCAwIDAgMS4yOC0uNTU3Yy40MDEtLjI1OS43MDUtLjQ4Ni45MTEtLjY4My4yNjgtLjI3Ni40NjYtLjU2OC41OTQtLjg3OGE0Ljc0IDQuNzQgMCAwIDAgLjM0My0xLjc4OGMwLS4yOTgtLjAyLS41NTctLjA1OC0uNzc2SDguMjgxek0xNC45MTQgNi41N2EuMjYuMjYgMCAwIDAtLjE5My0uMDc2SC4yNjhhLjI2LjI2IDAgMCAwLS4xOTMuMDc2LjI2NC4yNjQgMCAwIDAtLjA3NS4xOTR2LjU0YzAgLjA3OS4wMjUuMTQzLjA3NS4xOTRhLjI2LjI2IDAgMCAwIC4xOTMuMDc2SDE0LjcyYS4yNi4yNiAwIDAgMCAuMTkzLS4wNzYuMjY0LjI2NCAwIDAgMCAuMDc1LS4xOTR2LS41NGEuMjY0LjI2NCAwIDAgMC0uMDc1LS4xOTR6Ii8+PC9nPjwvc3ZnPg==";
  }, function (e, t) {
    e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzQ0NCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMS4wMjEgMi45MDZjLjE4NiAxLjIxOS4zNzIgMS41LjM3MiAyLjcxOUMxLjM5MyA2LjM3NSAwIDcuMDMxIDAgNy4wMzF2LjkzOHMxLjM5My42NTYgMS4zOTMgMS40MDZjMCAxLjIxOS0uMTg2IDEuNS0uMzcyIDIuNzE5Qy43NDMgMTQuMDYzIDEuNzY0IDE1IDIuNjkzIDE1aDEuOTV2LTEuODc1cy0xLjY3Mi4xODgtMS42NzItLjkzOGMwLS44NDMuMTg2LS44NDMuMzcyLTIuNzE4LjA5My0uODQ0LS40NjQtMS41LTEuMDIyLTEuOTY5LjU1OC0uNDY5IDEuMTE1LTEuMDMxIDEuMDIyLTEuODc1QzMuMDY0IDMuNzUgMi45NyAzLjc1IDIuOTcgMi45MDZjMC0xLjEyNSAxLjY3Mi0xLjAzMSAxLjY3Mi0xLjAzMVYwaC0xLjk1QzEuNjcgMCAuNzQzLjkzOCAxLjAyIDIuOTA2ek0xMS45NzkgMi45MDZjLS4xODYgMS4yMTktLjM3MiAxLjUtLjM3MiAyLjcxOSAwIC43NSAxLjM5MyAxLjQwNiAxLjM5MyAxLjQwNnYuOTM4cy0xLjM5My42NTYtMS4zOTMgMS40MDZjMCAxLjIxOS4xODYgMS41LjM3MiAyLjcxOS4yNzggMS45NjktLjc0MyAyLjkwNi0xLjY3MiAyLjkwNmgtMS45NXYtMS44NzVzMS42NzIuMTg4IDEuNjcyLS45MzhjMC0uODQzLS4xODYtLjg0My0uMzcyLTIuNzE4LS4wOTMtLjg0NC40NjQtMS41IDEuMDIyLTEuOTY5LS41NTgtLjQ2OS0xLjExNS0xLjAzMS0xLjAyMi0xLjg3NS4xODYtMS44NzUuMzcyLTEuODc1LjM3Mi0yLjcxOSAwLTEuMTI1LTEuNjcyLTEuMDMxLTEuNjcyLTEuMDMxVjBoMS45NWMxLjAyMiAwIDEuOTUuOTM4IDEuNjcyIDIuOTA2eiIvPjwvZz48L3N2Zz4=";
  }, function (e, t) {
    e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTEuOTIxIDMuMTE5YS40MjcuNDI3IDAgMCAwIC4zMzUuMTY0aC45N2EuNDI2LjQyNiAwIDAgMCAuMzA0LS4xMy40NDEuNDQxIDAgMCAwIC4xMjUtLjMxbC4wMDItMi40MWEuNDM0LjQzNCAwIDAgMC0uNDMtLjQzMkguNDNBLjQzNC40MzQgMCAwIDAgMCAuNDR2Mi40MDZjMCAuMjQyLjE5Mi40MzguNDMuNDM4aC45N2MuMTMgMCAuMjU0LS4wNi4zMzUtLjE2NWwuNzMtLjkzSDUuNTR2MTEuMzZjMCAuMjQxLjE5Mi40MzcuNDMuNDM3aDEuNzE3Yy4yMzcgMCAuNDMtLjE5Ni40My0uNDM3VjIuMTg4aDMuMDdsLjczNC45MzF6TTEzLjg5OCAxMS4yNjNhLjQyNS40MjUgMCAwIDAtLjQ4Mi0uMTQ2bC0uNTQ3LjE5NFY5LjYxN2EuNDQyLjQ0MiAwIDAgMC0uMTI2LS4zMS40MjYuNDI2IDAgMCAwLS4zMDQtLjEyN2gtLjQyOWEuNDM0LjQzNCAwIDAgMC0uNDMuNDM3djEuNjk0bC0uNTQ3LS4xOTRhLjQyNS40MjUgMCAwIDAtLjQ4MS4xNDYuNDQ0LjQ0NCAwIDAgMC0uMDE2LjUxMmwxLjMzMiAyLjAxN2EuNDI3LjQyNyAwIDAgMCAuNzEzIDBsMS4zMzMtMi4wMTdhLjQ0NC40NDQgMCAwIDAtLjAxNi0uNTEyeiIvPjwvZz48L3N2Zz4=";
  }, function (e, t) {
    e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNNS43MTYgMy4yMTFIMTd2MS4xOTdINS43MTZ6TTAgLjAyaDE3djEuMTk3SDB6TTAgMTIuNzgzaDE3djEuMTk3SDB6TTUuNzE2IDkuNTkzSDE3djEuMTk3SDUuNzE2ek01LjcxNiA2LjQwMkgxN3YxLjE5N0g1LjcxNnpNLjE4NyA5LjQ5MUwyLjUyIDcgLjE4NyA0LjUwOXoiLz48L2c+PC9zdmc+";
  }, function (e, t) {
    e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNNS4zOTYgMy4xOTNoMTAuNTczVjQuMzlINS4zOTZ6TS4wMzkuMDAzaDE1LjkzVjEuMkguMDM5ek0uMDM5IDEyLjc2NmgxNS45M3YxLjE5N0guMDM5ek01LjM5NiA5LjU3NWgxMC41NzN2MS4xOTdINS4zOTZ6TTUuMzk2IDYuMzg0aDEwLjU3M3YxLjE5N0g1LjM5NnpNMi4xODcgNC40OTFMMCA2Ljk4M2wyLjE4NyAyLjQ5MXoiLz48L2c+PC9zdmc+";
  }, function (e, t) {
    e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNNC4yMDIgMS40NjZoOC4xNWMuMzM4IDAgLjYxMi0uMzIyLjYxMi0uNzIgMC0uMzk3LS4yNzQtLjcyLS42MTItLjcyaC04LjE1Yy0uMzM4IDAtLjYxMS4zMjMtLjYxMS43MiAwIC4zOTguMjczLjcyLjYxLjcyek0xMi4zNTIgNS43ODNoLTguMTVjLS4zMzggMC0uNjExLjMyMi0uNjExLjcyIDAgLjM5Ny4yNzMuNzIuNjEuNzJoOC4xNTFjLjMzOCAwIC42MTItLjMyMy42MTItLjcyIDAtLjM5OC0uMjc0LS43Mi0uNjEyLS43MnpNMTIuMzUyIDExLjU0aC04LjE1Yy0uMzM4IDAtLjYxMS4zMjItLjYxMS43MiAwIC4zOTYuMjczLjcxOS42MS43MTloOC4xNTFjLjMzOCAwIC42MTItLjMyMy42MTItLjcyIDAtLjM5Ny0uMjc0LS43Mi0uNjEyLS43MnpNLjc2NyAxLjI0OXYxLjgwMmMwIC4xOTUuMTM2LjM0My4zMTUuMzQzLjE3NiAwIC4zMTUtLjE1LjMxNS0uMzQzVi4zNTZjMC0uMTktLjEzMy0uMzM5LS4zMDItLjMzOS0uMTQ4IDAtLjIyMy4xMTgtLjI0Ny4xNTZhLjIyOC4yMjggMCAwIDAtLjAwMy4wMDVMLjU3OS42MjFhLjQ3NC40NzQgMCAwIDAtLjA5OC4yNzNjMCAuMTk0LjEyOC4zNTEuMjg2LjM1NXpNLjM1MiA4LjE5SDEuNTVjLjE1NyAwIC4yODUtLjE2Mi4yODUtLjM2MiAwLS4xOTgtLjEyOC0uMzU5LS4yODUtLjM1OUguNjh2LS4wMDZjMC0uMTA3LjIxLS4yODEuMzc4LS40MjIuMzM2LS4yNzguNzUzLS42MjUuNzUzLTEuMjI2IDAtLjU3LS4zNzYtMS0uODc0LTEtLjQ3NyAwLS44MzYuMzg1LS44MzYuODk3IDAgLjI5Ny4xNjQuNDAyLjMwNS40MDIuMiAwIC4zMjEtLjE3Ni4zMjEtLjM0NiAwLS4xMDYuMDIzLS4yMjguMjA0LS4yMjguMjQzIDAgLjI1LjI1NC4yNS4yODMgMCAuMjI4LS4yNTIuNDQyLS40OTUuNjQ5LS4zMDEuMjU1LS42NDIuNTQ0LS42NDIuOTkydi4zODRjMCAuMjA1LjE1OS4zNDMuMzA4LjM0M3pNMS43NyAxMC41NDNjMC0uNTkyLS4yOTYtLjkzMS0uODE0LS45MzEtLjY4IDAtLjg1OS41Ny0uODU5Ljg3MiAwIC4zNTEuMjIyLjM5LjMxOC4zOS4xODUgMCAuMzEtLjE0OC4zMS0uMzY2IDAtLjA4NC4wMjYtLjE4MS4yMjQtLjE4MS4xNDIgMCAuMi4wMjQuMi4yNjcgMCAuMjM3LS4wNDMuMjYzLS4yMTMuMjYzLS4xNjQgMC0uMjg4LjE1Mi0uMjg4LjM1NCAwIC4yLjEyNS4zNS4yOTEuMzUuMjI1IDAgLjI3LjEwOC4yNy4yODN2LjA3NWMwIC4yOTQtLjA5Ny4zNS0uMjc3LjM1LS4yNDggMC0uMjY3LS4xNS0uMjY3LS4xOTcgMC0uMTc0LS4wOTgtLjM1LS4zMTctLjM1LS4xOTIgMC0uMzA3LjE0MS0uMzA3LjM3OCAwIC40My4zMTMuODg4Ljg5NS44ODguNTY0IDAgLjkwMS0uNC45MDEtMS4wN3YtLjA3NGMwLS4yNzQtLjA3NC0uNTAyLS4yMTQtLjY2Ni4wOTYtLjE2My4xNDgtLjM4LjE0OC0uNjM1eiIvPjwvZz48L3N2Zz4=";
  }, function (e, t) {
    e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMS43MiAzLjQyN2MuOTUxIDAgMS43MjItLjc2OCAxLjcyMi0xLjcwOFMyLjY3LjAxIDEuNzIuMDFDLjc3LjAwOCAwIC43NzUgMCAxLjcxNWMwIC45NC43NzQgMS43MTEgMS43MiAxLjcxMXptMC0yLjYyNWMuNTEgMCAuOTIyLjQxMi45MjIuOTE0YS45Mi45MiAwIDAgMS0xLjg0MiAwIC45Mi45MiAwIDAgMSAuOTItLjkxNHpNMS43MiA4LjcwM2MuOTUxIDAgMS43MjItLjc2OCAxLjcyMi0xLjcwOFMyLjY3IDUuMjg3IDEuNzIgNS4yODdDLjc3IDUuMjg3IDAgNi4wNTIgMCA2Ljk5NXMuNzc0IDEuNzA4IDEuNzIgMS43MDh6bTAtMi42MjJjLjUxIDAgLjkyMi40MTIuOTIyLjkxNGEuOTIuOTIgMCAwIDEtMS44NDIgMGMwLS41MDUuNDE1LS45MTQuOTItLjkxNHpNMS43MiAxMy45ODJjLjk1MSAwIDEuNzIyLS43NjggMS43MjItMS43MDggMC0uOTQzLS43NzQtMS43MDgtMS43MjEtMS43MDgtLjk0NyAwLTEuNzIxLjc2OC0xLjcyMSAxLjcwOHMuNzc0IDEuNzA4IDEuNzIgMS43MDh6bTAtMi42MjVjLjUxIDAgLjkyMi40MTIuOTIyLjkxNGEuOTIuOTIgMCAxIDEtMS44NDIgMCAuOTIuOTIgMCAwIDEgLjkyLS45MTR6TTUuNzQ0IDIuMTE1aDkuODQ1YS40LjQgMCAwIDAgLjQwMS0uMzk5LjQuNCAwIDAgMC0uNDAxLS4zOTlINS43NDRhLjQuNCAwIDAgMC0uNDAyLjM5OS40LjQgMCAwIDAgLjQwMi4zOTl6TTUuNzQ0IDcuMzk0aDkuODQ1YS40LjQgMCAwIDAgLjQwMS0uMzk5LjQuNCAwIDAgMC0uNDAxLS4zOThINS43NDRhLjQuNCAwIDAgMC0uNDAyLjM5OC40LjQgMCAwIDAgLjQwMi4zOTl6TTUuNzQ0IDEyLjY3aDkuODQ1YS40LjQgMCAwIDAgLjQwMS0uMzk5LjQuNCAwIDAgMC0uNDAxLS4zOTlINS43NDRhLjQuNCAwIDAgMC0uNDAyLjQuNC40IDAgMCAwIC40MDIuMzk4eiIvPjwvZz48L3N2Zz4=";
  }, function (e, t) {
    e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNOC40OTMgMTQuODg3SC4zMjZhLjMyNi4zMjYgMCAwIDEgMC0uNjUyaDguMTY3YS4zMjYuMzI2IDAgMCAxIDAgLjY1MnpNMTQuNjE4IDEwLjE2MkguMzI2YS4zMjYuMzI2IDAgMCAxIDAtLjY1M2gxNC4yOTJhLjMyNi4zMjYgMCAwIDEgMCAuNjUzek04LjQ5MyA1LjQzNUguMzI2YS4zMjYuMzI2IDAgMCAxIDAtLjY1Mmg4LjE2N2EuMzI2LjMyNiAwIDAgMSAwIC42NTJ6TTE0LjYxOC43MDlILjMyNmEuMzI2LjMyNiAwIDAgMSAwLS42NTJoMTQuMjkyYS4zMjYuMzI2IDAgMCAxIDAgLjY1MnoiLz48L2c+PC9zdmc+";
  }, function (e, t) {
    e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTEuNTU2IDE0Ljg4N0gzLjM4OGEuMzI2LjMyNiAwIDAgMSAwLS42NTJoOC4xNjdhLjMyNi4zMjYgMCAwIDEgMCAuNjUyek0xNC42MTggMTAuMTYySC4zMjZhLjMyNi4zMjYgMCAwIDEgMC0uNjUzaDE0LjI5MmEuMzI2LjMyNiAwIDAgMSAwIC42NTN6TTExLjU1NiA1LjQzNUgzLjM4OGEuMzI2LjMyNiAwIDAgMSAwLS42NTJoOC4xNjdhLjMyNi4zMjYgMCAwIDEgMCAuNjUyek0xNC42MTguNzA5SC4zMjZhLjMyNi4zMjYgMCAwIDEgMC0uNjUyaDE0LjI5MmEuMzI2LjMyNiAwIDAgMSAwIC42NTJ6Ii8+PC9nPjwvc3ZnPg==";
  }, function (e, t) {
    e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTQuNjE4IDE0Ljg4N0g2LjQ1YS4zMjYuMzI2IDAgMCAxIDAtLjY1Mmg4LjE2N2EuMzI2LjMyNiAwIDAgMSAwIC42NTJ6TTE0LjYxOCAxMC4xNjJILjMyNmEuMzI2LjMyNiAwIDAgMSAwLS42NTNoMTQuMjkyYS4zMjYuMzI2IDAgMCAxIDAgLjY1M3pNMTQuNjE4IDUuNDM1SDYuNDVhLjMyNi4zMjYgMCAwIDEgMC0uNjUyaDguMTY3YS4zMjYuMzI2IDAgMCAxIDAgLjY1MnpNMTQuNjE4LjcwOUguMzI2YS4zMjYuMzI2IDAgMCAxIDAtLjY1MmgxNC4yOTJhLjMyNi4zMjYgMCAwIDEgMCAuNjUyeiIvPjwvZz48L3N2Zz4=";
  }, function (e, t) {
    e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTQuNjIgMTQuODg4SC4zMjVhLjMyNi4zMjYgMCAwIDEgMC0uNjUySDE0LjYyYS4zMjYuMzI2IDAgMCAxIDAgLjY1MnpNMTQuNjIgMTAuMTYySC4zMjVhLjMyNi4zMjYgMCAwIDEgMC0uNjUySDE0LjYyYS4zMjYuMzI2IDAgMCAxIDAgLjY1MnpNMTQuNjIgNS40MzZILjMyNWEuMzI2LjMyNiAwIDAgMSAwLS42NTJIMTQuNjJhLjMyNi4zMjYgMCAwIDEgMCAuNjUyek0xNC42Mi43MUguMzI1YS4zMjYuMzI2IDAgMCAxIDAtLjY1M0gxNC42MmEuMzI2LjMyNiAwIDAgMSAwIC42NTN6Ii8+PC9nPjwvc3ZnPg==";
  }, function (e, t) {
    e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTQuNDA2LjU4NWExLjk5OCAxLjk5OCAwIDAgMC0yLjgyNSAwbC0uNTQuNTRhLjc0MS43NDEgMCAxIDAtMS4wNDggMS4wNDhsLjE3NS4xNzUtNS44MjYgNS44MjUtMi4wMjIgMi4wMjNhLjkxLjkxIDAgMCAwLS4yNjYuNjAybC0uMDA1LjEwOHYuMDAybC0uMDgxIDEuODI5YS4zMDIuMzAyIDAgMCAwIC4zMDIuMzE2aC4wMTNsLjk3LS4wNDQuNTkyLS4wMjYuMjY4LS4wMTJjLjI5Ny0uMDEzLjU3OS0uMTM3Ljc5LS4zNDdsNy43Ny03Ljc3LjE0Ni4xNDRhLjc0Ljc0IDAgMCAwIDEuMDQ4IDBjLjI5LS4yOS4yOS0uNzU5IDAtMS4wNDhsLjU0LS41NGMuNzgtLjc4Ljc4LTIuMDQ0IDAtMi44MjV6TTguNzk1IDcuMzMzbC0yLjczLjUxNSA0LjQ1Mi00LjQ1MiAxLjEwOCAxLjEwNy0yLjgzIDIuODN6TTIuMDggMTMuNjczYy0xLjE0OCAwLTIuMDguMjk1LTIuMDguNjYgMCAuMzYzLjkzMi42NTggMi4wOC42NTggMS4xNSAwIDIuMDgtLjI5NCAyLjA4LS42NTkgMC0uMzY0LS45My0uNjU5LTIuMDgtLjY1OXoiLz48L2c+PC9zdmc+";
  }, function (e, t) {
    e.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNSIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDE2IDE2Ij48cGF0aCBkPSJNOC4xIDE0bDYuNC03LjJjLjYtLjcuNi0xLjgtLjEtMi41bC0yLjctMi43Yy0uMy0uNC0uOC0uNi0xLjMtLjZIOC42Yy0uNSAwLTEgLjItMS40LjZMLjUgOS4yYy0uNi43LS42IDEuOS4xIDIuNWwyLjcgMi43Yy4zLjQuOC42IDEuMy42SDE2di0xSDguMXptLTEuMy0uMXMwLS4xIDAgMGwtMi43LTIuN2MtLjQtLjQtLjQtLjkgMC0xLjNMNy41IDZoLTFsLTMgMy4zYy0uNi43LS42IDEuNy4xIDIuNEw1LjkgMTRINC42Yy0uMiAwLS40LS4xLS42LS4yTDEuMiAxMWMtLjMtLjMtLjMtLjggMC0xLjFMNC43IDZoMS44TDEwIDJoMUw3LjUgNmwzLjEgMy43LTMuNSA0Yy0uMS4xLS4yLjEtLjMuMnoiLz48L3N2Zz4=";
  }, function (e, t) {
    e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEzLjk2Ny45NUEzLjIyNiAzLjIyNiAwIDAgMCAxMS42Ny4wMDJjLS44NyAwLTEuNjg2LjMzNy0yLjI5Ny45NDhMNy4xMDUgMy4yMThBMy4yNDcgMy4yNDcgMCAwIDAgNi4yNCA2LjI0YTMuMjI1IDMuMjI1IDAgMCAwLTMuMDIyLjg2NUwuOTUgOS4zNzNhMy4yNTMgMy4yNTMgMCAwIDAgMCA0LjU5NCAzLjIyNiAzLjIyNiAwIDAgMCAyLjI5Ny45NDhjLjg3IDAgMS42ODYtLjMzNiAyLjI5OC0uOTQ4TDcuODEyIDExLjdhMy4yNDcgMy4yNDcgMCAwIDAgLjg2NS0zLjAyMyAzLjIyNSAzLjIyNSAwIDAgMCAzLjAyMi0uODY1bDIuMjY4LTIuMjY3YTMuMjUyIDMuMjUyIDAgMCAwIDAtNC41OTV6TTcuMTA1IDEwLjk5M0w0LjgzNyAxMy4yNmEyLjIzMyAyLjIzMyAwIDAgMS0xLjU5LjY1NSAyLjIzMyAyLjIzMyAwIDAgMS0xLjU5LS42NTUgMi4yNTIgMi4yNTIgMCAwIDEgMC0zLjE4bDIuMjY4LTIuMjY4YTIuMjMyIDIuMjMyIDAgMCAxIDEuNTktLjY1NWMuNDMgMCAuODQxLjEyIDEuMTk1LjM0M0w0Ljc3MiA5LjQzOGEuNS41IDAgMSAwIC43MDcuNzA3bDEuOTM5LTEuOTM4Yy41NDUuODY4LjQ0MiAyLjAzLS4zMTMgMi43ODV6bTYuMTU1LTYuMTU1bC0yLjI2OCAyLjI2N2EyLjIzMyAyLjIzMyAwIDAgMS0xLjU5LjY1NWMtLjQzMSAwLS44NDEtLjEyLTEuMTk1LS4zNDNsMS45MzgtMS45MzhhLjUuNSAwIDEgMC0uNzA3LS43MDdMNy40OTkgNi43MWEyLjI1MiAyLjI1MiAwIDAgMSAuMzEzLTIuNzg1bDIuMjY3LTIuMjY4YTIuMjMzIDIuMjMzIDAgMCAxIDEuNTktLjY1NSAyLjIzMyAyLjIzMyAwIDAgMSAyLjI0NiAyLjI0NWMwIC42MDMtLjIzMiAxLjE2OC0uNjU1IDEuNTl6IiBmaWxsPSIjMDAwIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=";
  }, function (e, t) {
    e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTMuOTU2IDEuMDM3YTMuNTUgMy41NSAwIDAgMC01LjAxNCAwTDYuNDM2IDMuNTQ0YS41NDUuNTQ1IDAgMSAwIC43Ny43N2wyLjUwOC0yLjUwNmEyLjQzOCAyLjQzOCAwIDAgMSAxLjczNS0uNzE1Yy42NTggMCAxLjI3NS4yNTQgMS43MzYuNzE1LjQ2LjQ2MS43MTUgMS4wNzguNzE1IDEuNzM2IDAgLjY1OC0uMjU0IDEuMjc0LS43MTUgMS43MzVMOS45MDcgOC41NThhMi40NTggMi40NTggMCAwIDEtMy40NzIgMCAuNTQ1LjU0NSAwIDEgMC0uNzcxLjc3MSAzLjUzNCAzLjUzNCAwIDAgMCAyLjUwNyAxLjAzN2MuOTA4IDAgMS44MTYtLjM0NiAyLjUwNy0xLjAzN2wzLjI3OC0zLjI3OGEzLjUyIDMuNTIgMCAwIDAgMS4wMzUtMi41MDdjMC0uOTUtLjM2Ny0xLjg0LTEuMDM1LTIuNTA3eiIvPjxwYXRoIGQ9Ik03LjQgMTEuMDY1bC0yLjEyMiAyLjEyYTIuNDM3IDIuNDM3IDAgMCAxLTEuNzM1LjcxNiAyLjQzNyAyLjQzNyAwIDAgMS0xLjczNi0uNzE1IDIuNDU3IDIuNDU3IDAgMCAxIDAtMy40NzFsMy4wODYtMy4wODZhMi40MzggMi40MzggMCAwIDEgMS43MzUtLjcxNWMuNjU4IDAgMS4yNzUuMjU0IDEuNzM2LjcxNWEuNTQ1LjU0NSAwIDEgMCAuNzcxLS43NzEgMy41NSAzLjU1IDAgMCAwLTUuMDE0IDBMMS4wMzYgOC45NDRBMy41MiAzLjUyIDAgMCAwIDAgMTEuNDVjMCAuOTUuMzY3IDEuODQgMS4wMzUgMi41MDdhMy41MiAzLjUyIDAgMCAwIDIuNTA2IDEuMDM1Yy45NSAwIDEuODQtLjM2OCAyLjUwNy0xLjAzNWwyLjEyMi0yLjEyMWEuNTQ1LjU0NSAwIDAgMC0uNzcxLS43NzF6TTkuMjc0IDEyLjAwMmEuNTQ2LjU0NiAwIDAgMC0uNTQ2LjU0NXYxLjYzN2EuNTQ2LjU0NiAwIDAgMCAxLjA5MSAwdi0xLjYzN2EuNTQ1LjU0NSAwIDAgMC0uNTQ1LS41NDV6TTExLjIzIDExLjYxNmEuNTQ1LjU0NSAwIDEgMC0uNzcyLjc3MmwxLjE1NyAxLjE1NmEuNTQzLjU0MyAwIDAgMCAuNzcxIDAgLjU0NS41NDUgMCAwIDAgMC0uNzdsLTEuMTU2LTEuMTU4ek0xMi41MzcgOS44MkgxMC45YS41NDYuNTQ2IDAgMCAwIDAgMS4wOTFoMS42MzdhLjU0Ni41NDYgMCAwIDAgMC0xLjA5ek00LjkxIDMuNTQ3YS41NDYuNTQ2IDAgMCAwIC41NDUtLjU0NVYxLjM2NmEuNTQ2LjU0NiAwIDAgMC0xLjA5IDB2MS42MzZjMCAuMzAxLjI0NC41NDUuNTQ1LjU0NXpNMi44ODggMy45MzNhLjU0My41NDMgMCAwIDAgLjc3MSAwIC41NDUuNTQ1IDAgMCAwIDAtLjc3MUwyLjUwMiAyLjAwNWEuNTQ1LjU0NSAwIDEgMC0uNzcxLjc3bDEuMTU3IDEuMTU4ek0xLjYyOCA1LjczaDEuNjM2YS41NDYuNTQ2IDAgMCAwIDAtMS4wOTJIMS42MjhhLjU0Ni41NDYgMCAwIDAgMCAxLjA5MXoiLz48L2c+PC9zdmc+";
  }, function (e, t) {
    e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTciIHZpZXdCb3g9IjE1LjcyOSAyMi4wODIgMTcgMTciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI5LjcwOCAyNS4xMDRjLTMuMDIxLTMuMDIyLTcuOTM3LTMuMDIyLTEwLjk1OCAwLTMuMDIxIDMuMDItMy4wMiA3LjkzNiAwIDEwLjk1OCAzLjAyMSAzLjAyIDcuOTM3IDMuMDIgMTAuOTU4LS4wMDEgMy4wMi0zLjAyMSAzLjAyLTcuOTM2IDAtMTAuOTU3em0tLjg0NSAxMC4xMTJhNi41NiA2LjU2IDAgMCAxLTkuMjY4IDAgNi41NiA2LjU2IDAgMCAxIDAtOS4yNjcgNi41NiA2LjU2IDAgMCAxIDkuMjY4IDAgNi41NiA2LjU2IDAgMCAxIDAgOS4yNjd6bS03LjUyNC02LjczYS45MDYuOTA2IDAgMSAxIDEuODExIDAgLjkwNi45MDYgMCAwIDEtMS44MTEgMHptNC4xMDYgMGEuOTA2LjkwNiAwIDEgMSAxLjgxMiAwIC45MDYuOTA2IDAgMCAxLTEuODEyIDB6bTIuMTQxIDMuNzA4Yy0uNTYxIDEuMjk4LTEuODc1IDIuMTM3LTMuMzQ4IDIuMTM3LTEuNTA1IDAtMi44MjctLjg0My0zLjM2OS0yLjE0N2EuNDM4LjQzOCAwIDAgMSAuODEtLjMzNmMuNDA1Ljk3NiAxLjQxIDEuNjA3IDIuNTU5IDEuNjA3IDEuMTIzIDAgMi4xMjEtLjYzMSAyLjU0NC0xLjYwOGEuNDM4LjQzOCAwIDAgMSAuODA0LjM0N3oiLz48L3N2Zz4=";
  }, function (e, t) {
    e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTYuNzA4IDYuNjE1YS40MzYuNDM2IDAgMCAwLS41NDMuMjkxbC0xLjgzIDYuMDQ1YS40MzYuNDM2IDAgMCAwIC44MzMuMjUyTDcgNy4xNmEuNDM2LjQzNiAwIDAgMC0uMjktLjU0NHpNOC45MzEgNi42MTVhLjQzNi40MzYgMCAwIDAtLjU0My4yOTFsLTEuODMgNi4wNDVhLjQzNi40MzYgMCAwIDAgLjgzNC4yNTJsMS44My02LjA0NGEuNDM2LjQzNiAwIDAgMC0uMjktLjU0NHoiLz48cGF0aCBkPSJNMTYuNTY0IDBILjQzNkEuNDM2LjQzNiAwIDAgMCAwIC40MzZ2MTYuMTI4YzAgLjI0LjE5NS40MzYuNDM2LjQzNmgxNi4xMjhjLjI0IDAgLjQzNi0uMTk1LjQzNi0uNDM2Vi40MzZBLjQzNi40MzYgMCAwIDAgMTYuNTY0IDB6TTMuNDg3Ljg3MmgxMC4wMjZ2MS43NDNIMy40ODdWLjg3MnptLTIuNjE1IDBoMS43NDN2MS43NDNILjg3MlYuODcyem0xNS4yNTYgMTUuMjU2SC44NzJWMy40ODhoMTUuMjU2djEyLjY0em0wLTEzLjUxM2gtMS43NDNWLjg3MmgxLjc0M3YxLjc0M3oiLz48Y2lyY2xlIGN4PSI5My44NjciIGN5PSIyNDUuMDY0IiByPSIxMy4xMjgiIHRyYW5zZm9ybT0ibWF0cml4KC4wMzMyIDAgMCAuMDMzMiAwIDApIi8+PGNpcmNsZSBjeD0iOTMuODY3IiBjeT0iMzYwLjU5MiIgcj0iMTMuMTI4IiB0cmFuc2Zvcm09Im1hdHJpeCguMDMzMiAwIDAgLjAzMzIgMCAwKSIvPjxwYXRoIGQ9Ik0xNC4yNTQgMTIuNjQxSDEwLjJhLjQzNi40MzYgMCAwIDAgMCAuODcyaDQuMDU0YS40MzYuNDM2IDAgMCAwIDAtLjg3MnoiLz48L3N2Zz4=";
  }, function (e, t) {
    e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTQuNzQxIDBILjI2Qy4xMTYgMCAwIC4xMzYgMCAuMzA0djEzLjM5MmMwIC4xNjguMTE2LjMwNC4yNTkuMzA0SDE0Ljc0Yy4xNDMgMCAuMjU5LS4xMzYuMjU5LS4zMDRWLjMwNEMxNSAuMTM2IDE0Ljg4NCAwIDE0Ljc0MSAwem0tLjI1OCAxMy4zOTFILjUxN1YuNjFoMTMuOTY2VjEzLjM5eiIvPjxwYXRoIGQ9Ik00LjEzOCA2LjczOGMuNzk0IDAgMS40NC0uNzYgMS40NC0xLjY5NXMtLjY0Ni0xLjY5NS0xLjQ0LTEuNjk1Yy0uNzk0IDAtMS40NC43Ni0xLjQ0IDEuNjk1IDAgLjkzNC42NDYgMS42OTUgMS40NCAxLjY5NXptMC0yLjc4MWMuNTA5IDAgLjkyMy40ODcuOTIzIDEuMDg2IDAgLjU5OC0uNDE0IDEuMDg2LS45MjMgMS4wODYtLjUwOSAwLS45MjMtLjQ4Ny0uOTIzLTEuMDg2IDAtLjU5OS40MTQtMS4wODYuOTIzLTEuMDg2ek0xLjgxIDEyLjE3NGMuMDYgMCAuMTIyLS4wMjUuMTcxLS4wNzZMNi4yIDcuNzI4bDIuNjY0IDMuMTM0YS4yMzIuMjMyIDAgMCAwIC4zNjYgMCAuMzQzLjM0MyAwIDAgMCAwLS40M0w3Ljk4NyA4Ljk2OWwyLjM3NC0zLjA2IDIuOTEyIDMuMTQyYy4xMDYuMTEzLjI3LjEwNS4zNjYtLjAyYS4zNDMuMzQzIDAgMCAwLS4wMTYtLjQzbC0zLjEwNC0zLjM0N2EuMjQ0LjI0NCAwIDAgMC0uMTg2LS4wOC4yNDUuMjQ1IDAgMCAwLS4xOC4xTDcuNjIyIDguNTM3IDYuMzk0IDcuMDk0YS4yMzIuMjMyIDAgMCAwLS4zNTQtLjAxM2wtNC40IDQuNTZhLjM0My4zNDMgMCAwIDAtLjAyNC40My4yNDMuMjQzIDAgMCAwIC4xOTQuMTAzeiIvPjwvZz48L3N2Zz4=";
  }, function (e, t) {
    e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTcgMTQuODc1YzIuNjcyIDAgNC44NDYtMi4xNDUgNC44NDYtNC43ODEgMC0yLjYzNy0yLjE3NC00Ljc4MS00Ljg0Ni00Ljc4MVY4LjVMMS42MTUgNC4yNSA3IDB2My4xODhjMy44NiAwIDcgMy4wOTggNyA2LjkwNlMxMC44NiAxNyA3IDE3cy03LTMuMDk4LTctNi45MDZoMi4xNTRjMCAyLjYzNiAyLjE3NCA0Ljc4MSA0Ljg0NiA0Ljc4MXoiIGZpbGw9IiMwMDAiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==";
  }, function (e, t) {
    e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTYuNTA0IDEzLjk3N2E0LjQ5NyA0LjQ5NyAwIDAgMS00LjQ5Mi00LjQ5MiA0LjQ5NyA0LjQ5NyAwIDAgMSA0LjQ5Mi00LjQ5M3YyLjk5NWw0Ljk5LTMuOTkzTDYuNTA0IDB2Mi45OTVhNi40OTYgNi40OTYgMCAwIDAtNi40ODggNi40OWMwIDMuNTc4IDIuOTEgNi40OSA2LjQ4OCA2LjQ5YTYuNDk2IDYuNDk2IDAgMCAwIDYuNDg3LTYuNDloLTEuOTk2YTQuNDk3IDQuNDk3IDAgMCAxLTQuNDkxIDQuNDkyeiIgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+";
  }, function (e, t) {
    e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTExLjg2NiAxMS42NDZIOS4wNkw1Ljg2NyA3Ljk0MmwtMy4xMjEgMy43MDRIMGw0LjUyNC01LjA2NEwuMjE4IDEuODA0aDIuNzdsMyAzLjQ2NCAzLjAyMy0zLjQ2NGgyLjY1TDcuMzA2IDYuNTgybDQuNTYgNS4wNjR6bTEuNzI1IDIuMDU4bDEuODI3LTEuMzY4Yy42NC0uNDM1IDEuMDYyLS44NCAxLjI2NC0xLjIxMi4yMDItLjM3Mi4zMDItLjc3My4zMDItMS4yMDIgMC0uNy0uMjM3LTEuMjY2LS43MS0xLjY5Ni0uNDc0LS40MzEtMS4wOTctLjY0Ni0xLjg2OS0uNjQ2LS43NDQgMC0xLjM0LjIxOC0xLjc4NS42NTMtLjQ0Ni40MzYtLjY3IDEuMDkyLS42NyAxLjk3aDEuNDM2YzAtLjUyNC4wOTQtLjg4Ni4yODEtMS4wODcuMTg4LS4yLjQ0NS0uMzAxLjc3Mi0uMzAxcy41ODYuMTAyLjc3Ny4zMDZjLjE5LjIwNC4yODYuNDU4LjI4Ni43NiAwIC4zMDMtLjA4OC41NzctLjI2Ni44MjItLjE3Ny4yNDUtLjY3LjY1OC0xLjQ3OCAxLjI0LS42OTIuNS0xLjYyOC45NzEtMS45MSAxLjQxM0wxMS44NjQgMTVIMTd2LTEuMjk2aC0zLjQxeiIvPjwvc3ZnPg==";
  }, function (e, t) {
    e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTcuMzA1IDEwLjE2NUwxMS44NjUgMTVIOS4wNTdsLTMuMTkyLTMuNTM2TDIuNzQ2IDE1SDBsNC41MjMtNC44MzVMLjIxOCA1LjYwM2gyLjc3TDUuOTg2IDguOTEgOS4wMSA1LjYwM2gyLjY0OWwtNC4zNTQgNC41NjJ6bTYuMjM0LTMuMjY5bDEuODc5LTEuMzA2Yy42NC0uNDE2IDEuMDYyLS44MDEgMS4yNjQtMS4xNTcuMjAxLS4zNTYuMzAyLS43MzguMzAyLTEuMTQ4IDAtLjY2OS0uMjM3LTEuMjEtLjcxLTEuNjItLjQ3NC0uNDExLTEuMDk3LS42MTctMS44NjgtLjYxNy0uNzQ0IDAtMS4zNC4yMDgtMS43ODUuNjI0LS40NDcuNDE2LS42NyAxLjA0My0uNjcgMS44ODFoMS40MzZjMC0uNS4wOTQtLjg0Ni4yODEtMS4wMzguMTg4LS4xOTEuNDQ1LS4yODcuNzcyLS4yODdzLjU4NS4wOTcuNzc3LjI5MmMuMTkuMTk1LjI4Ni40MzcuMjg2LjcyNiAwIC4yOS0uMDg5LjU1LS4yNjYuNzg1cy0uNjcuNjI4LTEuNDc5IDEuMTg0Yy0uNjkxLjQ3Ny0xLjYyNy45MjctMS45MDggMS4zNWwuMDE0IDEuNTY5SDE3VjYuODk2aC0zLjQ2MXoiLz48L3N2Zz4=";
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var r = n(121),
        i = o(r),
        a = n(122),
        l = o(a),
        c = n(123),
        s = o(c),
        u = n(124),
        d = o(u),
        p = n(125),
        f = o(p),
        m = n(126),
        g = o(m),
        y = n(127),
        h = o(y),
        M = n(128),
        b = o(M),
        j = n(129),
        w = o(j),
        k = n(130),
        N = o(k),
        C = n(131),
        E = o(C),
        L = n(132),
        D = o(L),
        S = n(133),
        v = o(S),
        x = n(134),
        I = o(x);
    e.exports = {
      en: i.default,
      fr: l.default,
      zh: s.default,
      ru: d.default,
      pt: f.default,
      ko: g.default,
      it: h.default,
      nl: b.default,
      de: w.default,
      da: N.default,
      zh_tw: E.default,
      pl: D.default,
      es: v.default,
      ja: I.default
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = {
      "generic.add": "Add",
      "generic.cancel": "Cancel",
      "components.controls.blocktype.h1": "H1",
      "components.controls.blocktype.h2": "H2",
      "components.controls.blocktype.h3": "H3",
      "components.controls.blocktype.h4": "H4",
      "components.controls.blocktype.h5": "H5",
      "components.controls.blocktype.h6": "H6",
      "components.controls.blocktype.blockquote": "Blockquote",
      "components.controls.blocktype.code": "Code",
      "components.controls.blocktype.blocktype": "Block Type",
      "components.controls.blocktype.normal": "Normal",
      "components.controls.colorpicker.colorpicker": "Color Picker",
      "components.controls.colorpicker.text": "Text",
      "components.controls.colorpicker.background": "Highlight",
      "components.controls.embedded.embedded": "Embedded",
      "components.controls.embedded.embeddedlink": "Embedded Link",
      "components.controls.embedded.enterlink": "Enter link",
      "components.controls.emoji.emoji": "Emoji",
      "components.controls.fontfamily.fontfamily": "Font",
      "components.controls.fontsize.fontsize": "Font Size",
      "components.controls.history.history": "History",
      "components.controls.history.undo": "Undo",
      "components.controls.history.redo": "Redo",
      "components.controls.image.image": "Image",
      "components.controls.image.fileUpload": "File Upload",
      "components.controls.image.byURL": "URL",
      "components.controls.image.dropFileText": "Drop the file or click to upload",
      "components.controls.inline.bold": "Bold",
      "components.controls.inline.italic": "Italic",
      "components.controls.inline.underline": "Underline",
      "components.controls.inline.strikethrough": "Strikethrough",
      "components.controls.inline.monospace": "Monospace",
      "components.controls.inline.superscript": "Superscript",
      "components.controls.inline.subscript": "Subscript",
      "components.controls.link.linkTitle": "Link Title",
      "components.controls.link.linkTarget": "Link Target",
      "components.controls.link.linkTargetOption": "Open link in new window",
      "components.controls.link.link": "Link",
      "components.controls.link.unlink": "Unlink",
      "components.controls.list.list": "List",
      "components.controls.list.unordered": "Unordered",
      "components.controls.list.ordered": "Ordered",
      "components.controls.list.indent": "Indent",
      "components.controls.list.outdent": "Outdent",
      "components.controls.remove.remove": "Remove",
      "components.controls.textalign.textalign": "Text Align",
      "components.controls.textalign.left": "Left",
      "components.controls.textalign.center": "Center",
      "components.controls.textalign.right": "Right",
      "components.controls.textalign.justify": "Justify"
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = {
      "generic.add": "Ok",
      "generic.cancel": "Annuler",
      "components.controls.blocktype.h1": "Titre 1",
      "components.controls.blocktype.h2": "Titre 2",
      "components.controls.blocktype.h3": "Titre 3",
      "components.controls.blocktype.h4": "Titre 4",
      "components.controls.blocktype.h5": "Titre 5",
      "components.controls.blocktype.h6": "Titre 6",
      "components.controls.blocktype.blockquote": "Citation",
      "components.controls.blocktype.code": "Code",
      "components.controls.blocktype.blocktype": "Type bloc",
      "components.controls.blocktype.normal": "Normal",
      "components.controls.colorpicker.colorpicker": "Palette de couleur",
      "components.controls.colorpicker.text": "Texte",
      "components.controls.colorpicker.background": "Fond",
      "components.controls.embedded.embedded": "Embedded",
      "components.controls.embedded.embeddedlink": "Lien iFrame",
      "components.controls.embedded.enterlink": "Entrer le lien",
      "components.controls.emoji.emoji": "Emoji",
      "components.controls.fontfamily.fontfamily": "Police",
      "components.controls.fontsize.fontsize": "Taille de police",
      "components.controls.history.history": "Historique",
      "components.controls.history.undo": "Précédent",
      "components.controls.history.redo": "Suivant",
      "components.controls.image.image": "Image",
      "components.controls.image.fileUpload": "Téléchargement",
      "components.controls.image.byURL": "URL",
      "components.controls.image.dropFileText": "Glisser une image ou cliquer pour télécharger",
      "components.controls.inline.bold": "Gras",
      "components.controls.inline.italic": "Italique",
      "components.controls.inline.underline": "Souligner",
      "components.controls.inline.strikethrough": "Barrer",
      "components.controls.inline.monospace": "Monospace",
      "components.controls.inline.superscript": "Exposant",
      "components.controls.inline.subscript": "Indice",
      "components.controls.link.linkTitle": "Titre du lien",
      "components.controls.link.linkTarget": "Cible du lien",
      "components.controls.link.linkTargetOption": "Ouvrir le lien dans une nouvelle fenêtre",
      "components.controls.link.link": "Lier",
      "components.controls.link.unlink": "Délier",
      "components.controls.list.list": "Liste",
      "components.controls.list.unordered": "Désordonnée",
      "components.controls.list.ordered": "Ordonnée",
      "components.controls.list.indent": "Augmenter le retrait",
      "components.controls.list.outdent": "Diminuer le retrait",
      "components.controls.remove.remove": "Supprimer",
      "components.controls.textalign.textalign": "Alignement du texte",
      "components.controls.textalign.left": "Gauche",
      "components.controls.textalign.center": "Centre",
      "components.controls.textalign.right": "Droite",
      "components.controls.textalign.justify": "Justifier"
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = {
      "generic.add": "添加",
      "generic.cancel": "取消",
      "components.controls.blocktype.h1": "标题1",
      "components.controls.blocktype.h2": "标题2",
      "components.controls.blocktype.h3": "标题3",
      "components.controls.blocktype.h4": "标题4",
      "components.controls.blocktype.h5": "标题5",
      "components.controls.blocktype.h6": "标题6",
      "components.controls.blocktype.blockquote": "引用",
      "components.controls.blocktype.code": "源码",
      "components.controls.blocktype.blocktype": "样式",
      "components.controls.blocktype.normal": "正文",
      "components.controls.colorpicker.colorpicker": "选色器",
      "components.controls.colorpicker.text": "文字",
      "components.controls.colorpicker.background": "背景",
      "components.controls.embedded.embedded": "内嵌",
      "components.controls.embedded.embeddedlink": "内嵌网页",
      "components.controls.embedded.enterlink": "输入网页地址",
      "components.controls.emoji.emoji": "表情符号",
      "components.controls.fontfamily.fontfamily": "字体",
      "components.controls.fontsize.fontsize": "字号",
      "components.controls.history.history": "历史",
      "components.controls.history.undo": "撤销",
      "components.controls.history.redo": "恢复",
      "components.controls.image.image": "图片",
      "components.controls.image.fileUpload": "来自文件",
      "components.controls.image.byURL": "在线图片",
      "components.controls.image.dropFileText": "点击或者拖拽文件上传",
      "components.controls.inline.bold": "粗体",
      "components.controls.inline.italic": "斜体",
      "components.controls.inline.underline": "下划线",
      "components.controls.inline.strikethrough": "删除线",
      "components.controls.inline.monospace": "等宽字体",
      "components.controls.inline.superscript": "上标",
      "components.controls.inline.subscript": "下标",
      "components.controls.link.linkTitle": "超链接",
      "components.controls.link.linkTarget": "输入链接地址",
      "components.controls.link.linkTargetOption": "在新窗口中打开链接",
      "components.controls.link.link": "链接",
      "components.controls.link.unlink": "删除链接",
      "components.controls.list.list": "列表",
      "components.controls.list.unordered": "项目符号",
      "components.controls.list.ordered": "编号",
      "components.controls.list.indent": "增加缩进量",
      "components.controls.list.outdent": "减少缩进量",
      "components.controls.remove.remove": "清除格式",
      "components.controls.textalign.textalign": "文本对齐",
      "components.controls.textalign.left": "文本左对齐",
      "components.controls.textalign.center": "居中",
      "components.controls.textalign.right": "文本右对齐",
      "components.controls.textalign.justify": "两端对齐"
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = {
      "generic.add": "Добавить",
      "generic.cancel": "Отменить",
      "components.controls.blocktype.h1": "Заголовок 1",
      "components.controls.blocktype.h2": "Заголовок 2",
      "components.controls.blocktype.h3": "Заголовок 3",
      "components.controls.blocktype.h4": "Заголовок 4",
      "components.controls.blocktype.h5": "Заголовок 5",
      "components.controls.blocktype.h6": "Заголовок 6",
      "components.controls.blocktype.blockquote": "Цитата",
      "components.controls.blocktype.code": "Код",
      "components.controls.blocktype.blocktype": "Форматирование",
      "components.controls.blocktype.normal": "Обычный",
      "components.controls.colorpicker.colorpicker": "Выбор цвета",
      "components.controls.colorpicker.text": "Текст",
      "components.controls.colorpicker.background": "Фон",
      "components.controls.embedded.embedded": "Встраивание",
      "components.controls.embedded.embeddedlink": "Ссылка в iFrame",
      "components.controls.embedded.enterlink": "Вставьте ссылку",
      "components.controls.emoji.emoji": "Эмодзи",
      "components.controls.fontfamily.fontfamily": "Шрифт",
      "components.controls.fontsize.fontsize": "Размер шрифта",
      "components.controls.history.history": "История",
      "components.controls.history.undo": "Отменить",
      "components.controls.history.redo": "Вернуть",
      "components.controls.image.image": "Изображение",
      "components.controls.image.fileUpload": "Файлы",
      "components.controls.image.byURL": "URL",
      "components.controls.image.dropFileText": "Переместите в эту область файлы или кликните для загрузки",
      "components.controls.inline.bold": "Жирный",
      "components.controls.inline.italic": "Курсив",
      "components.controls.inline.underline": "Подчеркивание",
      "components.controls.inline.strikethrough": "Зачеркивание",
      "components.controls.inline.monospace": "Monospace",
      "components.controls.inline.superscript": "Верхний индекс",
      "components.controls.inline.subscript": "Нижний индекс",
      "components.controls.link.linkTitle": "Текст",
      "components.controls.link.linkTarget": "Адрес ссылки",
      "components.controls.link.linkTargetOption": "Открывать в новом окне",
      "components.controls.link.link": "Ссылка",
      "components.controls.link.unlink": "Убрать ссылку",
      "components.controls.list.list": "Список",
      "components.controls.list.unordered": "Неупорядоченный",
      "components.controls.list.ordered": "Упорядоченный",
      "components.controls.list.indent": "Отступ",
      "components.controls.list.outdent": "Выступ",
      "components.controls.remove.remove": "Удалить",
      "components.controls.textalign.textalign": "Выравнивание текста",
      "components.controls.textalign.left": "Слева",
      "components.controls.textalign.center": "По центру",
      "components.controls.textalign.right": "Справа",
      "components.controls.textalign.justify": "Выравнить"
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = {
      "generic.add": "Ok",
      "generic.cancel": "Cancelar",
      "components.controls.blocktype.h1": "Título 1",
      "components.controls.blocktype.h2": "Título 2",
      "components.controls.blocktype.h3": "Título 3",
      "components.controls.blocktype.h4": "Título 4",
      "components.controls.blocktype.h5": "Título 5",
      "components.controls.blocktype.h6": "Título 6",
      "components.controls.blocktype.blockquote": "Citação",
      "components.controls.blocktype.code": "Code",
      "components.controls.blocktype.blocktype": "Estilo",
      "components.controls.blocktype.normal": "Normal",
      "components.controls.colorpicker.colorpicker": "Paleta de cores",
      "components.controls.colorpicker.text": "Texto",
      "components.controls.colorpicker.background": "Fundo",
      "components.controls.embedded.embedded": "Embarcado",
      "components.controls.embedded.embeddedlink": "Link embarcado",
      "components.controls.embedded.enterlink": "Coloque o link",
      "components.controls.emoji.emoji": "Emoji",
      "components.controls.fontfamily.fontfamily": "Fonte",
      "components.controls.fontsize.fontsize": "Tamanho da Fonte",
      "components.controls.history.history": "Histórico",
      "components.controls.history.undo": "Desfazer",
      "components.controls.history.redo": "Refazer",
      "components.controls.image.image": "Imagem",
      "components.controls.image.fileUpload": "Carregar arquivo",
      "components.controls.image.byURL": "URL",
      "components.controls.image.dropFileText": "Arraste uma imagem aqui ou clique para carregar",
      "components.controls.inline.bold": "Negrito",
      "components.controls.inline.italic": "Itálico",
      "components.controls.inline.underline": "Sublinhado",
      "components.controls.inline.strikethrough": "Strikethrough",
      "components.controls.inline.monospace": "Monospace",
      "components.controls.inline.superscript": "Sobrescrito",
      "components.controls.inline.subscript": "Subscrito",
      "components.controls.link.linkTitle": "Título do link",
      "components.controls.link.linkTarget": "Alvo do link",
      "components.controls.link.linkTargetOption": "Abrir link em outra janela",
      "components.controls.link.link": "Adicionar Link",
      "components.controls.link.unlink": "Remover link",
      "components.controls.list.list": "Lista",
      "components.controls.list.unordered": "Sem ordenção",
      "components.controls.list.ordered": "Ordenada",
      "components.controls.list.indent": "Aumentar recuo",
      "components.controls.list.outdent": "Diminuir recuo",
      "components.controls.remove.remove": "Remover",
      "components.controls.textalign.textalign": "Alinhamento do texto",
      "components.controls.textalign.left": "À Esquerda",
      "components.controls.textalign.center": "Centralizado",
      "components.controls.textalign.right": "À Direita",
      "components.controls.textalign.justify": "Justificado"
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = {
      "generic.add": "입력",
      "generic.cancel": "취소",
      "components.controls.blocktype.h1": "제목1",
      "components.controls.blocktype.h2": "제목2",
      "components.controls.blocktype.h3": "제목3",
      "components.controls.blocktype.h4": "제목4",
      "components.controls.blocktype.h5": "제목5",
      "components.controls.blocktype.h6": "제목6",
      "components.controls.blocktype.blockquote": "인용",
      "components.controls.blocktype.code": "Code",
      "components.controls.blocktype.blocktype": "블록",
      "components.controls.blocktype.normal": "표준",
      "components.controls.colorpicker.colorpicker": "색상 선택",
      "components.controls.colorpicker.text": "글꼴색",
      "components.controls.colorpicker.background": "배경색",
      "components.controls.embedded.embedded": "임베드",
      "components.controls.embedded.embeddedlink": "임베드 링크",
      "components.controls.embedded.enterlink": "주소를 입력하세요",
      "components.controls.emoji.emoji": "이모지",
      "components.controls.fontfamily.fontfamily": "글꼴",
      "components.controls.fontsize.fontsize": "글꼴 크기",
      "components.controls.history.history": "히스토리",
      "components.controls.history.undo": "실행 취소",
      "components.controls.history.redo": "다시 실행",
      "components.controls.image.image": "이미지",
      "components.controls.image.fileUpload": "파일 업로드",
      "components.controls.image.byURL": "주소",
      "components.controls.image.dropFileText": "클릭하거나 파일을 드롭하여 업로드하세요",
      "components.controls.inline.bold": "굵게",
      "components.controls.inline.italic": "기울임꼴",
      "components.controls.inline.underline": "밑줄",
      "components.controls.inline.strikethrough": "취소선",
      "components.controls.inline.monospace": "고정 너비",
      "components.controls.inline.superscript": "위 첨자",
      "components.controls.inline.subscript": "아래 첨자",
      "components.controls.link.linkTitle": "링크 제목",
      "components.controls.link.linkTarget": "링크 타겟",
      "components.controls.link.linkTargetOption": "새창으로 열기",
      "components.controls.link.link": "링크",
      "components.controls.link.unlink": "링크 제거",
      "components.controls.list.list": "리스트",
      "components.controls.list.unordered": "일반 리스트",
      "components.controls.list.ordered": "순서 리스트",
      "components.controls.list.indent": "들여쓰기",
      "components.controls.list.outdent": "내어쓰기",
      "components.controls.remove.remove": "삭제",
      "components.controls.textalign.textalign": "텍스트 정렬",
      "components.controls.textalign.left": "왼쪽",
      "components.controls.textalign.center": "중앙",
      "components.controls.textalign.right": "오른쪽",
      "components.controls.textalign.justify": "양쪽"
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = {
      "generic.add": "Aggiungi",
      "generic.cancel": "Annulla",
      "components.controls.blocktype.h1": "H1",
      "components.controls.blocktype.h2": "H2",
      "components.controls.blocktype.h3": "H3",
      "components.controls.blocktype.h4": "H4",
      "components.controls.blocktype.h5": "H5",
      "components.controls.blocktype.h6": "H6",
      "components.controls.blocktype.blockquote": "Citazione",
      "components.controls.blocktype.code": "Codice",
      "components.controls.blocktype.blocktype": "Stili",
      "components.controls.blocktype.normal": "Normale",
      "components.controls.colorpicker.colorpicker": "Colore testo",
      "components.controls.colorpicker.text": "Testo",
      "components.controls.colorpicker.background": "Evidenziazione",
      "components.controls.embedded.embedded": "Incorpora",
      "components.controls.embedded.embeddedlink": "Incorpora link",
      "components.controls.embedded.enterlink": "Inserisci link",
      "components.controls.emoji.emoji": "Emoji",
      "components.controls.fontfamily.fontfamily": "Carattere",
      "components.controls.fontsize.fontsize": "Dimensione carattere",
      "components.controls.history.history": "Modifiche",
      "components.controls.history.undo": "Annulla",
      "components.controls.history.redo": "Ripristina",
      "components.controls.image.image": "Immagine",
      "components.controls.image.fileUpload": "Carica immagine",
      "components.controls.image.byURL": "URL",
      "components.controls.image.dropFileText": "Trascina il file o clicca per caricare",
      "components.controls.inline.bold": "Grassetto",
      "components.controls.inline.italic": "Corsivo",
      "components.controls.inline.underline": "Sottolineato",
      "components.controls.inline.strikethrough": "Barrato",
      "components.controls.inline.monospace": "Monospace",
      "components.controls.inline.superscript": "Apice",
      "components.controls.inline.subscript": "Pedice",
      "components.controls.link.linkTitle": "Testo",
      "components.controls.link.linkTarget": "Link",
      "components.controls.link.linkTargetOption": "Apri link in una nuova finestra",
      "components.controls.link.link": "Inserisci link",
      "components.controls.link.unlink": "Rimuovi link",
      "components.controls.list.list": "Lista",
      "components.controls.list.unordered": "Elenco puntato",
      "components.controls.list.ordered": "Elenco numerato",
      "components.controls.list.indent": "Indent",
      "components.controls.list.outdent": "Outdent",
      "components.controls.remove.remove": "Rimuovi formattazione",
      "components.controls.textalign.textalign": "Allineamento del testo",
      "components.controls.textalign.left": "Allinea a sinistra",
      "components.controls.textalign.center": "Allinea al centro",
      "components.controls.textalign.right": "Allinea a destra",
      "components.controls.textalign.justify": "Giustifica"
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = {
      "generic.add": "Toevoegen",
      "generic.cancel": "Annuleren",
      "components.controls.blocktype.h1": "H1",
      "components.controls.blocktype.h2": "H2",
      "components.controls.blocktype.h3": "H3",
      "components.controls.blocktype.h4": "H4",
      "components.controls.blocktype.h5": "H5",
      "components.controls.blocktype.h6": "H6",
      "components.controls.blocktype.blockquote": "Blockquote",
      "components.controls.blocktype.code": "Code",
      "components.controls.blocktype.blocktype": "Blocktype",
      "components.controls.blocktype.normal": "Normaal",
      "components.controls.colorpicker.colorpicker": "Kleurkiezer",
      "components.controls.colorpicker.text": "Tekst",
      "components.controls.colorpicker.background": "Achtergrond",
      "components.controls.embedded.embedded": "Ingevoegd",
      "components.controls.embedded.embeddedlink": "Ingevoegde link",
      "components.controls.embedded.enterlink": "Voeg link toe",
      "components.controls.emoji.emoji": "Emoji",
      "components.controls.fontfamily.fontfamily": "Lettertype",
      "components.controls.fontsize.fontsize": "Lettergrootte",
      "components.controls.history.history": "Geschiedenis",
      "components.controls.history.undo": "Ongedaan maken",
      "components.controls.history.redo": "Opnieuw",
      "components.controls.image.image": "Afbeelding",
      "components.controls.image.fileUpload": "Bestand uploaden",
      "components.controls.image.byURL": "URL",
      "components.controls.image.dropFileText": "Drop het bestand hier of klik om te uploaden",
      "components.controls.inline.bold": "Dikgedrukt",
      "components.controls.inline.italic": "Schuingedrukt",
      "components.controls.inline.underline": "Onderstrepen",
      "components.controls.inline.strikethrough": "Doorstrepen",
      "components.controls.inline.monospace": "Monospace",
      "components.controls.inline.superscript": "Superscript",
      "components.controls.inline.subscript": "Subscript",
      "components.controls.link.linkTitle": "Linktitel",
      "components.controls.link.linkTarget": "Link bestemming",
      "components.controls.link.linkTargetOption": "Open link in een nieuw venster",
      "components.controls.link.link": "Link",
      "components.controls.link.unlink": "Unlink",
      "components.controls.list.list": "Lijst",
      "components.controls.list.unordered": "Ongeordend",
      "components.controls.list.ordered": "Geordend",
      "components.controls.list.indent": "Inspringen",
      "components.controls.list.outdent": "Inspringen verkleinen",
      "components.controls.remove.remove": "Verwijderen",
      "components.controls.textalign.textalign": "Tekst uitlijnen",
      "components.controls.textalign.left": "Links",
      "components.controls.textalign.center": "Gecentreerd",
      "components.controls.textalign.right": "Rechts",
      "components.controls.textalign.justify": "Uitgelijnd"
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = {
      "generic.add": "Hinzufügen",
      "generic.cancel": "Abbrechen",
      "components.controls.blocktype.h1": "Überschrift 1",
      "components.controls.blocktype.h2": "Überschrift 2",
      "components.controls.blocktype.h3": "Überschrift 3",
      "components.controls.blocktype.h4": "Überschrift 4",
      "components.controls.blocktype.h5": "Überschrift 5",
      "components.controls.blocktype.h6": "Überschrift 6",
      "components.controls.blocktype.blockquote": "Zitat",
      "components.controls.blocktype.code": "Quellcode",
      "components.controls.blocktype.blocktype": "Blocktyp",
      "components.controls.blocktype.normal": "Normal",
      "components.controls.colorpicker.colorpicker": "Farbauswahl",
      "components.controls.colorpicker.text": "Text",
      "components.controls.colorpicker.background": "Hintergrund",
      "components.controls.embedded.embedded": "Eingebettet",
      "components.controls.embedded.embeddedlink": "Eingebetteter Link",
      "components.controls.embedded.enterlink": "Link eingeben",
      "components.controls.emoji.emoji": "Emoji",
      "components.controls.fontfamily.fontfamily": "Schriftart",
      "components.controls.fontsize.fontsize": "Schriftgröße",
      "components.controls.history.history": "Historie",
      "components.controls.history.undo": "Zurücknehmen",
      "components.controls.history.redo": "Wiederholen",
      "components.controls.image.image": "Bild",
      "components.controls.image.fileUpload": "Datei-Upload",
      "components.controls.image.byURL": "URL",
      "components.controls.image.dropFileText": "Dateien ziehen und ablegen, oder klicken zum Hochladen",
      "components.controls.inline.bold": "Fett",
      "components.controls.inline.italic": "Kursiv",
      "components.controls.inline.underline": "Unterstreichen",
      "components.controls.inline.strikethrough": "Durchstreichen",
      "components.controls.inline.monospace": "Monospace",
      "components.controls.inline.superscript": "Hochgestellt",
      "components.controls.inline.subscript": "Tiefgestellt",
      "components.controls.link.linkTitle": "Link-Titel",
      "components.controls.link.linkTarget": "Link-Ziel",
      "components.controls.link.linkTargetOption": "Link in neuem Fenster öffnen",
      "components.controls.link.link": "Link",
      "components.controls.link.unlink": "Aufheben",
      "components.controls.list.list": "Liste",
      "components.controls.list.unordered": "Aufzählung",
      "components.controls.list.ordered": "Nummerierte Liste",
      "components.controls.list.indent": "Einzug vergrößern",
      "components.controls.list.outdent": "Einzug reduzieren",
      "components.controls.remove.remove": "Entfernen",
      "components.controls.textalign.textalign": "Textausrichtung",
      "components.controls.textalign.left": "Linksbündig",
      "components.controls.textalign.center": "Zentrieren",
      "components.controls.textalign.right": "Rechtsbündig",
      "components.controls.textalign.justify": "Blocksatz"
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = {
      "generic.add": "Tilføj",
      "generic.cancel": "Annuller",
      "components.controls.blocktype.h1": "Overskrift 1",
      "components.controls.blocktype.h2": "Overskrift 2",
      "components.controls.blocktype.h3": "Overskrift 3",
      "components.controls.blocktype.h4": "Overskrift 4",
      "components.controls.blocktype.h5": "Overskrift 5",
      "components.controls.blocktype.h6": "Overskrift 6",
      "components.controls.blocktype.blockquote": "Blokcitat",
      "components.controls.blocktype.code": "Kode",
      "components.controls.blocktype.blocktype": "Blok Type",
      "components.controls.blocktype.normal": "Normal",
      "components.controls.colorpicker.colorpicker": "Farver",
      "components.controls.colorpicker.text": "Tekst",
      "components.controls.colorpicker.background": "Baggrund",
      "components.controls.embedded.embedded": "Indlejre",
      "components.controls.embedded.embeddedlink": "Indlejre Link",
      "components.controls.embedded.enterlink": "Indtast link",
      "components.controls.emoji.emoji": "Emoji",
      "components.controls.fontfamily.fontfamily": "Fonttype",
      "components.controls.fontsize.fontsize": "Fontstørrelser",
      "components.controls.history.history": "Historie",
      "components.controls.history.undo": "Fortryd",
      "components.controls.history.redo": "Gendan",
      "components.controls.image.image": "Billede",
      "components.controls.image.fileUpload": "Filoverførsel",
      "components.controls.image.byURL": "URL",
      "components.controls.image.dropFileText": "Drop filen eller klik for at uploade",
      "components.controls.inline.bold": "Fed",
      "components.controls.inline.italic": "Kursiv",
      "components.controls.inline.underline": "Understrege",
      "components.controls.inline.strikethrough": "Gennemstreget",
      "components.controls.inline.monospace": "Monospace",
      "components.controls.inline.superscript": "Hævet",
      "components.controls.inline.subscript": "Sænket",
      "components.controls.link.linkTitle": "Link Titel",
      "components.controls.link.linkTarget": "Link Mål",
      "components.controls.link.linkTargetOption": "Åbn link i nyt vindue",
      "components.controls.link.link": "Link",
      "components.controls.link.unlink": "Fjern link",
      "components.controls.list.list": "Liste",
      "components.controls.list.unordered": "Uordnet",
      "components.controls.list.ordered": "Ordnet",
      "components.controls.list.indent": "Indrykning",
      "components.controls.list.outdent": "Udrykning",
      "components.controls.remove.remove": "Fjern",
      "components.controls.textalign.textalign": "Tekstjustering",
      "components.controls.textalign.left": "Venstre",
      "components.controls.textalign.center": "Center",
      "components.controls.textalign.right": "Højre",
      "components.controls.textalign.justify": "Margener"
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = {
      "generic.add": "新增",
      "generic.cancel": "取消",
      "components.controls.blocktype.h1": "標題1",
      "components.controls.blocktype.h2": "標題2",
      "components.controls.blocktype.h3": "標題3",
      "components.controls.blocktype.h4": "標題4",
      "components.controls.blocktype.h5": "標題5",
      "components.controls.blocktype.h6": "標題6",
      "components.controls.blocktype.blockquote": "引用",
      "components.controls.blocktype.code": "程式碼",
      "components.controls.blocktype.blocktype": "樣式",
      "components.controls.blocktype.normal": "正文",
      "components.controls.colorpicker.colorpicker": "選色器",
      "components.controls.colorpicker.text": "文字",
      "components.controls.colorpicker.background": "背景",
      "components.controls.embedded.embedded": "內嵌",
      "components.controls.embedded.embeddedlink": "內嵌網頁",
      "components.controls.embedded.enterlink": "輸入網頁地址",
      "components.controls.emoji.emoji": "表情符號",
      "components.controls.fontfamily.fontfamily": "字體",
      "components.controls.fontsize.fontsize": "字體大小",
      "components.controls.history.history": "歷史紀錄",
      "components.controls.history.undo": "復原",
      "components.controls.history.redo": "重做",
      "components.controls.image.image": "圖片",
      "components.controls.image.fileUpload": "檔案上傳",
      "components.controls.image.byURL": "網址",
      "components.controls.image.dropFileText": "點擊或拖曳檔案上傳",
      "components.controls.inline.bold": "粗體",
      "components.controls.inline.italic": "斜體",
      "components.controls.inline.underline": "底線",
      "components.controls.inline.strikethrough": "刪除線",
      "components.controls.inline.monospace": "等寬字體",
      "components.controls.inline.superscript": "上標",
      "components.controls.inline.subscript": "下標",
      "components.controls.link.linkTitle": "超連結",
      "components.controls.link.linkTarget": "輸入連結位址",
      "components.controls.link.linkTargetOption": "在新視窗打開連結",
      "components.controls.link.link": "連結",
      "components.controls.link.unlink": "刪除連結",
      "components.controls.list.list": "列表",
      "components.controls.list.unordered": "項目符號",
      "components.controls.list.ordered": "編號",
      "components.controls.list.indent": "增加縮排",
      "components.controls.list.outdent": "減少縮排",
      "components.controls.remove.remove": "清除格式",
      "components.controls.textalign.textalign": "文字對齊",
      "components.controls.textalign.left": "文字向左對齊",
      "components.controls.textalign.center": "文字置中",
      "components.controls.textalign.right": "文字向右對齊",
      "components.controls.textalign.justify": "兩端對齊"
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = {
      "generic.add": "Dodaj",
      "generic.cancel": "Anuluj",
      "components.controls.blocktype.h1": "Nagłówek 1",
      "components.controls.blocktype.h2": "Nagłówek 2",
      "components.controls.blocktype.h3": "Nagłówek 3",
      "components.controls.blocktype.h4": "Nagłówek 4",
      "components.controls.blocktype.h5": "Nagłówek 5",
      "components.controls.blocktype.h6": "Nagłówek 6",
      "components.controls.blocktype.blockquote": "Cytat",
      "components.controls.blocktype.code": "Kod",
      "components.controls.blocktype.blocktype": "Format",
      "components.controls.blocktype.normal": "Normalny",
      "components.controls.colorpicker.colorpicker": "Kolor",
      "components.controls.colorpicker.text": "Tekst",
      "components.controls.colorpicker.background": "Tło",
      "components.controls.embedded.embedded": "Osadź",
      "components.controls.embedded.embeddedlink": "Osadź odnośnik",
      "components.controls.embedded.enterlink": "Wprowadź odnośnik",
      "components.controls.emoji.emoji": "Emoji",
      "components.controls.fontfamily.fontfamily": "Krój czcionki",
      "components.controls.fontsize.fontsize": "Rozmiar czcionki",
      "components.controls.history.history": "Historia",
      "components.controls.history.undo": "Cofnij",
      "components.controls.history.redo": "Ponów",
      "components.controls.image.image": "Obrazek",
      "components.controls.image.fileUpload": "Prześlij plik",
      "components.controls.image.byURL": "URL",
      "components.controls.image.dropFileText": "Upuść plik lub kliknij, aby przesłać",
      "components.controls.inline.bold": "Pogrubienie",
      "components.controls.inline.italic": "Kursywa",
      "components.controls.inline.underline": "Podkreślenie",
      "components.controls.inline.strikethrough": "Przekreślenie",
      "components.controls.inline.monospace": "Monospace",
      "components.controls.inline.superscript": "Indeks górny",
      "components.controls.inline.subscript": "Indeks dolny",
      "components.controls.link.linkTitle": "Tytuł odnośnika",
      "components.controls.link.linkTarget": "Adres odnośnika",
      "components.controls.link.linkTargetOption": "Otwórz odnośnik w nowej karcie",
      "components.controls.link.link": "Wstaw odnośnik",
      "components.controls.link.unlink": "Usuń odnośnik",
      "components.controls.list.list": "Lista",
      "components.controls.list.unordered": "Lista nieuporządkowana",
      "components.controls.list.ordered": "Lista uporządkowana",
      "components.controls.list.indent": "Zwiększ wcięcie",
      "components.controls.list.outdent": "Zmniejsz wcięcie",
      "components.controls.remove.remove": "Usuń",
      "components.controls.textalign.textalign": "Wyrównaj tekst",
      "components.controls.textalign.left": "Do lewej",
      "components.controls.textalign.center": "Do środka",
      "components.controls.textalign.right": "Do prawej",
      "components.controls.textalign.justify": "Wyjustuj"
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = {
      "generic.add": "Añadir",
      "generic.cancel": "Cancelar",
      "components.controls.blocktype.h1": "H1",
      "components.controls.blocktype.h2": "H2",
      "components.controls.blocktype.h3": "H3",
      "components.controls.blocktype.h4": "H4",
      "components.controls.blocktype.h5": "H5",
      "components.controls.blocktype.h6": "H6",
      "components.controls.blocktype.blockquote": "Blockquote",
      "components.controls.blocktype.code": "Código",
      "components.controls.blocktype.blocktype": "Tipo de bloque",
      "components.controls.blocktype.normal": "Normal",
      "components.controls.colorpicker.colorpicker": "Seleccionar color",
      "components.controls.colorpicker.text": "Texto",
      "components.controls.colorpicker.background": "Subrayado",
      "components.controls.embedded.embedded": "Adjuntar",
      "components.controls.embedded.embeddedlink": "Adjuntar Link",
      "components.controls.embedded.enterlink": "Introducir link",
      "components.controls.emoji.emoji": "Emoji",
      "components.controls.fontfamily.fontfamily": "Fuente",
      "components.controls.fontsize.fontsize": "Tamaño de fuente",
      "components.controls.history.history": "Histórico",
      "components.controls.history.undo": "Deshacer",
      "components.controls.history.redo": "Rehacer",
      "components.controls.image.image": "Imagen",
      "components.controls.image.fileUpload": "Subir archivo",
      "components.controls.image.byURL": "URL",
      "components.controls.image.dropFileText": "Arrastra el archivo o haz click para subirlo",
      "components.controls.inline.bold": "Negrita",
      "components.controls.inline.italic": "Cursiva",
      "components.controls.inline.underline": "Subrayado",
      "components.controls.inline.strikethrough": "Tachado",
      "components.controls.inline.monospace": "Monospace",
      "components.controls.inline.superscript": "Sobreíndice",
      "components.controls.inline.subscript": "Subíndice",
      "components.controls.link.linkTitle": "Título del enlace",
      "components.controls.link.linkTarget": "Objetivo del enlace",
      "components.controls.link.linkTargetOption": "Abrir en nueva ventana",
      "components.controls.link.link": "Enlazar",
      "components.controls.link.unlink": "Desenlazar",
      "components.controls.list.list": "Lista",
      "components.controls.list.unordered": "Desordenada",
      "components.controls.list.ordered": "Ordenada",
      "components.controls.list.indent": "Indentada",
      "components.controls.list.outdent": "Dentada",
      "components.controls.remove.remove": "Eliminar",
      "components.controls.textalign.textalign": "Alineación del texto",
      "components.controls.textalign.left": "Izquierda",
      "components.controls.textalign.center": "Centrado",
      "components.controls.textalign.right": "Derecha",
      "components.controls.textalign.justify": "Justificado"
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = {
      "generic.add": "追加",
      "generic.cancel": "キャンセル",
      "components.controls.blocktype.h1": "見出し1",
      "components.controls.blocktype.h2": "見出し2",
      "components.controls.blocktype.h3": "見出し3",
      "components.controls.blocktype.h4": "見出し4",
      "components.controls.blocktype.h5": "見出し5",
      "components.controls.blocktype.h6": "見出し6",
      "components.controls.blocktype.blockquote": "引用",
      "components.controls.blocktype.code": "コード",
      "components.controls.blocktype.blocktype": "スタイル",
      "components.controls.blocktype.normal": "標準テキスト",
      "components.controls.colorpicker.colorpicker": "テキストの色",
      "components.controls.colorpicker.text": "テキスト",
      "components.controls.colorpicker.background": "ハイライト",
      "components.controls.embedded.embedded": "埋め込み",
      "components.controls.embedded.embeddedlink": "埋め込みリンク",
      "components.controls.embedded.enterlink": "リンクを入力してください",
      "components.controls.emoji.emoji": "絵文字",
      "components.controls.fontfamily.fontfamily": "フォント",
      "components.controls.fontsize.fontsize": "フォントサイズ",
      "components.controls.history.history": "履歴",
      "components.controls.history.undo": "元に戻す",
      "components.controls.history.redo": "やり直し",
      "components.controls.image.image": "画像",
      "components.controls.image.fileUpload": "ファイルをアップロード",
      "components.controls.image.byURL": "URL",
      "components.controls.image.dropFileText": "ここに画像をドラッグするか、クリックしてください",
      "components.controls.inline.bold": "太字",
      "components.controls.inline.italic": "斜体",
      "components.controls.inline.underline": "下線",
      "components.controls.inline.strikethrough": "取り消し線",
      "components.controls.inline.monospace": "等幅フォント",
      "components.controls.inline.superscript": "上付き文字",
      "components.controls.inline.subscript": "下付き文字",
      "components.controls.link.linkTitle": "リンクタイトル",
      "components.controls.link.linkTarget": "リンク対象",
      "components.controls.link.linkTargetOption": "新しいウィンドウで開く",
      "components.controls.link.link": "リンク",
      "components.controls.link.unlink": "リンクを解除",
      "components.controls.list.list": "リスト",
      "components.controls.list.unordered": "箇条書き",
      "components.controls.list.ordered": "番号付き",
      "components.controls.list.indent": "インデント増",
      "components.controls.list.outdent": "インデント減",
      "components.controls.remove.remove": "書式をクリア",
      "components.controls.textalign.textalign": "整列",
      "components.controls.textalign.left": "左揃え",
      "components.controls.textalign.center": "中央揃え",
      "components.controls.textalign.right": "右揃え",
      "components.controls.textalign.justify": "両端揃え"
    };
  }, function (e, t) {
    e.exports = {
      "rdw-editor-main": "rdw-editor-main",
      "rdw-editor-toolbar": "rdw-editor-toolbar",
      "public-DraftStyleDefault-block": "public-DraftStyleDefault-block",
      "rdw-editor-wrapper": "rdw-editor-wrapper"
    };
  }, function (e, t) {
    e.exports = {
      "DraftEditor-editorContainer": "DraftEditor-editorContainer",
      "DraftEditor-root": "DraftEditor-root",
      "public-DraftEditor-content": "public-DraftEditor-content",
      "public-DraftEditor-block": "public-DraftEditor-block",
      "DraftEditor-alignLeft": "DraftEditor-alignLeft",
      "public-DraftStyleDefault-block": "public-DraftStyleDefault-block",
      "public-DraftEditorPlaceholder-root": "public-DraftEditorPlaceholder-root",
      "DraftEditor-alignCenter": "DraftEditor-alignCenter",
      "DraftEditor-alignRight": "DraftEditor-alignRight",
      "public-DraftEditorPlaceholder-hasFocus": "public-DraftEditorPlaceholder-hasFocus",
      "DraftEditorPlaceholder-hidden": "DraftEditorPlaceholder-hidden",
      "public-DraftStyleDefault-ltr": "public-DraftStyleDefault-ltr",
      "public-DraftStyleDefault-rtl": "public-DraftStyleDefault-rtl",
      "public-DraftStyleDefault-listLTR": "public-DraftStyleDefault-listLTR",
      "public-DraftStyleDefault-listRTL": "public-DraftStyleDefault-listRTL",
      "public-DraftStyleDefault-ol": "public-DraftStyleDefault-ol",
      "public-DraftStyleDefault-ul": "public-DraftStyleDefault-ul",
      "public-DraftStyleDefault-depth0": "public-DraftStyleDefault-depth0",
      "public-DraftStyleDefault-depth1": "public-DraftStyleDefault-depth1",
      "public-DraftStyleDefault-depth2": "public-DraftStyleDefault-depth2",
      "public-DraftStyleDefault-depth3": "public-DraftStyleDefault-depth3",
      "public-DraftStyleDefault-depth4": "public-DraftStyleDefault-depth4",
      "public-DraftStyleDefault-unorderedListItem": "public-DraftStyleDefault-unorderedListItem",
      "public-DraftStyleDefault-orderedListItem": "public-DraftStyleDefault-orderedListItem",
      "public-DraftStyleDefault-reset": "public-DraftStyleDefault-reset"
    };
  }]);
});